import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { 
  Search, 
  ChevronLeft, 
  ChevronRight, 
  Plus,
  Calendar,
  Clock,
  Filter,
  Users,
  User,
  MoreHorizontal,
  Image as ImageIcon,
  Video,
  FileText,
  Heart,
  MessageCircle,
  Share2,
  Bookmark,
  TrendingUp,
  Rss,
  Newspaper,
  BarChart3,
  Grid,
  List,
  RefreshCw,
  Download,
  ChevronDown,
  Info,
  Eye,
  MousePointer,
  Hash,
  X,
  Maximize2,
  Minimize2,
  MapPin,
  AtSign,
  Pencil,
  Trash2,
  Hourglass,
  Sparkles,
  Bold,
  Italic,
  Smile,
  Link2,
  ExternalLink,
  AlertCircle,
  CheckCircle,
  Loader2,
  Upload,
  Send,
  Settings,
  Play,
  Edit3,
  GripVertical,
  Move
} from 'lucide-react';
import { toast } from 'sonner';

// Use window.location.origin for runtime URL resolution
const API_URL = typeof window !== 'undefined' ? window.location.origin : '';

// Social Media Platform Icons (SVG components)
const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const XTwitterIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const ThreadsIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.182.408-2.256 1.333-3.022.812-.672 1.927-1.073 3.222-1.153 1.009-.063 1.949.025 2.812.258-.082-.645-.263-1.196-.546-1.645-.447-.71-1.18-1.108-2.18-1.18l-.027-.002c-.663 0-1.717.187-2.455 1.082l-1.548-1.248c.673-.833 1.657-1.39 2.654-1.587.206-.04.422-.066.65-.08h.183c1.637 0 2.97.584 3.858 1.69.636.79 1.018 1.79 1.14 2.97l.016.174c.898.282 1.7.718 2.369 1.3 1.263 1.097 1.962 2.634 1.962 4.323 0 1.092-.26 2.103-.77 3.003-.51.9-1.26 1.67-2.225 2.29-1.678 1.077-3.883 1.623-6.554 1.623zm1.456-6.516c.984-.055 1.735-.38 2.232-.97.465-.55.737-1.315.813-2.28-.648-.158-1.366-.227-2.142-.207-1.016.027-1.848.262-2.405.68-.502.377-.752.876-.722 1.442.032.601.347 1.065.887 1.306.426.19.938.278 1.525.278l-.188-.249z"/>
  </svg>
);

const PinterestIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/>
  </svg>
);

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const MediumIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"/>
  </svg>
);

const SnapchatIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301a.601.601 0 01.255-.06c.135 0 .27.03.406.091.51.227.54.617.449.827-.11.254-.341.465-.715.555a2.4 2.4 0 01-.18.044 3.3 3.3 0 00-.18.044c-.359.09-.629.195-.839.37-.283.233-.377.56-.377.883 0 .135.015.27.044.405.12.53.436 1.215 1.392 2.1 1.02.944 2.22 1.333 2.22 2.03 0 .465-.329.87-1.173 1.17a8.85 8.85 0 01-.82.243c-.14.03-.274.06-.404.09a1.95 1.95 0 00-.645.24c-.06.045-.12.09-.165.135-.09.09-.255.285-.39.584-.12.27-.255.659-.329 1.169a.601.601 0 01-.6.516c-.015 0-.03 0-.044-.003h-.014c-.21-.015-.449-.044-.704-.104a7.87 7.87 0 01-.899-.27 6.97 6.97 0 00-1.244-.314 5.17 5.17 0 00-.72-.044c-.27 0-.495.03-.69.074-.344.074-.613.194-.838.329-.209.12-.375.254-.51.4-.09.095-.195.224-.3.39-.195.3-.495.659-.988.959-.51.314-1.169.481-1.952.526h-.18c-.78-.045-1.44-.212-1.95-.526-.494-.3-.794-.659-.99-.959a3.14 3.14 0 00-.299-.39c-.135-.146-.3-.28-.51-.4-.225-.135-.494-.255-.839-.329a3.47 3.47 0 00-.689-.074c-.27 0-.54.03-.81.074-.27.045-.524.12-.765.195-.27.09-.54.165-.809.225a5.9 5.9 0 01-.69.09c-.015 0-.03.003-.044.003a.601.601 0 01-.6-.516c-.075-.51-.21-.899-.33-1.169-.134-.299-.299-.494-.389-.584a1.84 1.84 0 00-.165-.135c-.18-.12-.39-.195-.645-.24-.135-.03-.27-.06-.405-.09a8.85 8.85 0 01-.819-.243c-.845-.3-1.174-.705-1.174-1.17 0-.697 1.2-1.086 2.22-2.03.956-.885 1.272-1.57 1.392-2.1.03-.135.044-.27.044-.405 0-.323-.094-.65-.377-.883-.21-.175-.48-.28-.84-.37a3.3 3.3 0 00-.179-.044 2.4 2.4 0 01-.18-.044c-.374-.09-.604-.301-.714-.555-.091-.21-.06-.6.45-.827a.765.765 0 01.405-.091c.09 0 .18.015.256.06.374.181.733.286 1.034.301.198 0 .325-.045.4-.09-.007-.165-.018-.33-.03-.51l-.003-.06c-.104-1.628-.23-3.654.299-4.847 1.584-3.545 4.94-3.821 5.931-3.821h.003z"/>
  </svg>
);

const BlueskyIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 01-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8z"/>
  </svg>
);

const SocialMedia = () => {
  // Main tab state
  const [activeTab, setActiveTab] = useState('posts');
  
  // Posts tab state
  const [selectedPlatforms, setSelectedPlatforms] = useState(['all']);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('weekly');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [currentWeekStart, setCurrentWeekStart] = useState(new Date());

  // Explore tab state
  const [exploreSubTab, setExploreSubTab] = useState('trending');
  const [exploreSort, setExploreSort] = useState('top');
  const [exploreCategory, setExploreCategory] = useState('all');
  const [explorePlatform, setExplorePlatform] = useState('all');
  const [exploreSearch, setExploreSearch] = useState('');

  // Media tab state
  const [mediaSearch, setMediaSearch] = useState('');
  const [mediaTypeFilter, setMediaTypeFilter] = useState('all');
  const [mediaUsageFilter, setMediaUsageFilter] = useState('all');
  const [mediaCategory, setMediaCategory] = useState('all');
  const [selectedMedia, setSelectedMedia] = useState([]);
  const [mediaViewMode, setMediaViewMode] = useState('grid');
  
  // Media library state (real data from API)
  const [mediaItems, setMediaItems] = useState([]);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [showMediaUploadModal, setShowMediaUploadModal] = useState(false);
  const [uploadingMedia, setUploadingMedia] = useState(false);
  const [mediaUploadFile, setMediaUploadFile] = useState(null);
  const [mediaUploadName, setMediaUploadName] = useState('');
  const [mediaUploadCategory, setMediaUploadCategory] = useState('uncategorized');
  const [deletingMedia, setDeletingMedia] = useState(false);
  
  // Media picker modal for post creation
  const [showMediaPickerModal, setShowMediaPickerModal] = useState(false);

  // Analytics tab state
  const [analyticsSubTab, setAnalyticsSubTab] = useState('overview');
  const [analyticsMember, setAnalyticsMember] = useState('all');
  const [analyticsDateRange, setAnalyticsDateRange] = useState('year');
  const [analyticsSource, setAnalyticsSource] = useState('instagram'); // 'instagram' or 'facebook'
  const [instagramAnalytics, setInstagramAnalytics] = useState(null);
  const [facebookAnalytics, setFacebookAnalytics] = useState(null);
  const [personalIgAnalytics, setPersonalIgAnalytics] = useState(null);
  const [personalIgAnalyticsLoading, setPersonalIgAnalyticsLoading] = useState(false);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);

  // Post modal state
  const [showPostModal, setShowPostModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [postModalMode, setPostModalMode] = useState('create'); // 'create' or 'edit'
  const [aiAssistLoading, setAiAssistLoading] = useState(false); // AI caption generation loading state
  const [newPost, setNewPost] = useState({
    platform: 'instagram',
    title: '',
    description: '',
    date: '',
    time: '09:00',
    category: 'real-estate',
    image: null,
    mediaType: null, // 'image' or 'video'
    hashtags: '',
    selectedPlatforms: ['instagram']
  });
  const [postEditorExpanded, setPostEditorExpanded] = useState(false);

  // Instagram tab state
  const [instagramStatus, setInstagramStatus] = useState(null);
  const [instagramLoading, setInstagramLoading] = useState(false);
  const [instagramPosts, setInstagramPosts] = useState([]);
  const [instagramPostsLoading, setInstagramPostsLoading] = useState(false);
  const [instagramNextPage, setInstagramNextPage] = useState(null);
  const [instagramLoadingMore, setInstagramLoadingMore] = useState(false);
  const [showInstagramComposeModal, setShowInstagramComposeModal] = useState(false);
  const [instagramComposeData, setInstagramComposeData] = useState({
    caption: '',
    imageUrl: '',
    videoUrl: '',
    mediaType: 'IMAGE'
  });
  const [instagramPublishing, setInstagramPublishing] = useState(false);
  const [instagramScheduledPosts, setInstagramScheduledPosts] = useState([]);
  const [selectedInstagramPost, setSelectedInstagramPost] = useState(null);

  // Facebook state
  const [facebookStatus, setFacebookStatus] = useState(null);
  const [facebookLoading, setFacebookLoading] = useState(false);
  const [facebookPosts, setFacebookPosts] = useState([]);
  const [facebookPostsLoading, setFacebookPostsLoading] = useState(false);
  const [facebookPublishing, setFacebookPublishing] = useState(false);

  // Upload-Post state (replaces Outstand)
  const [uploadPostStatus, setUploadPostStatus] = useState(null);
  const [uploadPostLoading, setUploadPostLoading] = useState(false);
  const [uploadPostAccounts, setUploadPostAccounts] = useState([]);
  const [uploadPostConnecting, setUploadPostConnecting] = useState(false);
  const [disconnectingAccount, setDisconnectingAccount] = useState(null); // Track account being disconnected
  const [showDisconnectModal, setShowDisconnectModal] = useState(false);
  const [accountToDisconnect, setAccountToDisconnect] = useState(null);

  // YouTube Analytics state (real analytics via YouTube Analytics API)
  const [youtubeAnalyticsStatus, setYoutubeAnalyticsStatus] = useState(null);
  const [youtubeAnalyticsLoading, setYoutubeAnalyticsLoading] = useState(false);
  const [youtubeAnalytics, setYoutubeAnalytics] = useState(null);
  const [youtubeChannelStats, setYoutubeChannelStats] = useState(null);
  const [youtubeTopVideos, setYoutubeTopVideos] = useState([]);
  const [youtubeDailyData, setYoutubeDailyData] = useState([]);

  // Layout tab state (content grid view)
  const [layoutPlatform, setLayoutPlatform] = useState(null); // null = auto-select first available
  const [youtubeVideos, setYoutubeVideos] = useState([]);
  const [youtubePlaylists, setYoutubePlaylists] = useState([]);
  const [youtubeVideosLoading, setYoutubeVideosLoading] = useState(false);
  const [youtubeLayoutSubTab, setYoutubeLayoutSubTab] = useState('videos');
  
  // Layout Preview Mode - for drag-and-drop grid preview
  const [layoutPreviewMode, setLayoutPreviewMode] = useState(false); // Show draft posts in grid preview
  const [layoutGridOrder, setLayoutGridOrder] = useState([]); // IDs in display order for drag-and-drop
  const [showDraftsInLayout, setShowDraftsInLayout] = useState(true); // Toggle to show/hide drafts in layout
  
  // X (Twitter) content state for Layout
  const [xPosts, setXPosts] = useState([]);
  const [xPostsLoading, setXPostsLoading] = useState(false);
  
  // Generic platform content state
  const [genericPlatformContent, setGenericPlatformContent] = useState({});
  const [genericContentLoading, setGenericContentLoading] = useState(false);

  // Fetch Instagram status on component mount
  useEffect(() => {
    // Always fetch social accounts status on mount
    fetchInstagramStatus();
    fetchFacebookStatus();
    fetchUploadPostStatus();
    fetchYoutubeAnalyticsStatus();
    fetchPosts(); // Fetch scheduled posts on mount
    fetchCategories(); // Fetch post categories on mount
  }, []);

  useEffect(() => {
    if (activeTab === 'accounts') {
      // Fetch all account statuses
      fetchInstagramStatus();
      fetchFacebookStatus();
      fetchUploadPostStatus();
    }
    if (activeTab === 'media') {
      fetchMediaAssets();
    }
    if (activeTab === 'posts') {
      // Refresh posts when switching to posts tab
      fetchPosts();
    }
    if (activeTab === 'layout') {
      // Fetch Instagram posts for Layout page if not already loaded
      if (instagramPosts.length === 0) {
        fetchInstagramStatus();
        fetchInstagramPosts();
      }
    }
    if (activeTab === 'analytics') {
      // Fetch Instagram data for analytics if not already loaded
      if (instagramPosts.length === 0) {
        fetchInstagramStatus();
        fetchInstagramPosts();
      }
    }
  }, [activeTab]);

  // Fetch media assets when media picker modal opens
  useEffect(() => {
    if (showMediaPickerModal) {
      fetchMediaAssets();
    }
  }, [showMediaPickerModal]);

  // Compute Instagram Analytics from posts
  useEffect(() => {
    if (instagramPosts.length > 0 && instagramStatus?.connected) {
      computeInstagramAnalytics();
    }
  }, [instagramPosts, analyticsDateRange, instagramStatus]);

  // Compute Facebook Analytics from posts
  useEffect(() => {
    if (facebookPosts.length > 0 && facebookStatus?.page?.connected) {
      computeFacebookAnalytics();
    }
  }, [facebookPosts, analyticsDateRange, facebookStatus]);

  const computeInstagramAnalytics = () => {
    setAnalyticsLoading(true);
    
    // Filter posts by date range
    const now = new Date();
    let daysBack = 30;
    if (analyticsDateRange === '7days') daysBack = 7;
    else if (analyticsDateRange === '90days') daysBack = 90;
    else if (analyticsDateRange === 'year') daysBack = 365;
    
    const cutoffDate = new Date(now.getTime() - (daysBack * 24 * 60 * 60 * 1000));
    
    const filteredPosts = instagramPosts.filter(post => {
      const postDate = new Date(post.timestamp);
      return postDate >= cutoffDate;
    });

    // Calculate metrics
    const totalLikes = filteredPosts.reduce((sum, post) => sum + (post.like_count || 0), 0);
    const totalComments = filteredPosts.reduce((sum, post) => sum + (post.comments_count || 0), 0);
    const totalEngagement = totalLikes + totalComments;
    const avgEngagement = filteredPosts.length > 0 ? Math.round(totalEngagement / filteredPosts.length) : 0;
    
    // Posts by type
    const imageCount = filteredPosts.filter(p => p.media_type === 'IMAGE').length;
    const videoCount = filteredPosts.filter(p => p.media_type === 'VIDEO').length;
    const carouselCount = filteredPosts.filter(p => p.media_type === 'CAROUSEL_ALBUM').length;
    
    // Top performing posts
    const topPosts = [...filteredPosts]
      .sort((a, b) => ((b.like_count || 0) + (b.comments_count || 0)) - ((a.like_count || 0) + (a.comments_count || 0)))
      .slice(0, 5);
    
    // Posts per day for chart
    const postsPerDay = {};
    filteredPosts.forEach(post => {
      const date = new Date(post.timestamp).toLocaleDateString();
      postsPerDay[date] = (postsPerDay[date] || 0) + 1;
    });
    
    // Engagement per day for chart
    const engagementPerDay = {};
    filteredPosts.forEach(post => {
      const date = new Date(post.timestamp).toLocaleDateString();
      engagementPerDay[date] = (engagementPerDay[date] || 0) + (post.like_count || 0) + (post.comments_count || 0);
    });

    // Generate chart data (last N days)
    const chartData = [];
    for (let i = daysBack - 1; i >= 0; i--) {
      const date = new Date(now.getTime() - (i * 24 * 60 * 60 * 1000));
      const dateStr = date.toLocaleDateString();
      chartData.push({
        date: dateStr,
        shortDate: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        posts: postsPerDay[dateStr] || 0,
        engagement: engagementPerDay[dateStr] || 0
      });
    }

    setInstagramAnalytics({
      totalPosts: filteredPosts.length,
      totalLikes,
      totalComments,
      totalEngagement,
      avgEngagement,
      imageCount,
      videoCount,
      carouselCount,
      topPosts,
      chartData,
      accountInfo: instagramStatus.account
    });
    
    setAnalyticsLoading(false);
  };

  const computeFacebookAnalytics = () => {
    // Filter posts by date range
    const now = new Date();
    let daysBack = 30;
    if (analyticsDateRange === '7days') daysBack = 7;
    else if (analyticsDateRange === '90days') daysBack = 90;
    else if (analyticsDateRange === 'year') daysBack = 365;
    
    const cutoffDate = new Date(now.getTime() - (daysBack * 24 * 60 * 60 * 1000));
    
    const filteredPosts = facebookPosts.filter(post => {
      const postDate = new Date(post.created_time);
      return postDate >= cutoffDate;
    });

    // Calculate metrics
    const totalLikes = filteredPosts.reduce((sum, post) => sum + (post.likes || 0), 0);
    const totalComments = filteredPosts.reduce((sum, post) => sum + (post.comments || 0), 0);
    const totalShares = filteredPosts.reduce((sum, post) => sum + (post.shares || 0), 0);
    const totalEngagement = totalLikes + totalComments + totalShares;
    const avgEngagement = filteredPosts.length > 0 ? Math.round(totalEngagement / filteredPosts.length) : 0;
    
    // Posts with/without images
    const postsWithImages = filteredPosts.filter(p => p.image_url).length;
    const textOnlyPosts = filteredPosts.length - postsWithImages;
    
    // Top performing posts
    const topPosts = [...filteredPosts]
      .sort((a, b) => ((b.likes || 0) + (b.comments || 0) + (b.shares || 0)) - ((a.likes || 0) + (a.comments || 0) + (a.shares || 0)))
      .slice(0, 5);
    
    // Engagement per day for chart
    const engagementPerDay = {};
    filteredPosts.forEach(post => {
      const date = new Date(post.created_time).toLocaleDateString();
      engagementPerDay[date] = (engagementPerDay[date] || 0) + (post.likes || 0) + (post.comments || 0) + (post.shares || 0);
    });

    // Generate chart data (last N days)
    const chartData = [];
    for (let i = daysBack - 1; i >= 0; i--) {
      const date = new Date(now.getTime() - (i * 24 * 60 * 60 * 1000));
      const dateStr = date.toLocaleDateString();
      chartData.push({
        date: dateStr,
        shortDate: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        engagement: engagementPerDay[dateStr] || 0
      });
    }

    setFacebookAnalytics({
      totalPosts: filteredPosts.length,
      totalLikes,
      totalComments,
      totalShares,
      totalEngagement,
      avgEngagement,
      postsWithImages,
      textOnlyPosts,
      topPosts,
      chartData,
      pageInfo: facebookStatus.page
    });
  };

  // Publish post to Facebook Page
  const publishToFacebook = async (message, imageUrl = null) => {
    setFacebookPublishing(true);
    try {
      const endpoint = imageUrl 
        ? `${API_URL}/api/facebook/publish/photo` 
        : `${API_URL}/api/facebook/publish/text`;
      
      const formData = new FormData();
      formData.append('message', message);
      if (imageUrl) {
        formData.append('photo_url', imageUrl);
      }

      const response = await fetch(endpoint, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (response.ok && data.success) {
        toast.success(data.message || 'Posted to Facebook!');
        fetchFacebookPosts();
        return true;
      } else {
        toast.error(data.detail || 'Failed to publish to Facebook');
        return false;
      }
    } catch (error) {
      console.error('Facebook publish error:', error);
      toast.error('Failed to publish to Facebook');
      return false;
    } finally {
      setFacebookPublishing(false);
    }
  };

  // Media Library API Functions
  const fetchMediaAssets = async () => {
    setMediaLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/social-media-assets/assets`);
      if (response.ok) {
        const data = await response.json();
        setMediaItems(data.assets || []);
      }
    } catch (error) {
      console.error('Failed to fetch media assets:', error);
    } finally {
      setMediaLoading(false);
    }
  };

  // Facebook API Functions
  const fetchFacebookStatus = async () => {
    setFacebookLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/facebook/status`);
      const data = await response.json();
      setFacebookStatus(data);
    } catch (error) {
      console.error('Failed to fetch Facebook status:', error);
      setFacebookStatus({ connected: false, error: error.message });
    } finally {
      setFacebookLoading(false);
    }
  };

  const fetchFacebookPosts = async () => {
    setFacebookPostsLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/facebook/posts?limit=25`);
      if (response.ok) {
        const data = await response.json();
        setFacebookPosts(data.data || []);
      }
    } catch (error) {
      console.error('Failed to fetch Facebook posts:', error);
    } finally {
      setFacebookPostsLoading(false);
    }
  };

  // Upload-Post API Functions (replaces Outstand)
  const fetchUploadPostStatus = async () => {
    setUploadPostLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/upload-post/status`);
      const data = await response.json();
      setUploadPostStatus(data);
      
      // Set connected accounts from the response
      if (data.accounts) {
        setUploadPostAccounts(data.accounts);
      }
    } catch (error) {
      console.error('Failed to fetch Upload-Post status:', error);
      setUploadPostStatus({ connected: false, error: error.message });
    } finally {
      setUploadPostLoading(false);
    }
  };

  const openUploadPostConnect = async (platform = null) => {
    setUploadPostConnecting(true);
    try {
      const url = platform 
        ? `${API_URL}/api/upload-post/connect-url?platforms=${platform}`
        : `${API_URL}/api/upload-post/connect-url`;
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.success && data.access_url) {
        // Open Upload-Post connection page in new window
        window.open(data.access_url, '_blank', 'width=600,height=700');
        toast.success('Connection page opened! After connecting, click Refresh to update.');
      } else {
        toast.error(data.detail || 'Failed to generate connection URL');
      }
    } catch (error) {
      console.error('Failed to open Upload-Post connect:', error);
      toast.error('Failed to open connection page');
    } finally {
      setUploadPostConnecting(false);
    }
  };

  // Open disconnect confirmation modal
  const openDisconnectModal = (account, source = 'upload-post') => {
    setAccountToDisconnect({ ...account, source });
    setShowDisconnectModal(true);
  };

  // Handle account disconnect
  const handleDisconnectAccount = async () => {
    if (!accountToDisconnect) return;
    
    setDisconnectingAccount(accountToDisconnect);
    
    try {
      if (accountToDisconnect.source === 'instagram-business') {
        // For Instagram Business API - disconnect locally
        // In a real app, you'd call an API to revoke tokens
        toast.info('To fully disconnect, revoke access in your Instagram settings');
        // Clear local Instagram status
        setInstagramStatus({ connected: false });
      } else if (accountToDisconnect.source === 'youtube-analytics') {
        // For YouTube Analytics API - disconnect
        const response = await fetch(`${API_URL}/api/youtube-analytics/disconnect?user_id=dwoodson`, {
          method: 'POST'
        });
        if (response.ok) {
          setYoutubeAnalyticsStatus({ connected: false });
          toast.success('YouTube Analytics disconnected');
        } else {
          toast.error('Failed to disconnect YouTube Analytics');
        }
      } else {
        // For Upload-Post accounts - open their dashboard to manage
        toast.info('Opening Upload-Post dashboard to manage your accounts...');
        window.open('https://upload-post.com/dashboard', '_blank');
        // Remove from local state for UI feedback
        setUploadPostAccounts(prev => 
          prev.filter(acc => 
            !(acc.platform === accountToDisconnect.platform && 
              acc.username === accountToDisconnect.username)
          )
        );
        toast.success(`${accountToDisconnect.platform} account removed. Manage connections in Upload-Post dashboard.`);
      }
    } catch (error) {
      console.error('Failed to disconnect account:', error);
      toast.error('Failed to disconnect account');
    } finally {
      setDisconnectingAccount(null);
      setShowDisconnectModal(false);
      setAccountToDisconnect(null);
    }
  };

  // YouTube Analytics API Functions
  const fetchYoutubeAnalyticsStatus = async () => {
    setYoutubeAnalyticsLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/youtube-analytics/status?user_id=dwoodson`);
      const data = await response.json();
      setYoutubeAnalyticsStatus(data);
      
      // If connected, also fetch channel stats
      if (data.connected && data.channel) {
        setYoutubeChannelStats(data.channel);
      }
    } catch (error) {
      console.error('Failed to fetch YouTube Analytics status:', error);
      setYoutubeAnalyticsStatus({ connected: false, error: error.message });
    } finally {
      setYoutubeAnalyticsLoading(false);
    }
  };

  // Personal Instagram Analytics (via Upload-Post)
  const fetchPersonalIgAnalytics = async () => {
    setPersonalIgAnalyticsLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/upload-post/analytics/instagram`);
      const data = await response.json();
      
      if (data.success) {
        setPersonalIgAnalytics(data);
      } else {
        console.error('Failed to fetch personal IG analytics:', data.error);
        setPersonalIgAnalytics(null);
      }
    } catch (error) {
      console.error('Failed to fetch personal Instagram analytics:', error);
      setPersonalIgAnalytics(null);
    } finally {
      setPersonalIgAnalyticsLoading(false);
    }
  };

  // Fetch personal IG analytics when switching to that tab
  useEffect(() => {
    if (analyticsSource.startsWith('instagram-personal') && !personalIgAnalytics && !personalIgAnalyticsLoading) {
      fetchPersonalIgAnalytics();
    }
  }, [analyticsSource]);

  const connectYoutubeAnalytics = async () => {
    try {
      const response = await fetch(`${API_URL}/api/youtube-analytics/auth/connect?user_id=dwoodson`);
      const data = await response.json();
      
      if (data.auth_url) {
        // Open Google OAuth in new window
        window.open(data.auth_url, '_blank', 'width=600,height=700');
        toast.success('Authorization page opened. After connecting, click Refresh to update.');
      } else {
        toast.error('Failed to generate authorization URL');
      }
    } catch (error) {
      console.error('Failed to initiate YouTube Analytics connection:', error);
      toast.error('Failed to connect YouTube Analytics');
    }
  };

  const fetchYoutubeAnalyticsData = async () => {
    if (!youtubeAnalyticsStatus?.connected) return;
    
    setYoutubeAnalyticsLoading(true);
    try {
      // Determine date range based on analyticsDateRange
      let days = 28;
      if (analyticsDateRange === '7days') days = 7;
      else if (analyticsDateRange === '90days') days = 90;
      else if (analyticsDateRange === 'year') days = 365;
      
      const endDate = new Date().toISOString().split('T')[0];
      const startDate = new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      
      // Fetch main analytics
      const analyticsResponse = await fetch(
        `${API_URL}/api/youtube-analytics/analytics?user_id=dwoodson&start_date=${startDate}&end_date=${endDate}`
      );
      if (analyticsResponse.ok) {
        const data = await analyticsResponse.json();
        setYoutubeAnalytics(data);
      }
      
      // Fetch top videos
      const topVideosResponse = await fetch(
        `${API_URL}/api/youtube-analytics/analytics/top-videos?user_id=dwoodson&start_date=${startDate}&end_date=${endDate}&max_results=5`
      );
      if (topVideosResponse.ok) {
        const data = await topVideosResponse.json();
        setYoutubeTopVideos(data.videos || []);
      }
      
      // Fetch daily data for charts
      const dailyResponse = await fetch(
        `${API_URL}/api/youtube-analytics/analytics/daily?user_id=dwoodson&start_date=${startDate}&end_date=${endDate}`
      );
      if (dailyResponse.ok) {
        const data = await dailyResponse.json();
        setYoutubeDailyData(data.daily_data || []);
      }
      
    } catch (error) {
      console.error('Failed to fetch YouTube Analytics data:', error);
    } finally {
      setYoutubeAnalyticsLoading(false);
    }
  };

  // Handle YouTube Analytics OAuth callback
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('youtube_connected') === 'true') {
      toast.success('YouTube Analytics connected successfully!');
      fetchYoutubeAnalyticsStatus();
      // Clean up URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  // Fetch YouTube Analytics when source changes to youtube and is connected
  useEffect(() => {
    if (analyticsSource === 'youtube' && youtubeAnalyticsStatus?.connected) {
      fetchYoutubeAnalyticsData();
    }
  }, [analyticsSource, analyticsDateRange, youtubeAnalyticsStatus?.connected]);

  // Fetch YouTube videos and playlists for Layout tab
  const fetchYoutubeVideos = async () => {
    if (!youtubeAnalyticsStatus?.connected) return;
    
    setYoutubeVideosLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/youtube-analytics/channel/videos?user_id=dwoodson&max_results=50`);
      if (response.ok) {
        const data = await response.json();
        setYoutubeVideos(data.videos || []);
      }
    } catch (error) {
      console.error('Failed to fetch YouTube videos:', error);
    }
    
    // Fetch playlists
    try {
      const response = await fetch(`${API_URL}/api/youtube-analytics/channel/playlists?user_id=dwoodson`);
      if (response.ok) {
        const data = await response.json();
        setYoutubePlaylists(data.playlists || []);
      }
    } catch (error) {
      console.error('Failed to fetch YouTube playlists:', error);
    }
    
    setYoutubeVideosLoading(false);
  };

  // Fetch YouTube videos when Layout tab is selected and YouTube is chosen
  useEffect(() => {
    if (activeTab === 'layout' && layoutPlatform === 'youtube' && youtubeAnalyticsStatus?.connected) {
      fetchYoutubeVideos();
    }
  }, [activeTab, layoutPlatform, youtubeAnalyticsStatus?.connected]);

  const handleMediaUpload = async () => {
    if (!mediaUploadFile) {
      toast.error('Please select a file to upload');
      return;
    }

    setUploadingMedia(true);
    try {
      const formData = new FormData();
      formData.append('file', mediaUploadFile);
      formData.append('name', mediaUploadName || mediaUploadFile.name.split('.')[0]);
      formData.append('category', mediaUploadCategory);

      const response = await fetch(`${API_URL}/api/social-media-assets/upload`, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        const data = await response.json();
        toast.success('Media uploaded successfully!');
        setShowMediaUploadModal(false);
        setMediaUploadFile(null);
        setMediaUploadName('');
        setMediaUploadCategory('uncategorized');
        fetchMediaAssets();
      } else {
        const error = await response.json();
        toast.error(error.detail || 'Failed to upload media');
      }
    } catch (error) {
      console.error('Upload error:', error);
      toast.error('Failed to upload media');
    } finally {
      setUploadingMedia(false);
    }
  };

  const handleDeleteMedia = async (mediaId) => {
    try {
      const response = await fetch(`${API_URL}/api/social-media-assets/assets/${mediaId}`, {
        method: 'DELETE'
      });

      if (response.ok) {
        toast.success('Media deleted');
        setMediaItems(prev => prev.filter(item => item.id !== mediaId));
        setSelectedMedia(prev => prev.filter(id => id !== mediaId));
      }
    } catch (error) {
      toast.error('Failed to delete media');
    }
  };

  const handleDeleteSelectedMedia = async () => {
    if (selectedMedia.length === 0) return;
    
    setDeletingMedia(true);
    try {
      const response = await fetch(`${API_URL}/api/social-media-assets/assets`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(selectedMedia)
      });

      if (response.ok) {
        const data = await response.json();
        toast.success(`Deleted ${data.deleted_count} items`);
        fetchMediaAssets();
        setSelectedMedia([]);
      }
    } catch (error) {
      toast.error('Failed to delete selected media');
    } finally {
      setDeletingMedia(false);
    }
  };

  const handleToggleFavorite = async (mediaId) => {
    try {
      const response = await fetch(`${API_URL}/api/social-media-assets/assets/${mediaId}/favorite`, {
        method: 'PUT'
      });

      if (response.ok) {
        const data = await response.json();
        setMediaItems(prev => prev.map(item => 
          item.id === mediaId ? { ...item, favorite: data.favorite } : item
        ));
      }
    } catch (error) {
      toast.error('Failed to update favorite');
    }
  };

  // Instagram API Functions
  const fetchInstagramStatus = async () => {
    setInstagramLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/instagram/status`);
      const data = await response.json();
      setInstagramStatus(data);
    } catch (error) {
      console.error('Failed to fetch Instagram status:', error);
      setInstagramStatus({ connected: false, error: error.message });
    } finally {
      setInstagramLoading(false);
    }
  };

  const fetchInstagramPosts = async (loadMore = false) => {
    if (loadMore) {
      setInstagramLoadingMore(true);
    } else {
      setInstagramPostsLoading(true);
    }
    try {
      const url = loadMore && instagramNextPage 
        ? instagramNextPage 
        : `${API_URL}/api/instagram/media?limit=100`;
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        if (loadMore) {
          setInstagramPosts(prev => [...prev, ...(data.data || [])]);
        } else {
          setInstagramPosts(data.data || []);
        }
        setInstagramNextPage(data.paging?.next || null);
      }
    } catch (error) {
      console.error('Failed to fetch Instagram posts:', error);
    } finally {
      setInstagramPostsLoading(false);
      setInstagramLoadingMore(false);
    }
  };

  const fetchScheduledPosts = async () => {
    try {
      const response = await fetch(`${API_URL}/api/instagram/scheduled`);
      if (response.ok) {
        const data = await response.json();
        setInstagramScheduledPosts(data.scheduled_posts || []);
      }
    } catch (error) {
      console.error('Failed to fetch scheduled posts:', error);
    }
  };

  const publishInstagramPost = async () => {
    if (!instagramComposeData.caption.trim()) {
      toast.error('Please add a caption');
      return;
    }
    if (!instagramComposeData.imageUrl && !instagramComposeData.videoUrl) {
      toast.error('Please provide an image or video URL');
      return;
    }

    setInstagramPublishing(true);
    try {
      const formData = new FormData();
      formData.append('caption', instagramComposeData.caption);

      let endpoint = '/api/instagram/publish/image';
      if (instagramComposeData.mediaType === 'VIDEO' || instagramComposeData.mediaType === 'REELS') {
        endpoint = '/api/instagram/publish/video';
        formData.append('video_url', instagramComposeData.videoUrl);
        formData.append('media_type', instagramComposeData.mediaType);
      } else {
        formData.append('image_url', instagramComposeData.imageUrl);
      }

      const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (response.ok && data.success) {
        toast.success(data.message || 'Post published successfully!');
        setShowInstagramComposeModal(false);
        setInstagramComposeData({ caption: '', imageUrl: '', videoUrl: '', mediaType: 'IMAGE' });
        // Refresh posts
        fetchInstagramPosts();
      } else {
        toast.error(data.detail || 'Failed to publish post');
      }
    } catch (error) {
      console.error('Publish error:', error);
      toast.error('Failed to publish post');
    } finally {
      setInstagramPublishing(false);
    }
  };

  const deleteScheduledPost = async (postId) => {
    try {
      const response = await fetch(`${API_URL}/api/instagram/scheduled/${postId}`, {
        method: 'DELETE'
      });
      if (response.ok) {
        toast.success('Scheduled post deleted');
        fetchScheduledPosts();
      }
    } catch (error) {
      toast.error('Failed to delete scheduled post');
    }
  };

  // Get current week dates for sample posts
  const getSampleDate = (dayOffset) => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Start from Monday
    const monday = new Date(today);
    monday.setDate(today.getDate() + diff + dayOffset);
    return monday.toISOString().split('T')[0];
  };

  // Posts state - fetched from backend
  const [posts, setPosts] = useState([]);
  const [postsLoading, setPostsLoading] = useState(false);

  // Fetch posts from backend
  const fetchPosts = async () => {
    setPostsLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/content-posts`);
      if (response.ok) {
        const data = await response.json();
        setPosts(data);
      } else {
        console.error('Failed to fetch posts');
      }
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setPostsLoading(false);
    }
  };

  // Platform configuration
  const platforms = [
    { id: 'facebook', name: 'Facebook', icon: FacebookIcon, color: 'text-blue-500' },
    { id: 'instagram', name: 'Instagram', icon: InstagramIcon, color: 'text-pink-500' },
    { id: 'linkedin', name: 'LinkedIn', icon: LinkedInIcon, color: 'text-blue-600' },
    { id: 'twitter', name: 'X (Twitter)', icon: XTwitterIcon, color: 'text-white' },
    { id: 'tiktok', name: 'TikTok', icon: TikTokIcon, color: 'text-white' },
    { id: 'youtube', name: 'YouTube', icon: YouTubeIcon, color: 'text-red-500' },
    { id: 'threads', name: 'Threads', icon: ThreadsIcon, color: 'text-white' },
    { id: 'pinterest', name: 'Pinterest', icon: PinterestIcon, color: 'text-red-600' },
  ];

  // Categories state - fetched from backend
  const [categories, setCategories] = useState([
    { id: 'real-estate', name: 'Real Estate', color: 'bg-purple-600' },
    { id: 'lifestyle', name: 'Lifestyle', color: 'bg-pink-500' },
    { id: 'business', name: 'Business', color: 'bg-blue-500' },
    { id: 'personal', name: 'Personal', color: 'bg-green-500' },
  ]);
  const [availableColors, setAvailableColors] = useState([]);
  const [showCategoryEditor, setShowCategoryEditor] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newCategoryColor, setNewCategoryColor] = useState('bg-purple-600');

  // Fetch categories from backend
  const fetchCategories = async () => {
    try {
      const response = await fetch(`${API_URL}/api/post-categories`);
      if (response.ok) {
        const data = await response.json();
        setCategories(data.categories);
        setAvailableColors(data.available_colors || []);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  // Save category (create or update)
  const saveCategory = async () => {
    if (!newCategoryName.trim()) {
      toast.error('Category name is required');
      return;
    }

    try {
      if (editingCategory) {
        // Update existing category
        const response = await fetch(`${API_URL}/api/post-categories/${editingCategory.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: newCategoryName, color: newCategoryColor })
        });
        if (response.ok) {
          const updated = await response.json();
          setCategories(categories.map(c => c.id === editingCategory.id ? updated : c));
          toast.success('Category updated!');
        }
      } else {
        // Create new category
        const response = await fetch(`${API_URL}/api/post-categories`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: newCategoryName, color: newCategoryColor })
        });
        if (response.ok) {
          const newCat = await response.json();
          setCategories([...categories, newCat]);
          toast.success('Category created!');
        } else {
          const err = await response.json();
          toast.error(err.detail || 'Failed to create category');
        }
      }
    } catch (error) {
      console.error('Error saving category:', error);
      toast.error('Failed to save category');
    }
    
    setEditingCategory(null);
    setNewCategoryName('');
    setNewCategoryColor('bg-purple-600');
    setShowCategoryEditor(false);
  };

  // Delete category
  const deleteCategory = async (categoryId) => {
    try {
      const response = await fetch(`${API_URL}/api/post-categories/${categoryId}`, {
        method: 'DELETE'
      });
      if (response.ok) {
        setCategories(categories.filter(c => c.id !== categoryId));
        toast.success('Category deleted!');
      }
    } catch (error) {
      console.error('Error deleting category:', error);
      toast.error('Failed to delete category');
    }
  };

  // Sample trending posts for Explore tab
  // Explore page now uses Instagram posts data instead of mock data
  // The trendingPosts array is replaced by instagramPosts from the Instagram API

  // Media category filters - dynamically built from uploaded assets
  const mediaCategories = [
    { id: 'all', name: 'All', icon: null },
    { id: 'favorites', name: 'Favorites', icon: '⭐' },
    { id: 'lifestyle', name: 'Lifestyle', icon: null },
    { id: 'business', name: 'Business', icon: null },
    { id: 'real-estate', name: 'Real Estate', icon: null },
    { id: 'uncategorized', name: 'Uncategorized', icon: null },
  ];

  // Toggle media selection
  const toggleMediaSelection = (mediaId) => {
    setSelectedMedia(prev => 
      prev.includes(mediaId) 
        ? prev.filter(id => id !== mediaId)
        : [...prev, mediaId]
    );
  };

  // Get days of the week
  const getDaysOfWeek = () => {
    const days = [];
    const start = new Date(currentWeekStart);
    start.setDate(start.getDate() - start.getDay() + 1);
    
    for (let i = 0; i < 7; i++) {
      const day = new Date(start);
      day.setDate(start.getDate() + i);
      days.push(day);
    }
    return days;
  };

  const daysOfWeek = getDaysOfWeek();

  const navigateWeek = (direction) => {
    const newDate = new Date(currentWeekStart);
    newDate.setDate(newDate.getDate() + (direction * 7));
    setCurrentWeekStart(newDate);
  };

  // Check if a scheduled post's time has passed
  const isScheduledPostExpired = (post) => {
    // Only filter out scheduled posts, keep drafts and published posts
    if (post.status !== 'scheduled') return false;
    
    const postDateTime = new Date(`${post.date}T${post.time || '00:00'}`);
    const now = new Date();
    return postDateTime < now;
  };

  const getPostsForDay = (date) => {
    const dateStr = date.toISOString().split('T')[0];
    return posts.filter(post => {
      // Filter out expired scheduled posts
      if (isScheduledPostExpired(post)) return false;
      
      // Filter by date first
      if (post.date !== dateStr) return false;
      
      // If 'all' is selected, show all posts
      if (selectedPlatforms.includes('all')) return true;
      
      // Filter by selected platforms
      const postPlatforms = post.selectedPlatforms || [post.platform];
      return postPlatforms.some(p => selectedPlatforms.includes(p) || 
        (p === 'x' && selectedPlatforms.includes('twitter')) ||
        (p === 'twitter' && selectedPlatforms.includes('x')));
    });
  };

  // Open modal to create a new post
  const openCreatePostModal = (date = null) => {
    const dateStr = date ? date.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
    setNewPost({
      platform: 'instagram',
      title: '',
      description: '',
      date: dateStr,
      time: '09:00',
      category: 'real-estate',
      image: null,
      hashtags: '',
      selectedPlatforms: ['instagram']
    });
    setPostModalMode('create');
    setSelectedPost(null);
    setPostEditorExpanded(false);
    setShowPostModal(true);
  };

  // Open modal to edit an existing post
  const openEditPostModal = (post) => {
    setNewPost({
      platform: post.platform,
      title: post.title,
      description: post.description,
      date: post.date,
      time: post.time,
      category: post.category,
      image: post.image,
      mediaType: post.mediaType || null,
      hashtags: post.hashtags || '',
      selectedPlatforms: post.selectedPlatforms || [post.platform]
    });
    setPostModalMode('edit');
    setSelectedPost(post);
    setShowPostModal(true);
  };

  // Toggle platform selection for multi-platform posting
  const togglePostPlatform = (platformId) => {
    setNewPost(prev => {
      const selected = prev.selectedPlatforms || [];
      if (selected.includes(platformId)) {
        return { ...prev, selectedPlatforms: selected.filter(p => p !== platformId) };
      } else {
        return { ...prev, selectedPlatforms: [...selected, platformId] };
      }
    });
  };

  // Save post (create or update) and optionally publish to connected platforms
  const savePost = async (publishNow = false) => {
    const selectedPlatformsForPost = newPost.selectedPlatforms || [];
    
    // Check if we should send to Upload-Post (either publishing now OR scheduling for future)
    const scheduleDateTime = new Date(`${newPost.date}T${newPost.time || '09:00'}`);
    const now = new Date();
    const isSchedulingForFuture = scheduleDateTime > now;
    const shouldSendToUploadPost = publishNow || isSchedulingForFuture;
    
    // If publishing now OR scheduling for future, send to Upload-Post
    if (shouldSendToUploadPost) {
      const postContent = `${newPost.title}\n\n${newPost.description}${newPost.hashtags ? `\n\n${newPost.hashtags}` : ''}`;
      
      // Get platforms connected via Upload-Post
      const uploadPostPlatforms = selectedPlatformsForPost.filter(p => 
        uploadPostAccounts.some(acc => acc.platform === p || (p === 'twitter' && acc.platform === 'x') || (p === 'x' && acc.platform === 'x'))
      );
      
      // Map 'twitter' to 'x' for Upload-Post API
      const platformsForApi = uploadPostPlatforms.map(p => p === 'twitter' ? 'x' : p);
      
      if (platformsForApi.length > 0) {
        // Check if YouTube is selected - it requires VIDEO, not just an image
        if (platformsForApi.includes('youtube')) {
          if (!newPost.image) {
            toast.error('YouTube requires a video file. Please select a video from your media library.', { duration: 5000 });
            return;
          }
          if (newPost.mediaType !== 'video') {
            toast.error('YouTube only accepts video files, not images. Please select a video from your media library.', { duration: 5000 });
            return;
          }
        }
        
        // Check if media is required - NOT required for X/Twitter
        const platformsRequiringMedia = platformsForApi.filter(p => !['x', 'twitter'].includes(p));
        if (platformsRequiringMedia.length > 0 && !newPost.image) {
          toast.error(`Media is required for ${platformsRequiringMedia.join(', ')}. Twitter/X can post without media.`, { duration: 5000 });
          return;
        }
        
        try {
          const actionText = isSchedulingForFuture && !publishNow ? 'Scheduling' : 'Publishing';
          toast.loading(`${actionText} post...`, { id: 'publish-post' });
          
          const payload = {
            content: postContent,
            platforms: platformsForApi,
          };
          
          // Add media URL and type if available
          if (newPost.image) {
            payload.media_url = newPost.image;
            payload.media_type = newPost.mediaType || 'image';
          }
          
          // Add schedule time if in the future
          if (isSchedulingForFuture) {
            payload.schedule_at = scheduleDateTime.toISOString();
          }
          
          const response = await fetch(`${API_URL}/api/upload-post/post`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          });
          
          const data = await response.json();
          
          if (data.success) {
            const successText = data.scheduled ? `Scheduled for ${platformsForApi.join(', ')}!` : `Published to ${platformsForApi.join(', ')}!`;
            toast.success(successText, { id: 'publish-post' });
            
            // Continue to save to local database below
          } else {
            toast.error(data.error || 'Failed to publish post', { id: 'publish-post', duration: 5000 });
            return; // Don't save locally if Upload-Post failed
          }
        } catch (error) {
          console.error('Error publishing post:', error);
          toast.error('Failed to publish post', { id: 'publish-post' });
          return; // Don't save locally if Upload-Post failed
        }
      }
      
      // Handle platforms not connected via Upload-Post (only for immediate publish)
      if (publishNow) {
        const otherPlatforms = selectedPlatformsForPost.filter(p => 
          !uploadPostAccounts.some(acc => acc.platform === p || (p === 'twitter' && acc.platform === 'x'))
        );
        
        // Publish to Facebook if selected and connected directly
        if (otherPlatforms.includes('facebook') && facebookStatus?.page?.connected) {
          const success = await publishToFacebook(postContent, newPost.image);
          if (success) {
            toast.success('Published to Facebook!');
          }
        }
        
        // Instagram Business API requires media
        if (otherPlatforms.includes('instagram') && instagramStatus?.connected && !uploadPostAccounts.some(a => a.platform === 'instagram')) {
          toast.info('For Instagram Business, please use the Instagram tab to publish with media.');
        }
      }
    }
    
    // Save to calendar (draft/scheduled) - persist to backend
    try {
      const postData = {
        title: newPost.title,
        description: newPost.description || '',
        platform: newPost.platform,
        selectedPlatforms: newPost.selectedPlatforms || [newPost.platform],
        date: newPost.date,
        time: newPost.time || '09:00',
        status: publishNow ? 'published' : 'scheduled',
        category: newPost.category || 'uncategorized',
        image: newPost.image || null,
        mediaType: newPost.mediaType || null,
        hashtags: newPost.hashtags || '',
      };

      if (postModalMode === 'create') {
        const response = await fetch(`${API_URL}/api/content-posts`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(postData)
        });
        
        if (response.ok) {
          const savedPost = await response.json();
          setPosts([...posts, savedPost]);
          if (!publishNow) toast.success('Post scheduled!');
        } else {
          toast.error('Failed to save post');
          return;
        }
      } else {
        // Update existing post
        const response = await fetch(`${API_URL}/api/content-posts/${selectedPost.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(postData)
        });
        
        if (response.ok) {
          const updatedPost = await response.json();
          setPosts(posts.map(p => p.id === selectedPost.id ? updatedPost : p));
          toast.success('Post updated!');
        } else {
          toast.error('Failed to update post');
          return;
        }
      }
    } catch (error) {
      console.error('Error saving post:', error);
      toast.error('Failed to save post');
      return;
    }
    
    setShowPostModal(false);
  };

  // Delete post - persist to backend
  const deletePost = async (postId) => {
    try {
      const response = await fetch(`${API_URL}/api/content-posts/${postId}`, {
        method: 'DELETE'
      });
      
      if (response.ok) {
        setPosts(posts.filter(p => p.id !== postId));
        toast.success('Post deleted!');
      } else {
        toast.error('Failed to delete post');
      }
    } catch (error) {
      console.error('Error deleting post:', error);
      toast.error('Failed to delete post');
    }
    setShowPostModal(false);
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
  };

  // Format time to 12-hour format in CST timezone
  const formatTimeToCST = (timeStr) => {
    if (!timeStr) return '';
    // Parse the time string (expected format: "HH:MM" in 24-hour)
    const [hours, minutes] = timeStr.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) return timeStr;
    
    // Convert to 12-hour format
    const period = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    
    return `${hour12}:${formattedMinutes} ${period} CST`;
  };

  const getDateRange = () => {
    const start = daysOfWeek[0];
    const end = daysOfWeek[6];
    return `${formatDate(start)} - ${formatDate(end)}`;
  };

  const getPlatformIcon = (platformId) => {
    const platform = platforms.find(p => p.id === platformId);
    if (platform) {
      const IconComponent = platform.icon;
      return <IconComponent />;
    }
    return null;
  };

  const toggleCategory = (categoryId) => {
    setSelectedCategories(prev => 
      prev.includes(categoryId) 
        ? prev.filter(id => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const togglePlatform = (platformId) => {
    if (platformId === 'all') {
      setSelectedPlatforms(['all']);
    } else {
      setSelectedPlatforms(prev => {
        const newSelection = prev.filter(id => id !== 'all');
        if (newSelection.includes(platformId)) {
          const filtered = newSelection.filter(id => id !== platformId);
          return filtered.length === 0 ? ['all'] : filtered;
        } else {
          return [...newSelection, platformId];
        }
      });
    }
  };

  // Render status icon and label for posts
  const getStatusDisplay = (status) => {
    switch (status) {
      case 'scheduled':
        return {
          icon: <Calendar size={12} />,
          label: 'Scheduled',
          className: 'bg-cyan-500/20 text-cyan-400'
        };
      case 'draft':
        return {
          icon: <FileText size={12} />,
          label: 'Draft',
          className: 'bg-yellow-500/20 text-yellow-400'
        };
      case 'published':
        return {
          icon: <CheckCircle size={12} />,
          label: 'Published',
          className: 'bg-green-500/20 text-green-400'
        };
      default:
        return {
          icon: <Clock size={12} />,
          label: status || 'Unknown',
          className: 'bg-gray-500/20 text-gray-400'
        };
    }
  };

  // Format large numbers
  const formatNumber = (num) => {
    if (typeof num === 'string') return num;
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num.toString();
  };

  // AI Assist - Generate caption and hashtags using AI
  const generateAICaption = async () => {
    if (aiAssistLoading) return;
    
    setAiAssistLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/ai-assist/generate-caption`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title: newPost.title || '',
          description: newPost.description || '',
          platforms: newPost.selectedPlatforms || ['instagram'],
          tone: 'engaging',
          include_hashtags: true,
          include_emojis: true
        })
      });
      
      const data = await response.json();
      
      if (data.success) {
        // Update the post with AI-generated content
        setNewPost(prev => ({
          ...prev,
          description: data.caption || prev.description,
          hashtags: data.hashtags || prev.hashtags
        }));
        toast.success('AI generated your caption and hashtags!');
      } else {
        toast.error(data.error || 'Failed to generate caption');
      }
    } catch (error) {
      console.error('AI Assist error:', error);
      toast.error('Failed to connect to AI service');
    } finally {
      setAiAssistLoading(false);
    }
  };

  // AI Assist - Improve existing caption
  const improveAICaption = async () => {
    if (aiAssistLoading) return;
    if (!newPost.description) {
      toast.info('Add some content first, then AI can improve it');
      return;
    }
    
    setAiAssistLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/ai-assist/improve-caption`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title: newPost.title || '',
          description: newPost.description,
          platforms: newPost.selectedPlatforms || ['instagram'],
          tone: 'engaging',
          include_hashtags: true,
          include_emojis: true
        })
      });
      
      const data = await response.json();
      
      if (data.success) {
        setNewPost(prev => ({
          ...prev,
          description: data.caption || prev.description,
          hashtags: data.hashtags || prev.hashtags
        }));
        toast.success('Caption improved by AI!');
      } else {
        toast.error(data.error || 'Failed to improve caption');
      }
    } catch (error) {
      console.error('AI Assist error:', error);
      toast.error('Failed to connect to AI service');
    } finally {
      setAiAssistLoading(false);
    }
  };

  // Format ISO 8601 duration (PT1H2M3S) to human readable (1:02:03)
  const formatDuration = (isoDuration) => {
    if (!isoDuration) return '';
    const match = isoDuration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!match) return isoDuration;
    
    const hours = parseInt(match[1] || 0);
    const minutes = parseInt(match[2] || 0);
    const seconds = parseInt(match[3] || 0);
    
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  // Get draft posts for a specific platform (for Layout grid preview)
  const getDraftPostsForPlatform = (platformId) => {
    const platformAliases = {
      'instagram': ['instagram'],
      'instagram-personal': ['instagram'],
      'youtube': ['youtube'],
      'facebook': ['facebook'],
      'x': ['x', 'twitter'],
      'twitter': ['x', 'twitter'],
      'tiktok': ['tiktok'],
      'linkedin': ['linkedin'],
      'threads': ['threads'],
      'pinterest': ['pinterest'],
    };
    
    const aliases = platformAliases[platformId?.toLowerCase()] || [platformId?.toLowerCase()];
    
    return posts.filter(post => {
      // Check if post is draft or scheduled
      if (post.status !== 'draft' && post.status !== 'scheduled') return false;
      
      // Check if post targets this platform
      const postPlatforms = post.selectedPlatforms || [post.platform];
      return postPlatforms.some(p => aliases.includes(p?.toLowerCase()));
    });
  };

  // Handle drag and drop reordering in Layout grid
  const handleLayoutDragEnd = (result) => {
    if (!result.destination) return;
    
    const items = Array.from(layoutGridOrder);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    
    setLayoutGridOrder(items);
    toast.success('Grid order updated! This is a preview of how your feed will look.');
  };

  // Initialize layout grid order when switching to layout tab or platform changes
  useEffect(() => {
    if (activeTab === 'layout' && layoutPlatform) {
      const platformDrafts = getDraftPostsForPlatform(layoutPlatform);
      
      // Combine existing posts with drafts for the grid preview
      let combinedItems = [];
      
      if (layoutPlatform === 'instagram' && instagramPosts.length > 0) {
        // For Instagram Business API, add existing posts
        combinedItems = instagramPosts.map(p => ({ type: 'published', id: p.id, data: p }));
      }
      
      // Add draft posts at the beginning (they'll appear at the top of the grid)
      const draftItems = platformDrafts.map(p => ({ type: 'draft', id: p.id, data: p }));
      combinedItems = [...draftItems, ...combinedItems];
      
      setLayoutGridOrder(combinedItems);
    }
  }, [activeTab, layoutPlatform, posts, instagramPosts]);

  // Get all available platforms for Layout tab (dynamically built from connected accounts)
  const getLayoutPlatforms = () => {
    const platforms = [];
    
    // Add Instagram if directly connected via Business API
    if (instagramStatus?.connected) {
      platforms.push({
        id: 'instagram',
        name: 'Instagram',
        icon: InstagramIcon,
        color: 'from-pink-500 to-purple-600',
        bgColor: 'bg-gradient-to-r from-pink-500 to-purple-600',
        borderColor: 'border-pink-500',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(236,72,153,0.3)]',
        username: instagramStatus.account?.username,
        connected: true,
        source: 'business-api'
      });
    }
    
    // Add Instagram from Upload-Post as a SEPARATE tab (if connected)
    const uploadPostInstagram = uploadPostAccounts.find(a => a.platform === 'instagram');
    if (uploadPostInstagram) {
      platforms.push({
        id: 'instagram-uploadpost',
        name: 'Instagram',
        icon: InstagramIcon,
        color: 'from-orange-500 to-pink-500',
        bgColor: 'bg-gradient-to-r from-orange-500 to-pink-500',
        borderColor: 'border-orange-500',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(249,115,22,0.3)]',
        username: uploadPostInstagram.friendly_name || uploadPostInstagram.display_name || uploadPostInstagram.username,
        profilePicture: uploadPostInstagram.profile_picture,
        connected: true,
        source: 'upload-post'
      });
    }
    
    // Add YouTube if connected via Analytics or Upload-Post
    if (youtubeAnalyticsStatus?.connected || uploadPostAccounts.some(a => a.platform === 'youtube')) {
      platforms.push({
        id: 'youtube',
        name: 'YouTube',
        icon: YouTubeIcon,
        color: 'bg-red-600',
        bgColor: 'bg-red-600',
        borderColor: 'border-red-500',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(239,68,68,0.3)]',
        username: youtubeAnalyticsStatus?.channel?.channel_title || 
                  uploadPostAccounts.find(a => a.platform === 'youtube')?.friendly_name,
        connected: true
      });
    }
    
    // Add platforms from Upload-Post accounts (excluding youtube and instagram which are handled above)
    uploadPostAccounts.forEach(account => {
      const platformId = account.platform.toLowerCase();
      // Skip instagram and youtube - they're handled separately above
      if (platformId === 'instagram' || platformId === 'youtube') return;
      // Skip if already added
      if (platforms.some(p => p.id === platformId)) return;
      
      // Get platform icon and styling
      const platformConfig = getPlatformLayoutConfig(platformId);
      if (platformConfig) {
        platforms.push({
          id: platformId,
          name: platformConfig.name,
          icon: platformConfig.icon,
          color: platformConfig.color,
          bgColor: platformConfig.bgColor,
          borderColor: platformConfig.borderColor,
          hoverShadow: platformConfig.hoverShadow,
          username: account.friendly_name || account.display_name || account.username,
          profilePicture: account.profile_picture,
          connected: true
        });
      }
    });
    
    return platforms;
  };

  // Get platform-specific config for Layout tab styling
  const getPlatformLayoutConfig = (platformId) => {
    const configs = {
      'x': {
        name: 'X (Twitter)',
        icon: XTwitterIcon,
        color: 'bg-black border-white',
        bgColor: 'bg-gray-900',
        borderColor: 'border-white',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(255,255,255,0.2)]'
      },
      'twitter': {
        name: 'X (Twitter)',
        icon: XTwitterIcon,
        color: 'bg-black border-white',
        bgColor: 'bg-gray-900',
        borderColor: 'border-white',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(255,255,255,0.2)]'
      },
      'facebook': {
        name: 'Facebook',
        icon: FacebookIcon,
        color: 'bg-blue-600',
        bgColor: 'bg-blue-600',
        borderColor: 'border-blue-500',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(59,130,246,0.3)]'
      },
      'linkedin': {
        name: 'LinkedIn',
        icon: LinkedInIcon,
        color: 'bg-blue-700',
        bgColor: 'bg-blue-700',
        borderColor: 'border-blue-600',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(37,99,235,0.3)]'
      },
      'tiktok': {
        name: 'TikTok',
        icon: TikTokIcon,
        color: 'bg-black',
        bgColor: 'bg-gradient-to-r from-pink-500 via-red-500 to-cyan-400',
        borderColor: 'border-pink-500',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(236,72,153,0.3)]'
      },
      'threads': {
        name: 'Threads',
        icon: ThreadsIcon,
        color: 'bg-black',
        bgColor: 'bg-gray-900',
        borderColor: 'border-gray-400',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(156,163,175,0.3)]'
      },
      'pinterest': {
        name: 'Pinterest',
        icon: PinterestIcon,
        color: 'bg-red-600',
        bgColor: 'bg-red-600',
        borderColor: 'border-red-500',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(220,38,38,0.3)]'
      },
      'bluesky': {
        name: 'Bluesky',
        icon: BlueskyIcon,
        color: 'bg-sky-500',
        bgColor: 'bg-sky-500',
        borderColor: 'border-sky-400',
        hoverShadow: 'hover:shadow-[0_0_20px_rgba(14,165,233,0.3)]'
      }
    };
    return configs[platformId] || null;
  };

  // Auto-select first available platform when Layout tab is activated or accounts change
  useEffect(() => {
    if (activeTab === 'layout') {
      const availablePlatforms = getLayoutPlatforms();
      if (availablePlatforms.length > 0 && !layoutPlatform) {
        setLayoutPlatform(availablePlatforms[0].id);
      } else if (layoutPlatform && !availablePlatforms.some(p => p.id === layoutPlatform)) {
        // Current platform no longer available, switch to first available
        setLayoutPlatform(availablePlatforms.length > 0 ? availablePlatforms[0].id : null);
      }
    }
  }, [activeTab, uploadPostAccounts, instagramStatus?.connected, youtubeAnalyticsStatus?.connected]);

  // Main tabs configuration
  const mainTabs = [
    { id: 'posts', label: 'Posts', icon: Calendar },
    { id: 'accounts', label: 'Accounts', icon: Users },
    { id: 'layout', label: 'Layout', icon: Grid },
    { id: 'media', label: 'Media', icon: ImageIcon },
    { id: 'analytics', label: 'Analytics', icon: BarChart3 },
  ];

  // Layout sub-tabs for YouTube
  const youtubeLayoutTabs = [
    { id: 'videos', label: 'Videos' },
    { id: 'playlists', label: 'Playlists' },
  ];

  return (
    <div className="min-h-screen bg-black text-white p-4 md:p-6">
      {/* Page Header with Connected Accounts */}
      <div className="mb-4 md:mb-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h1 className="text-xl md:text-3xl font-bold mb-1 md:mb-2">Social Media</h1>
            <p className="text-gray-400 text-sm md:text-base">Manage and schedule your content</p>
          </div>
          {/* Connected Accounts Status */}
          <div className="flex items-center gap-3">
            {instagramStatus?.connected && (
              <div className="flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-pink-500/20 to-purple-500/20 rounded-full border border-pink-500/30">
                <div className="w-5 h-5"><InstagramIcon /></div>
                <span className="text-sm text-white">@{instagramStatus.account?.username}</span>
                <CheckCircle className="w-4 h-4 text-green-400" />
              </div>
            )}
            {facebookStatus?.connected && (
              <div className="flex items-center gap-2 px-3 py-1.5 bg-blue-500/20 rounded-full border border-blue-500/30">
                <div className="w-5 h-5"><FacebookIcon /></div>
                <span className="text-sm text-white">{facebookStatus.page?.name}</span>
                <CheckCircle className="w-4 h-4 text-green-400" />
              </div>
            )}
            {/* Upload-Post Connected Accounts */}
            {uploadPostAccounts.map((account) => (
              <div key={account.platform} className="flex items-center gap-2 px-3 py-1.5 bg-gray-700/50 rounded-full border border-gray-500/30">
                <div className="w-5 h-5">
                  {account.platform === 'youtube' && <YouTubeIcon />}
                  {account.platform === 'tiktok' && <TikTokIcon />}
                  {account.platform === 'instagram' && <InstagramIcon />}
                  {account.platform === 'facebook' && <FacebookIcon />}
                  {account.platform === 'linkedin' && <LinkedInIcon />}
                  {account.platform === 'x' && <XTwitterIcon />}
                </div>
                <span className="text-sm text-white">@{account.friendly_name || account.display_name || account.username}</span>
                <CheckCircle className="w-4 h-4 text-green-400" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Tabs - Scrollable on mobile */}
      <div className="bg-black border border-gray-400 rounded-xl mb-4 md:mb-6 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
        <div className="flex overflow-x-auto scrollbar-hide border-b border-gray-700">
          {mainTabs.map((tab) => {
            const IconComponent = tab.icon;
            return (
              <button
                key={tab.id}
                data-testid={`tab-${tab.id}`}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-1.5 md:gap-2 px-3 md:px-6 py-3 md:py-4 text-xs md:text-sm font-medium transition-all border-b-2 -mb-[2px] whitespace-nowrap flex-shrink-0 ${
                  activeTab === tab.id
                    ? 'text-white border-white bg-white/5'
                    : 'text-gray-400 border-transparent hover:text-white hover:bg-white/5'
                } ${tab.id === 'instagram' ? 'text-pink-500' : ''}`}
              >
                {tab.isCustomIcon ? (
                  <div className="w-4 h-4 md:w-[18px] md:h-[18px]"><IconComponent /></div>
                ) : (
                  <IconComponent size={16} className="md:w-[18px] md:h-[18px]" />
                )}
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Unified Accounts Tab Content */}
      {activeTab === 'accounts' && (
        <div data-testid="accounts-tab-content" className="space-y-6">
          {/* Connected Accounts - All Sources */}
          {(uploadPostAccounts.length > 0 || instagramStatus?.connected) && (
            <div className="bg-black border border-gray-400 rounded-xl p-6 hover:border-cyan-400 hover:shadow-[0_0_20px_rgba(34,211,238,0.2)] transition-all duration-300">
              <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                <Users className="w-5 h-5 text-cyan-400" />
                Connected Accounts
              </h3>
              <div className="space-y-3">
                {/* Business Instagram Account */}
                {instagramStatus?.connected && (
                  <div
                    className="flex items-center gap-4 p-4 bg-gray-900/50 rounded-xl border border-gray-700 hover:border-gray-500 transition-colors"
                    data-testid="connected-account-instagram-business"
                  >
                    {/* Profile Picture */}
                    <div className="w-12 h-12 rounded-full bg-gray-800 flex items-center justify-center overflow-hidden flex-shrink-0">
                      {instagramStatus.account?.profile_picture_url ? (
                        <img src={instagramStatus.account.profile_picture_url} alt={instagramStatus.account?.username} className="w-full h-full object-cover" />
                      ) : (
                        <div className="w-6 h-6 text-pink-500"><InstagramIcon /></div>
                      )}
                    </div>
                    
                    {/* Username and Platform */}
                    <div className="flex-1 min-w-0">
                      <p className="text-white font-medium text-base">@{instagramStatus.account?.username}</p>
                      <p className="text-xs text-gray-400">Instagram Business</p>
                    </div>
                    
                    {/* Connected Badge & Disconnect Button */}
                    <div className="flex items-center gap-2">
                      <span className="flex items-center gap-1 px-2 py-1 bg-green-500/20 text-green-400 rounded-full text-xs">
                        <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
                        Connected
                      </span>
                      <button
                        onClick={() => openDisconnectModal({ 
                          platform: 'instagram', 
                          username: instagramStatus.account?.username,
                          name: instagramStatus.account?.username
                        }, 'instagram-business')}
                        className="p-2 text-gray-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-colors"
                        title="Disconnect account"
                        data-testid="disconnect-instagram-business"
                      >
                        <X size={16} />
                      </button>
                    </div>
                  </div>
                )}
                
                {/* Upload-Post Accounts */}
                {uploadPostAccounts.map((account) => (
                  <div
                    key={`${account.platform}-${account.username}`}
                    className="flex items-center gap-4 p-4 bg-gray-900/50 rounded-xl border border-gray-700 hover:border-gray-500 transition-colors"
                    data-testid={`uploadpost-account-${account.platform}-${account.username}`}
                  >
                    {/* Profile Picture */}
                    <div className="w-12 h-12 rounded-full bg-gray-800 flex items-center justify-center overflow-hidden flex-shrink-0">
                      {account.profile_picture ? (
                        <img src={account.profile_picture} alt={account.friendly_name} className="w-full h-full object-cover" />
                      ) : (
                        <>
                          {account.platform === 'instagram' && <div className="w-6 h-6 text-pink-500"><InstagramIcon /></div>}
                          {account.platform === 'youtube' && <div className="w-6 h-6 text-red-500"><YouTubeIcon /></div>}
                          {account.platform === 'tiktok' && <div className="w-6 h-6"><TikTokIcon /></div>}
                          {account.platform === 'x' && <div className="w-6 h-6"><XTwitterIcon /></div>}
                          {account.platform === 'linkedin' && <div className="w-6 h-6 text-blue-500"><LinkedInIcon /></div>}
                          {account.platform === 'facebook' && <div className="w-6 h-6 text-blue-500"><FacebookIcon /></div>}
                          {account.platform === 'threads' && <div className="w-6 h-6"><ThreadsIcon /></div>}
                          {account.platform === 'pinterest' && <div className="w-6 h-6 text-red-500"><PinterestIcon /></div>}
                          {account.platform === 'bluesky' && <div className="w-6 h-6 text-sky-500"><BlueskyIcon /></div>}
                          {!['instagram', 'youtube', 'tiktok', 'x', 'linkedin', 'facebook', 'threads', 'pinterest', 'bluesky'].includes(account.platform) && (
                            <User className="w-6 h-6 text-gray-400" />
                          )}
                        </>
                      )}
                    </div>
                    
                    {/* Username and Platform */}
                    <div className="flex-1 min-w-0">
                      <p className="text-white font-medium text-base">@{account.friendly_name || account.display_name || account.username}</p>
                      <p className="text-xs text-gray-400 capitalize flex items-center gap-1">
                        {account.platform === 'x' ? 'X' : account.platform}
                        <span className="text-gray-600">•</span>
                        <span className="text-gray-500">via Upload-Post</span>
                      </p>
                    </div>
                    
                    {/* Connected Badge & Disconnect Button */}
                    <div className="flex items-center gap-2">
                      <span className="flex items-center gap-1 px-2 py-1 bg-green-500/20 text-green-400 rounded-full text-xs">
                        <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
                        Connected
                      </span>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          openDisconnectModal({
                            platform: account.platform,
                            username: account.friendly_name || account.username,
                            name: account.friendly_name || account.display_name || account.username
                          }, 'upload-post');
                        }}
                        className="p-2 text-gray-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-colors"
                        title="Disconnect account"
                        data-testid={`disconnect-${account.platform}-${account.username}`}
                      >
                        <X size={16} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Actions */}
              <div className="flex gap-2 mt-4 pt-4 border-t border-gray-800">
                <button
                  onClick={() => openUploadPostConnect()}
                  disabled={uploadPostConnecting}
                  className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg text-sm font-medium hover:from-cyan-600 hover:to-blue-700 transition-colors disabled:opacity-50"
                >
                  {uploadPostConnecting ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <Plus size={16} />
                  )}
                  Add More Accounts
                </button>
                <button
                  onClick={fetchUploadPostStatus}
                  className="flex items-center justify-center gap-1 px-3 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-sm text-white transition-colors"
                >
                  <RefreshCw size={14} />
                </button>
              </div>
            </div>
          )}

          {/* Connect More Platforms */}
          <div className="bg-black border border-gray-400 rounded-xl p-6 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.2)] transition-all duration-300">
            <h3 className="text-lg font-semibold text-white mb-2 flex items-center gap-2">
              <Plus className="w-5 h-5 text-cyan-400" />
              Connect More Platforms
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Use Upload-Post to connect additional social media platforms with just one click. No developer setup required!
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {[
                { id: 'youtube', name: 'YouTube', icon: YouTubeIcon, color: 'hover:border-red-400' },
                { id: 'tiktok', name: 'TikTok', icon: TikTokIcon, color: 'hover:border-gray-300' },
                { id: 'x', name: 'X (Twitter)', icon: XTwitterIcon, color: 'hover:border-gray-300' },
                { id: 'linkedin', name: 'LinkedIn', icon: LinkedInIcon, color: 'hover:border-blue-400' },
                { id: 'threads', name: 'Threads', icon: ThreadsIcon, color: 'hover:border-gray-300' },
                { id: 'bluesky', name: 'Bluesky', icon: BlueskyIcon, color: 'hover:border-blue-400' },
                { id: 'pinterest', name: 'Pinterest', icon: PinterestIcon, color: 'hover:border-red-400' },
                { id: 'reddit', name: 'Reddit', icon: () => <span className="text-orange-500 text-lg">R</span>, color: 'hover:border-orange-400' },
              ].map(platform => {
                const PlatformIcon = platform.icon;
                const isConnected = uploadPostAccounts.some(acc => acc.platform === platform.id);
                return (
                  <button
                    key={platform.id}
                    onClick={() => !isConnected && openUploadPostConnect(platform.id)}
                    disabled={isConnected}
                    className={`flex items-center gap-2 p-3 bg-gray-900 border border-gray-700 rounded-xl transition-all ${platform.color} ${
                      isConnected ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
                    }`}
                    data-testid={`connect-${platform.id}-btn`}
                  >
                    <div className="w-5 h-5"><PlatformIcon /></div>
                    <span className="text-sm text-white truncate">{platform.name}</span>
                    {isConnected && <CheckCircle className="w-4 h-4 text-green-500 ml-auto flex-shrink-0" />}
                  </button>
                );
              })}
            </div>
            <p className="text-xs text-green-500/70 mt-4 flex items-center gap-1">
              <CheckCircle size={12} />
              No developer app setup required - just click and authorize!
            </p>
          </div>
        </div>
      )}

      {/* Instagram Tab Content (Legacy - kept for direct navigation) */}
      {activeTab === 'instagram' && (
        <div data-testid="instagram-tab-content">
          {/* Connection Status Card */}
          <div className="bg-black border border-gray-400 rounded-xl p-6 mb-6 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            {instagramLoading ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="w-8 h-8 animate-spin text-pink-500" />
                <span className="ml-3 text-gray-400">Checking connection...</span>
              </div>
            ) : instagramStatus?.connected ? (
              <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  {instagramStatus.account?.profile_picture_url ? (
                    <img 
                      src={instagramStatus.account.profile_picture_url} 
                      alt="Profile"
                      className="w-16 h-16 rounded-full object-cover border-2 border-pink-500"
                    />
                  ) : (
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 flex items-center justify-center">
                      <InstagramIcon />
                    </div>
                  )}
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="text-xl font-bold text-white">@{instagramStatus.account?.username}</h3>
                      <CheckCircle className="w-5 h-5 text-green-500" />
                    </div>
                    <p className="text-gray-400 text-sm capitalize">{instagramStatus.account?.account_type || 'Business'} Account</p>
                    <p className="text-gray-500 text-xs mt-1">{instagramStatus.account?.media_count || 0} posts</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <button
                    data-testid="refresh-instagram-btn"
                    onClick={() => { fetchInstagramStatus(); fetchInstagramPosts(); }}
                    className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
                  >
                    <RefreshCw size={16} />
                    Refresh
                  </button>
                  <button
                    data-testid="new-instagram-post-btn"
                    onClick={() => setShowInstagramComposeModal(true)}
                    className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 rounded-lg text-white text-sm font-medium transition-all"
                  >
                    <Plus size={16} />
                    New Post
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-8">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 flex items-center justify-center mb-4">
                  <InstagramIcon />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Instagram Not Connected</h3>
                <p className="text-gray-400 text-center max-w-md mb-4">
                  {instagramStatus?.error || 'Connect your Instagram Business account to manage posts and view insights.'}
                </p>
                <div className="flex items-center gap-2 text-yellow-500">
                  <AlertCircle size={16} />
                  <span className="text-sm">Requires Meta Developer App setup</span>
                </div>
              </div>
            )}
          </div>

          {/* Quick Stats */}
          {instagramStatus?.connected && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              {[
                { label: 'Posts', value: instagramStatus.account?.media_count || 0, icon: Grid, color: 'text-pink-400' },
                { label: 'Scheduled', value: instagramScheduledPosts.length, icon: Clock, color: 'text-purple-400' },
                { label: 'This Week', value: instagramPosts.filter(p => {
                  const postDate = new Date(p.timestamp);
                  const weekAgo = new Date();
                  weekAgo.setDate(weekAgo.getDate() - 7);
                  return postDate >= weekAgo;
                }).length, icon: Calendar, color: 'text-blue-400' },
                { label: 'Account Type', value: instagramStatus.account?.account_type || 'Business', icon: Users, color: 'text-green-400', isText: true },
              ].map((stat, idx) => {
                const IconComponent = stat.icon;
                return (
                  <div 
                    key={idx}
                    className="bg-black border border-gray-400 rounded-xl p-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300"
                  >
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-lg bg-white/5 ${stat.color}`}>
                        <IconComponent size={20} />
                      </div>
                      <div>
                        <div className={`${stat.isText ? 'text-lg' : 'text-2xl'} font-bold`}>{stat.value}</div>
                        <div className="text-xs text-gray-400">{stat.label}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Scheduled Posts Section */}
          {instagramStatus?.connected && instagramScheduledPosts.length > 0 && (
            <div className="bg-black border border-gray-400 rounded-xl p-4 mb-6 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                  <Clock className="w-5 h-5 text-purple-400" />
                  Scheduled Posts
                </h3>
              </div>
              <div className="space-y-3">
                {instagramScheduledPosts.map((post) => (
                  <div 
                    key={post.id}
                    className="flex items-center justify-between bg-gray-900 rounded-lg p-3 border border-gray-700"
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center">
                        {post.media_type === 'VIDEO' || post.media_type === 'REELS' ? (
                          <Video className="w-6 h-6 text-purple-400" />
                        ) : (
                          <ImageIcon className="w-6 h-6 text-pink-400" />
                        )}
                      </div>
                      <div>
                        <p className="text-white text-sm font-medium truncate max-w-[200px] md:max-w-[400px]">
                          {post.caption}
                        </p>
                        <p className="text-gray-400 text-xs">
                          Scheduled for {new Date(post.scheduled_time).toLocaleString()}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => deleteScheduledPost(post.id)}
                      className="p-2 hover:bg-red-500/20 rounded-lg transition-colors"
                    >
                      <Trash2 className="w-4 h-4 text-red-400" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Posts Grid */}
          <div className="bg-black border border-gray-400 rounded-xl p-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                <Grid className="w-5 h-5 text-pink-400" />
                Posts
              </h3>
              {instagramPosts.length > 0 && (
                <span className="text-sm text-gray-400">{instagramPosts.length} posts</span>
              )}
            </div>

            {instagramPostsLoading ? (
              <div className="flex items-center justify-center py-12">
                <Loader2 className="w-8 h-8 animate-spin text-pink-500" />
                <span className="ml-3 text-gray-400">Loading posts...</span>
              </div>
            ) : instagramPosts.length > 0 ? (
              <>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                {instagramPosts.map((post) => (
                  <div 
                    key={post.id}
                    data-testid={`instagram-post-${post.id}`}
                    className="relative group cursor-pointer aspect-square rounded-xl overflow-hidden border border-gray-700 hover:border-pink-500 transition-all"
                    onClick={() => setSelectedInstagramPost(post)}
                  >
                    {post.media_type === 'VIDEO' ? (
                      <div className="w-full h-full bg-gray-900 flex items-center justify-center">
                        <img 
                          src={post.thumbnail_url || post.media_url} 
                          alt="Video thumbnail"
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="w-12 h-12 rounded-full bg-black/60 flex items-center justify-center">
                            <Video className="w-6 h-6 text-white" />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <img 
                        src={post.media_url} 
                        alt={post.caption?.substring(0, 30) || 'Instagram post'}
                        className="w-full h-full object-cover"
                      />
                    )}
                    {/* Hover overlay */}
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-4">
                      <div className="flex items-center gap-1 text-white">
                        <Heart className="w-5 h-5" />
                        <span className="text-sm font-medium">{post.like_count || 0}</span>
                      </div>
                      <div className="flex items-center gap-1 text-white">
                        <MessageCircle className="w-5 h-5" />
                        <span className="text-sm font-medium">{post.comments_count || 0}</span>
                      </div>
                    </div>
                    {/* Media type badge */}
                    {post.media_type === 'CAROUSEL_ALBUM' && (
                      <div className="absolute top-2 right-2">
                        <Grid className="w-5 h-5 text-white drop-shadow-lg" />
                      </div>
                    )}
                  </div>
                ))}
              </div>
              {/* Load More Button */}
              {instagramNextPage && (
                <div className="flex justify-center mt-6">
                  <button
                    onClick={() => fetchInstagramPosts(true)}
                    disabled={instagramLoadingMore}
                    className="flex items-center gap-2 px-6 py-3 bg-gray-800 hover:bg-gray-700 disabled:bg-gray-900 rounded-lg text-white text-sm font-medium transition-colors"
                  >
                    {instagramLoadingMore ? (
                      <>
                        <Loader2 className="w-4 h-4 animate-spin" />
                        Loading...
                      </>
                    ) : (
                      <>
                        <ChevronDown className="w-4 h-4" />
                        Load More Posts
                      </>
                    )}
                  </button>
                </div>
              )}
            </>
            ) : instagramStatus?.connected ? (
              <div className="flex flex-col items-center justify-center py-12">
                <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mb-4">
                  <ImageIcon className="w-8 h-8 text-gray-600" />
                </div>
                <p className="text-gray-400 text-center">No posts yet</p>
                <button
                  onClick={() => setShowInstagramComposeModal(true)}
                  className="mt-4 flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-600 rounded-lg text-white text-sm font-medium"
                >
                  <Plus size={16} />
                  Create your first post
                </button>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-12">
                <p className="text-gray-500">Connect your Instagram account to see posts</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Instagram Post Detail Modal */}
      {selectedInstagramPost && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedInstagramPost(null)}
        >
          <div 
            className="bg-gray-900 rounded-xl max-w-3xl w-full max-h-[90vh] overflow-hidden flex flex-col md:flex-row"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Media Side */}
            <div className="md:w-1/2 bg-black flex items-center justify-center">
              {selectedInstagramPost.media_type === 'VIDEO' ? (
                <video 
                  src={selectedInstagramPost.media_url} 
                  controls 
                  className="w-full h-full object-contain max-h-[50vh] md:max-h-[80vh]"
                />
              ) : (
                <img 
                  src={selectedInstagramPost.media_url} 
                  alt="Post"
                  className="w-full h-full object-contain max-h-[50vh] md:max-h-[80vh]"
                />
              )}
            </div>
            {/* Details Side */}
            <div className="md:w-1/2 p-6 flex flex-col">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-500 to-purple-500 flex items-center justify-center">
                    <InstagramIcon />
                  </div>
                  <span className="font-semibold text-white">@{instagramStatus?.account?.username}</span>
                </div>
                <button 
                  onClick={() => setSelectedInstagramPost(null)}
                  className="p-2 hover:bg-gray-800 rounded-full transition-colors"
                >
                  <X className="w-5 h-5 text-gray-400" />
                </button>
              </div>
              
              <div className="flex-1 overflow-y-auto">
                <p className="text-white whitespace-pre-wrap text-sm mb-4">
                  {selectedInstagramPost.caption || 'No caption'}
                </p>
              </div>

              <div className="border-t border-gray-700 pt-4 mt-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-1 text-white">
                      <Heart className="w-5 h-5" />
                      <span className="text-sm">{selectedInstagramPost.like_count || 0}</span>
                    </div>
                    <div className="flex items-center gap-1 text-white">
                      <MessageCircle className="w-5 h-5" />
                      <span className="text-sm">{selectedInstagramPost.comments_count || 0}</span>
                    </div>
                  </div>
                  <a 
                    href={selectedInstagramPost.permalink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-1 text-pink-400 hover:text-pink-300 text-sm"
                  >
                    View on Instagram
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
                <p className="text-gray-500 text-xs">
                  {new Date(selectedInstagramPost.timestamp).toLocaleString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Instagram Compose Modal */}
      {showInstagramComposeModal && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={() => setShowInstagramComposeModal(false)}
        >
          <div 
            className="bg-gray-900 rounded-xl max-w-2xl w-full max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-700">
              <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                <div className="w-6 h-6 text-pink-500"><InstagramIcon /></div>
                Create New Post
              </h3>
              <button 
                onClick={() => setShowInstagramComposeModal(false)}
                className="p-2 hover:bg-gray-800 rounded-full transition-colors"
              >
                <X className="w-5 h-5 text-gray-400" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-4 max-h-[calc(90vh-140px)] overflow-y-auto">
              {/* Media Type Selection */}
              <div>
                <label className="block text-sm text-gray-400 mb-2">Media Type</label>
                <div className="flex gap-2">
                  {[
                    { id: 'IMAGE', label: 'Image', icon: ImageIcon },
                    { id: 'VIDEO', label: 'Video', icon: Video },
                    { id: 'REELS', label: 'Reel', icon: Video },
                  ].map((type) => {
                    const TypeIcon = type.icon;
                    return (
                      <button
                        key={type.id}
                        data-testid={`media-type-${type.id.toLowerCase()}`}
                        onClick={() => setInstagramComposeData({...instagramComposeData, mediaType: type.id})}
                        className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all ${
                          instagramComposeData.mediaType === type.id
                            ? 'bg-pink-500/20 text-pink-400 border border-pink-500'
                            : 'bg-gray-800 text-gray-400 border border-gray-700 hover:border-gray-600'
                        }`}
                      >
                        <TypeIcon size={16} />
                        {type.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Image/Video URL Input */}
              <div>
                <label className="block text-sm text-gray-400 mb-2">
                  {instagramComposeData.mediaType === 'IMAGE' ? 'Image URL' : 'Video URL'}
                  <span className="text-red-400 ml-1">*</span>
                </label>
                <input
                  type="url"
                  data-testid="media-url-input"
                  placeholder={instagramComposeData.mediaType === 'IMAGE' 
                    ? 'https://example.com/image.jpg' 
                    : 'https://example.com/video.mp4'
                  }
                  value={instagramComposeData.mediaType === 'IMAGE' 
                    ? instagramComposeData.imageUrl 
                    : instagramComposeData.videoUrl
                  }
                  onChange={(e) => setInstagramComposeData({
                    ...instagramComposeData,
                    [instagramComposeData.mediaType === 'IMAGE' ? 'imageUrl' : 'videoUrl']: e.target.value
                  })}
                  className="w-full bg-black border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-pink-500"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Media must be hosted on a publicly accessible URL
                </p>
              </div>

              {/* Caption */}
              <div>
                <label className="block text-sm text-gray-400 mb-2">
                  Caption
                  <span className="text-red-400 ml-1">*</span>
                </label>
                <textarea
                  data-testid="caption-input"
                  placeholder="Write your caption here... #hashtags @mentions"
                  value={instagramComposeData.caption}
                  onChange={(e) => setInstagramComposeData({...instagramComposeData, caption: e.target.value})}
                  rows={6}
                  className="w-full bg-black border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-pink-500 resize-none"
                />
                <p className="text-xs text-gray-500 mt-1 text-right">
                  {instagramComposeData.caption.length} / 2,200
                </p>
              </div>

              {/* Preview */}
              {(instagramComposeData.imageUrl || instagramComposeData.videoUrl) && (
                <div>
                  <label className="block text-sm text-gray-400 mb-2">Preview</label>
                  <div className="bg-black rounded-lg p-4 border border-gray-700">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-pink-500 to-purple-500 flex items-center justify-center">
                        <div className="w-4 h-4"><InstagramIcon /></div>
                      </div>
                      <span className="text-white text-sm font-medium">@{instagramStatus?.account?.username}</span>
                    </div>
                    {instagramComposeData.mediaType === 'IMAGE' && instagramComposeData.imageUrl && (
                      <img 
                        src={instagramComposeData.imageUrl} 
                        alt="Preview" 
                        className="w-full max-h-64 object-contain rounded-lg bg-gray-900 mb-3"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    )}
                    {(instagramComposeData.mediaType === 'VIDEO' || instagramComposeData.mediaType === 'REELS') && instagramComposeData.videoUrl && (
                      <div className="w-full h-48 bg-gray-800 rounded-lg flex items-center justify-center mb-3">
                        <Video className="w-12 h-12 text-gray-600" />
                      </div>
                    )}
                    <p className="text-white text-sm whitespace-pre-wrap">
                      {instagramComposeData.caption || 'Your caption will appear here...'}
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end gap-3 p-4 border-t border-gray-700">
              <button
                onClick={() => setShowInstagramComposeModal(false)}
                className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
              >
                Cancel
              </button>
              <button
                data-testid="publish-instagram-post-btn"
                onClick={publishInstagramPost}
                disabled={instagramPublishing || !instagramComposeData.caption.trim() || (!instagramComposeData.imageUrl && !instagramComposeData.videoUrl)}
                className="flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 disabled:from-gray-600 disabled:to-gray-700 disabled:cursor-not-allowed rounded-lg text-white text-sm font-medium transition-all"
              >
                {instagramPublishing ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    Publishing...
                  </>
                ) : (
                  <>
                    <Send className="w-4 h-4" />
                    Publish Now
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Facebook Tab Content */}
      {activeTab === 'facebook' && (
        <div data-testid="facebook-tab-content">
          {/* Personal Profile Card */}
          {facebookStatus?.personal_profile?.connected && (
            <div className="bg-black border border-gray-400 rounded-xl p-6 mb-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  {facebookStatus.personal_profile?.picture_url ? (
                    <img 
                      src={facebookStatus.personal_profile.picture_url} 
                      alt="Profile"
                      className="w-14 h-14 rounded-full object-cover border-2 border-blue-500"
                    />
                  ) : (
                    <div className="w-14 h-14 rounded-full bg-blue-600 flex items-center justify-center">
                      <FacebookIcon />
                    </div>
                  )}
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="text-lg font-bold text-white">{facebookStatus.personal_profile?.name}</h3>
                      <CheckCircle className="w-4 h-4 text-green-500" />
                      <span className="px-2 py-0.5 bg-gray-700 rounded text-xs text-gray-300">Personal</span>
                    </div>
                    <p className="text-gray-400 text-sm">
                      {facebookStatus.personal_profile?.friends_count || 0} friends
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="px-3 py-1 bg-yellow-500/20 text-yellow-400 rounded-full text-xs font-medium">
                    View Only
                  </span>
                  <a
                    href={`https://www.facebook.com/${facebookStatus.personal_profile?.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors"
                  >
                    <ExternalLink size={18} />
                  </a>
                </div>
              </div>
            </div>
          )}

          {/* Page Connection Card */}
          <div className="bg-black border border-gray-400 rounded-xl p-6 mb-6 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            {facebookLoading ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
                <span className="ml-3 text-gray-400">Checking connection...</span>
              </div>
            ) : facebookStatus?.page?.connected ? (
              <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  {facebookStatus.page?.picture_url ? (
                    <img 
                      src={facebookStatus.page.picture_url} 
                      alt="Page"
                      className="w-16 h-16 rounded-full object-cover border-2 border-blue-500"
                    />
                  ) : (
                    <div className="w-16 h-16 rounded-full bg-blue-600 flex items-center justify-center">
                      <FacebookIcon />
                    </div>
                  )}
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="text-xl font-bold text-white">{facebookStatus.page?.name}</h3>
                      <CheckCircle className="w-5 h-5 text-green-500" />
                      <span className="px-2 py-0.5 bg-blue-600 rounded text-xs text-white">Page</span>
                    </div>
                    <p className="text-gray-400 text-sm">{facebookStatus.page?.category || 'Facebook Page'}</p>
                    <p className="text-gray-500 text-xs mt-1">
                      {facebookStatus.page?.followers_count?.toLocaleString() || 0} followers • Can post
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => { fetchFacebookStatus(); fetchFacebookPosts(); }}
                    className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
                  >
                    <RefreshCw size={16} />
                    Refresh
                  </button>
                  <a
                    href={facebookStatus.page?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-white text-sm font-medium transition-all"
                  >
                    <ExternalLink size={16} />
                    View Page
                  </a>
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-8">
                <div className="w-20 h-20 rounded-full bg-blue-600 flex items-center justify-center mb-4">
                  <FacebookIcon />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Facebook Page Not Connected</h3>
                <p className="text-gray-400 text-center max-w-md mb-4">
                  Connect a Facebook Page to publish posts. Personal profiles are view-only.
                </p>
              </div>
            )}
          </div>

          {/* Quick Stats */}
          {facebookStatus?.connected && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              {[
                { label: 'Page Followers', value: facebookStatus.page?.followers_count || 0, icon: Users, color: 'text-blue-400' },
                { label: 'Page Likes', value: facebookStatus.page?.fan_count || 0, icon: Heart, color: 'text-red-400' },
                { label: 'Page Posts', value: facebookPosts.length, icon: Grid, color: 'text-green-400' },
                { label: 'Friends', value: facebookStatus.personal_profile?.friends_count || 0, icon: Users, color: 'text-purple-400' },
              ].map((stat, idx) => {
                const IconComponent = stat.icon;
                return (
                  <div 
                    key={idx}
                    className="bg-black border border-gray-400 rounded-xl p-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300"
                  >
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-lg bg-white/5 ${stat.color}`}>
                        <IconComponent size={20} />
                      </div>
                      <div>
                        <div className="text-2xl font-bold text-white">
                          {stat.value.toLocaleString()}
                        </div>
                        <div className="text-xs text-gray-400">{stat.label}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Recent Posts */}
          {facebookStatus?.connected && (
            <div className="bg-black border border-gray-400 rounded-xl p-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                  <Grid className="w-5 h-5 text-blue-400" />
                  Recent Posts
                </h3>
                <button
                  onClick={fetchFacebookPosts}
                  disabled={facebookPostsLoading}
                  className="text-sm text-gray-400 hover:text-white flex items-center gap-1"
                >
                  {facebookPostsLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw size={14} />}
                  Refresh
                </button>
              </div>

              {facebookPostsLoading ? (
                <div className="flex items-center justify-center py-12">
                  <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
                  <span className="ml-3 text-gray-400">Loading posts...</span>
                </div>
              ) : facebookPosts.length > 0 ? (
                <div className="space-y-4">
                  {facebookPosts.map((post) => (
                    <div 
                      key={post.id}
                      className="bg-gray-900 rounded-xl p-4 border border-gray-700 hover:border-gray-600 transition-all"
                    >
                      <div className="flex gap-4">
                        {post.image_url && (
                          <img 
                            src={post.image_url} 
                            alt="Post"
                            className="w-24 h-24 rounded-lg object-cover flex-shrink-0"
                          />
                        )}
                        <div className="flex-1 min-w-0">
                          <p className="text-white text-sm line-clamp-3 mb-2">
                            {post.message || 'No caption'}
                          </p>
                          <div className="flex items-center gap-4 text-xs text-gray-400">
                            <span className="flex items-center gap-1">
                              <Heart size={12} /> {post.likes || 0}
                            </span>
                            <span className="flex items-center gap-1">
                              <MessageCircle size={12} /> {post.comments || 0}
                            </span>
                            <span className="flex items-center gap-1">
                              <Share2 size={12} /> {post.shares || 0}
                            </span>
                            <span>
                              {new Date(post.created_time).toLocaleDateString()}
                            </span>
                          </div>
                        </div>
                        <a 
                          href={post.permalink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-400 hover:text-blue-300 flex-shrink-0"
                        >
                          <ExternalLink size={18} />
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-12">
                  <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mb-4">
                    <ImageIcon className="w-8 h-8 text-gray-600" />
                  </div>
                  <p className="text-gray-400 text-center">No posts found</p>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* TikTok Tab Content */}
      {activeTab === 'tiktok' && (
        <div data-testid="tiktok-tab-content">
          {/* Connection Status Card */}
          <div className="bg-black border border-gray-400 rounded-xl p-6 mb-6 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            {tiktokLoading ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="w-8 h-8 animate-spin text-white" />
                <span className="ml-3 text-gray-400">Checking connection...</span>
              </div>
            ) : tiktokStatus?.connected ? (
              <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  {tiktokStatus.account?.profile_picture ? (
                    <img 
                      src={tiktokStatus.account.profile_picture} 
                      alt="Profile"
                      className="w-16 h-16 rounded-full object-cover border-2 border-white"
                    />
                  ) : (
                    <div className="w-16 h-16 rounded-full bg-black border-2 border-white flex items-center justify-center">
                      <TikTokIcon />
                    </div>
                  )}
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="text-xl font-bold text-white">
                        @{tiktokStatus.account?.username || tiktokStatus.account?.name || 'TikTok Account'}
                      </h3>
                      <CheckCircle className="w-5 h-5 text-green-500" />
                    </div>
                    <p className="text-gray-400 text-sm">Connected via Outstand.so</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <button
                    data-testid="refresh-tiktok-btn"
                    onClick={fetchTiktokStatus}
                    className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
                  >
                    <RefreshCw size={16} />
                    Refresh
                  </button>
                  <button
                    onClick={() => disconnectTikTok(tiktokStatus.account?.id)}
                    className="flex items-center gap-2 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 border border-red-500/50 rounded-lg text-red-400 text-sm transition-colors"
                  >
                    <X size={16} />
                    Disconnect
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-8">
                <div className="w-20 h-20 rounded-full bg-black border-2 border-white flex items-center justify-center mb-4">
                  <div className="w-10 h-10"><TikTokIcon /></div>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Connect TikTok</h3>
                <p className="text-gray-400 text-center max-w-md mb-6">
                  Connect your TikTok account via Outstand.so to manage posts, view analytics, and grow your audience.
                </p>
                <button
                  data-testid="connect-tiktok-btn"
                  onClick={connectTikTok}
                  disabled={outstandConnecting}
                  className="flex items-center gap-2 px-6 py-3 bg-white hover:bg-gray-200 rounded-lg text-black font-medium transition-all disabled:opacity-50"
                >
                  {outstandConnecting ? (
                    <>
                      <Loader2 className="w-5 h-5 animate-spin" />
                      Connecting...
                    </>
                  ) : (
                    <>
                      <div className="w-5 h-5"><TikTokIcon /></div>
                      Connect TikTok Account
                    </>
                  )}
                </button>
                <p className="text-xs text-gray-500 mt-4">
                  Powered by Outstand.so unified social media API
                </p>
              </div>
            )}
          </div>

          {/* Other Connected Social Accounts via Outstand */}
          {outstandAccounts.length > 0 && (
            <div className="bg-black border border-gray-400 rounded-xl p-6 mb-6 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
              <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                <Users className="w-5 h-5 text-cyan-400" />
                Connected Social Accounts
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {outstandAccounts.map((account) => (
                  <div
                    key={account.id}
                    className="flex items-center gap-3 p-4 bg-gray-900 rounded-xl border border-gray-700"
                  >
                    <div className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center">
                      {account.network === 'tiktok' && <div className="w-5 h-5"><TikTokIcon /></div>}
                      {account.network === 'twitter' && <div className="w-5 h-5"><XTwitterIcon /></div>}
                      {account.network === 'linkedin' && <div className="w-5 h-5"><LinkedInIcon /></div>}
                      {account.network === 'instagram' && <div className="w-5 h-5"><InstagramIcon /></div>}
                      {account.network === 'facebook' && <div className="w-5 h-5"><FacebookIcon /></div>}
                      {account.network === 'youtube' && <div className="w-5 h-5"><YouTubeIcon /></div>}
                      {account.network === 'threads' && <div className="w-5 h-5"><ThreadsIcon /></div>}
                      {!['tiktok', 'twitter', 'linkedin', 'instagram', 'facebook', 'youtube', 'threads'].includes(account.network) && (
                        <Users className="w-5 h-5 text-gray-400" />
                      )}
                    </div>
                    <div className="flex-1">
                      <p className="text-white font-medium">@{account.username || account.name}</p>
                      <p className="text-xs text-gray-400 capitalize">{account.network}</p>
                    </div>
                    <CheckCircle className="w-4 h-4 text-green-500" />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Connect More Platforms */}
          <div className="bg-black border border-gray-400 rounded-xl p-6 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
              <Plus className="w-5 h-5 text-cyan-400" />
              Connect More Platforms
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Outstand.so provides a unified API to connect and manage multiple social media platforms.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {[
                { id: 'tiktok', name: 'TikTok', icon: TikTokIcon, color: 'hover:border-white' },
                { id: 'twitter', name: 'X (Twitter)', icon: XTwitterIcon, color: 'hover:border-gray-300' },
                { id: 'linkedin', name: 'LinkedIn', icon: LinkedInIcon, color: 'hover:border-blue-400' },
                { id: 'youtube', name: 'YouTube', icon: YouTubeIcon, color: 'hover:border-red-400' },
                { id: 'threads', name: 'Threads', icon: ThreadsIcon, color: 'hover:border-gray-300' },
                { id: 'bluesky', name: 'Bluesky', icon: BlueskyIcon, color: 'hover:border-blue-400' },
                { id: 'pinterest', name: 'Pinterest', icon: PinterestIcon, color: 'hover:border-red-400' },
              ].map(platform => {
                const PlatformIcon = platform.icon;
                const isConnected = outstandAccounts.some(acc => acc.network === platform.id);
                return (
                  <button
                    key={platform.id}
                    onClick={async () => {
                      if (!isConnected) {
                        try {
                          const response = await fetch(`${API_URL}/api/outstand/auth/${platform.id}/connect`);
                          const data = await response.json();
                          if (data.success && data.auth_url) {
                            window.location.href = data.auth_url;
                          } else {
                            toast.error(data.error || `Failed to connect ${platform.name}`);
                          }
                        } catch (error) {
                          toast.error(`Failed to connect ${platform.name}`);
                        }
                      }
                    }}
                    disabled={isConnected}
                    className={`flex items-center gap-2 p-3 bg-gray-900 border border-gray-700 rounded-xl transition-all ${platform.color} ${
                      isConnected ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                    data-testid={`connect-${platform.id}-btn`}
                  >
                    <div className="w-6 h-6"><PlatformIcon /></div>
                    <span className="text-sm text-white">{platform.name}</span>
                    {isConnected && <CheckCircle className="w-4 h-4 text-green-500 ml-auto" />}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Posts Tab Content */}
      {activeTab === 'posts' && (
        <>
          {/* Quick Stats - Above Content Calendar Header */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-4">
            {(() => {
              // Filter posts based on selected platforms for stats, excluding expired scheduled posts
              const activePosts = posts.filter(post => !isScheduledPostExpired(post));
              const filteredPosts = selectedPlatforms.includes('all') 
                ? activePosts 
                : activePosts.filter(post => {
                    const postPlatforms = post.selectedPlatforms || [post.platform];
                    return postPlatforms.some(p => selectedPlatforms.includes(p) || 
                      (p === 'x' && selectedPlatforms.includes('twitter')) ||
                      (p === 'twitter' && selectedPlatforms.includes('x')));
                  });
              
              return [
                { label: 'Scheduled', value: filteredPosts.filter(p => p.status === 'scheduled').length, icon: Calendar, color: 'text-blue-400' },
                { label: 'Drafts', value: filteredPosts.filter(p => p.status === 'draft').length, icon: FileText, color: 'text-yellow-400' },
                { label: 'This Week', value: filteredPosts.length, icon: Clock, color: 'text-green-400' },
                { label: 'Platforms', value: new Set(filteredPosts.map(p => p.platform)).size, icon: Share2, color: 'text-purple-400' },
              ].map((stat, idx) => {
                const IconComponent = stat.icon;
                return (
                  <div 
                    key={idx}
                    className="bg-black border border-gray-400 rounded-xl p-3 md:p-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300"
                  >
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-lg bg-white/5 ${stat.color}`}>
                        <IconComponent size={20} />
                      </div>
                      <div>
                        <div className="text-2xl font-bold">{stat.value}</div>
                        <div className="text-xs text-gray-400">{stat.label}</div>
                      </div>
                    </div>
                  </div>
                );
              });
            })()}
          </div>

          {/* Header with Create Post Button */}
          <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-xl flex items-center justify-center">
                  <Calendar className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-white">Content Calendar</h2>
                  <p className="text-sm text-gray-400">Schedule and manage your social media posts</p>
                </div>
              </div>
              <button
                data-testid="create-post-btn"
                onClick={() => openCreatePostModal()}
                className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 rounded-lg text-white font-medium transition-all shadow-lg hover:shadow-cyan-500/25"
              >
                <Plus size={18} />
                Create Post
              </button>
            </div>
          </div>

          {/* Platform Selection Bar */}
          <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            <div className="flex flex-wrap items-center gap-3">
              {platforms.map((platform) => {
                const IconComponent = platform.icon;
                const isSelected = selectedPlatforms.includes(platform.id) || selectedPlatforms.includes('all');
                // Check if platform is connected via Upload-Post
                const isUploadPostConnected = uploadPostAccounts.some(acc => 
                  acc.platform === platform.id || 
                  (platform.id === 'twitter' && acc.platform === 'x')
                );
                const isInstagramConnected = platform.id === 'instagram' && instagramStatus?.connected;
                const isFacebookConnected = platform.id === 'facebook' && facebookStatus?.connected;
                const isConnected = isUploadPostConnected || isInstagramConnected || isFacebookConnected;
                
                return (
                  <button
                    key={platform.id}
                    onClick={() => togglePlatform(platform.id)}
                    className={`relative p-2 rounded-lg transition-all duration-200 ${
                      isSelected 
                        ? `${platform.color} bg-white/10 border border-white/30` 
                        : 'text-gray-500 hover:text-gray-300 hover:bg-white/5'
                    }`}
                    title={`${platform.name}${isConnected ? ' (Connected)' : ''}`}
                  >
                    <IconComponent />
                    {isConnected && (
                      <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-green-500 rounded-full border border-black" />
                    )}
                  </button>
                );
              })}
            </div>
            {/* Connected accounts summary */}
            {uploadPostAccounts.length > 0 && (
              <div className="mt-3 pt-3 border-t border-gray-700 flex items-center gap-2 text-xs text-gray-400">
                <span>Connected via Upload-Post:</span>
                {uploadPostAccounts.map((acc) => (
                  <span key={acc.platform} className="flex items-center gap-1 px-2 py-0.5 bg-gray-800 rounded-full">
                    <CheckCircle size={10} className="text-green-500" />
                    @{acc.friendly_name || acc.display_name}
                  </span>
                ))}
              </div>
            )}
          </div>

          {/* Filters and Controls */}
          <div className="bg-black border border-gray-400 rounded-xl p-3 md:p-4 mb-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            <div className="flex flex-col gap-3 md:gap-4">
              {/* Search - Full width on mobile */}
              <div className="relative w-full md:max-w-md">
                <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search posts..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full bg-black border border-gray-600 rounded-lg pl-9 pr-4 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-gray-400"
                />
              </div>

              {/* Filters row with categories - combined container */}
              <div className="flex flex-col gap-3">
                {/* Top row: Filters, Date nav, View mode */}
                <div className="flex flex-wrap items-center gap-2">
                  <select className="flex-shrink-0 bg-black border border-gray-600 rounded-lg px-3 py-1.5 text-sm text-white focus:outline-none focus:border-gray-400">
                    <option value="all">All Posts</option>
                    <option value="scheduled">Scheduled</option>
                    <option value="draft">Drafts</option>
                    <option value="published">Published</option>
                  </select>
                  
                  <select className="flex-shrink-0 bg-black border border-gray-600 rounded-lg px-3 py-1.5 text-sm text-white focus:outline-none focus:border-gray-400 hidden sm:block">
                    <option value="all">All Members</option>
                    <option value="darren">Darren Woodson</option>
                  </select>

                  {/* View mode toggle */}
                  <div className="flex bg-black border border-gray-600 rounded-lg overflow-hidden">
                    {['Feed', 'Daily', 'Weekly', 'Monthly'].map((mode) => (
                      <button
                        key={mode}
                        onClick={() => setViewMode(mode.toLowerCase())}
                        className={`px-2 md:px-3 py-1.5 text-xs md:text-sm font-medium transition-colors ${
                          viewMode === mode.toLowerCase()
                            ? 'bg-white text-black'
                            : 'text-gray-400 hover:text-white hover:bg-white/10'
                        }`}
                      >
                        {mode}
                      </button>
                    ))}
                  </div>

                  {/* Date navigation - pushed to right */}
                  <div className="flex items-center gap-1 ml-auto flex-shrink-0">
                    <button 
                      onClick={() => navigateWeek(-1)}
                      className="p-1.5 hover:bg-white/10 rounded-lg transition-colors"
                    >
                      <ChevronLeft size={16} />
                    </button>
                    <span className="text-xs md:text-sm font-medium whitespace-nowrap min-w-[90px] md:min-w-[110px] text-center">
                      {getDateRange()}
                    </span>
                    <button 
                      onClick={() => navigateWeek(1)}
                      className="p-1.5 hover:bg-white/10 rounded-lg transition-colors"
                    >
                      <ChevronRight size={16} />
                    </button>
                  </div>
                </div>

                {/* Bottom row: Category filters */}
                <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide -mx-3 px-3 md:mx-0 md:px-0 pt-2 border-t border-gray-700">
                  <Filter size={16} className="text-gray-400 flex-shrink-0" />
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => toggleCategory(category.id)}
                      className={`flex-shrink-0 px-3 py-1 md:px-4 md:py-1.5 rounded-full text-xs md:text-sm font-medium transition-all whitespace-nowrap ${
                        selectedCategories.includes(category.id)
                          ? `${category.color} text-white`
                          : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white'
                      }`}
                    >
                      {category.name}
                    </button>
                  ))}
                  <button
                    onClick={() => setShowCategoryEditor(true)}
                    className="flex-shrink-0 px-3 py-1 md:px-4 md:py-1.5 rounded-full text-xs md:text-sm font-medium bg-gray-800/50 text-gray-400 hover:bg-gray-700 hover:text-white transition-all whitespace-nowrap flex items-center gap-1"
                  >
                    <Settings size={14} />
                    <span className="hidden sm:inline">Edit</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* View Content Based on viewMode */}

          {/* Category Editor Modal */}
          {showCategoryEditor && (
            <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 z-50" onClick={() => setShowCategoryEditor(false)}>
              <div 
                className="bg-gray-900 border border-gray-700 rounded-2xl w-full max-w-md p-6"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-xl font-bold text-white">Edit Categories</h3>
                  <button 
                    onClick={() => setShowCategoryEditor(false)}
                    className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                  >
                    <X size={20} />
                  </button>
                </div>

                {/* Existing Categories */}
                <div className="space-y-2 mb-6 max-h-64 overflow-y-auto">
                  {categories.map((category) => (
                    <div 
                      key={category.id}
                      className="flex items-center gap-3 p-3 bg-gray-800 rounded-lg group"
                    >
                      <div className={`w-4 h-4 rounded-full ${category.color}`} />
                      <span className="flex-1 text-white">{category.name}</span>
                      <button
                        onClick={() => {
                          setEditingCategory(category);
                          setNewCategoryName(category.name);
                          setNewCategoryColor(category.color);
                        }}
                        className="p-1.5 hover:bg-gray-700 rounded transition-colors opacity-0 group-hover:opacity-100"
                        data-testid={`edit-category-${category.id}`}
                      >
                        <Edit3 size={14} className="text-gray-400" />
                      </button>
                      <button
                        onClick={() => deleteCategory(category.id)}
                        className="p-1.5 hover:bg-red-500/20 rounded transition-colors opacity-0 group-hover:opacity-100"
                        data-testid={`delete-category-${category.id}`}
                      >
                        <Trash2 size={14} className="text-red-400" />
                      </button>
                    </div>
                  ))}
                </div>

                {/* Add/Edit Category Form */}
                <div className="border-t border-gray-700 pt-4">
                  <h4 className="text-sm font-medium text-gray-400 mb-3">
                    {editingCategory ? 'Edit Category' : 'Add New Category'}
                  </h4>
                  <div className="space-y-3">
                    <input
                      type="text"
                      value={newCategoryName}
                      onChange={(e) => setNewCategoryName(e.target.value)}
                      placeholder="Category name"
                      className="w-full bg-gray-800 border border-gray-600 rounded-lg px-4 py-2 text-white placeholder-gray-500 focus:outline-none focus:border-gray-400"
                      data-testid="category-name-input"
                    />
                    <div className="flex flex-wrap gap-2">
                      {(availableColors.length > 0 ? availableColors : [
                        'bg-purple-600', 'bg-pink-500', 'bg-blue-500', 'bg-green-500',
                        'bg-red-500', 'bg-yellow-500', 'bg-indigo-500', 'bg-cyan-500',
                        'bg-orange-500', 'bg-teal-500'
                      ]).map((color) => (
                        <button
                          key={color}
                          onClick={() => setNewCategoryColor(color)}
                          className={`w-8 h-8 rounded-full ${color} ${
                            newCategoryColor === color ? 'ring-2 ring-white ring-offset-2 ring-offset-gray-900' : ''
                          } transition-all`}
                          data-testid={`color-${color}`}
                        />
                      ))}
                    </div>
                    <div className="flex gap-2">
                      {editingCategory && (
                        <button
                          onClick={() => {
                            setEditingCategory(null);
                            setNewCategoryName('');
                            setNewCategoryColor('bg-purple-600');
                          }}
                          className="flex-1 px-4 py-2 bg-gray-800 text-gray-300 rounded-lg hover:bg-gray-700 transition-colors"
                        >
                          Cancel
                        </button>
                      )}
                      <button
                        onClick={saveCategory}
                        disabled={!newCategoryName.trim()}
                        className="flex-1 px-4 py-2 bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        data-testid="save-category-btn"
                      >
                        {editingCategory ? 'Update' : 'Add Category'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* View Content Based on viewMode */}
          {viewMode === 'feed' && (
            /* Feed View - All posts as a scrollable list sorted by date */
            <div className="bg-black border border-gray-400 rounded-xl p-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
              <div className="space-y-4 max-h-[800px] overflow-y-auto">
                {posts
                  .filter(post => {
                    // Filter out expired scheduled posts
                    if (isScheduledPostExpired(post)) return false;
                    // Filter by category
                    if (selectedCategories.length === 0) return true;
                    return selectedCategories.includes(post.category);
                  })
                  .sort((a, b) => {
                    const dateA = new Date(`${a.date}T${a.time || '00:00'}`);
                    const dateB = new Date(`${b.date}T${b.time || '00:00'}`);
                    return dateB - dateA; // Most recent first
                  })
                  .map((post) => {
                    const category = categories.find(c => c.id === post.category);
                    const postPlatforms = post.selectedPlatforms || [post.platform];
                    const statusDisplay = getStatusDisplay(post.status);
                    return (
                      <div 
                        key={post.id}
                        onClick={() => openEditPostModal(post)}
                        className="bg-gray-900 border border-gray-700 rounded-xl p-4 hover:border-gray-500 hover:shadow-[0_0_15px_rgba(156,163,175,0.2)] transition-all duration-200 cursor-pointer flex gap-4"
                        data-testid={`feed-post-${post.id}`}
                      >
                        {/* Media thumbnail */}
                        {post.image && (
                          <div className="relative w-32 h-32 flex-shrink-0 rounded-lg overflow-hidden">
                            {post.mediaType === 'video' ? (
                              <>
                                <video src={post.image} className="w-full h-full object-cover" preload="metadata" muted />
                                <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                                  <Play size={32} className="text-white" />
                                </div>
                              </>
                            ) : (
                              <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
                            )}
                          </div>
                        )}
                        
                        {/* Post content */}
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center justify-between mb-2">
                            <div className="flex items-center gap-2">
                              {postPlatforms.map((platformId) => {
                                const platform = platforms.find(p => p.id === platformId || (platformId === 'x' && p.id === 'twitter'));
                                return platform ? (
                                  <span key={platformId} className={platform.color} title={platform.name}>
                                    {React.createElement(platform.icon, { size: 18 })}
                                  </span>
                                ) : null;
                              })}
                            </div>
                            <span className={`text-xs px-2 py-1 rounded-full flex items-center gap-1 ${statusDisplay.className}`}>
                              {statusDisplay.icon}
                              {statusDisplay.label}
                            </span>
                          </div>
                          
                          <h3 className="text-lg font-semibold text-white mb-1 truncate">{post.title}</h3>
                          <p className="text-sm text-gray-400 line-clamp-2 mb-3">{post.description}</p>
                          
                          <div className="flex items-center gap-4 text-sm text-gray-500">
                            <div className="flex items-center gap-1">
                              <Calendar size={14} />
                              <span>{new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                            </div>
                            <div className="flex items-center gap-1">
                              <Clock size={14} />
                              <span>{formatTimeToCST(post.time)}</span>
                            </div>
                            {category && (
                              <span className={`text-xs px-2 py-0.5 rounded-full ${category.color} text-white`}>
                                {category.name}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {posts.filter(post => !isScheduledPostExpired(post) && (selectedCategories.length === 0 || selectedCategories.includes(post.category))).length === 0 && (
                  <div className="text-center py-12 text-gray-500">
                    <FileText size={48} className="mx-auto mb-4 opacity-50" />
                    <p>No posts found</p>
                    <p className="text-sm">Create a new post to get started</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {viewMode === 'daily' && (
            /* Daily View - Single day with hourly breakdown */
            <div className="bg-black border border-gray-400 rounded-xl overflow-hidden hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
              {/* Day header */}
              <div className="p-4 border-b border-gray-700 flex items-center justify-between">
                <button 
                  onClick={() => setCurrentWeekStart(new Date(currentWeekStart.getTime() - 24 * 60 * 60 * 1000))}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <ChevronLeft size={20} />
                </button>
                <div className="text-center">
                  <div className="text-2xl font-bold">{currentWeekStart.toLocaleDateString('en-US', { weekday: 'long' })}</div>
                  <div className="text-gray-400">{currentWeekStart.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</div>
                </div>
                <button 
                  onClick={() => setCurrentWeekStart(new Date(currentWeekStart.getTime() + 24 * 60 * 60 * 1000))}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <ChevronRight size={20} />
                </button>
              </div>
              
              {/* Hourly timeline */}
              <div className="max-h-[700px] overflow-y-auto">
                {Array.from({ length: 24 }, (_, hour) => {
                  const timeStr = `${hour.toString().padStart(2, '0')}:00`;
                  const hourPosts = posts.filter(post => {
                    // Filter out expired scheduled posts
                    if (isScheduledPostExpired(post)) return false;
                    const postDate = new Date(post.date);
                    const isToday = postDate.toDateString() === currentWeekStart.toDateString();
                    const postHour = parseInt(post.time?.split(':')[0] || '0');
                    return isToday && postHour === hour;
                  });
                  
                  return (
                    <div key={hour} className="flex border-b border-gray-800 min-h-[60px]">
                      <div className="w-20 p-3 text-sm text-gray-500 border-r border-gray-800 flex-shrink-0">
                        {formatTimeToCST(timeStr)}
                      </div>
                      <div className="flex-1 p-2">
                        {hourPosts.map((post) => {
                          const postPlatforms = post.selectedPlatforms || [post.platform];
                          const statusDisplay = getStatusDisplay(post.status);
                          return (
                            <div 
                              key={post.id}
                              onClick={() => openEditPostModal(post)}
                              className="bg-gray-900 border border-gray-700 rounded-lg p-3 mb-2 hover:border-gray-500 cursor-pointer transition-all"
                            >
                              <div className="flex items-center gap-2 mb-1">
                                {postPlatforms.map((platformId) => {
                                  const platform = platforms.find(p => p.id === platformId || (platformId === 'x' && p.id === 'twitter'));
                                  return platform ? (
                                    <span key={platformId} className={platform.color}>
                                      {React.createElement(platform.icon, { size: 14 })}
                                    </span>
                                  ) : null;
                                })}
                                <span className="text-white font-medium truncate flex-1">{post.title}</span>
                                <span className={`text-[10px] px-2 py-0.5 rounded-full ${statusDisplay.className}`}>
                                  {statusDisplay.label}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {viewMode === 'weekly' && (
            /* Weekly View - Calendar Grid */
            <div className="bg-black border border-gray-400 rounded-xl overflow-hidden hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            {/* Desktop: Full week view */}
            <div className="hidden md:block">
              <div className="grid grid-cols-7 border-b border-gray-700">
                {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day, idx) => (
                  <div key={day} className="p-3 text-center border-r border-gray-700 last:border-r-0">
                    <div className="text-xs text-gray-500 uppercase tracking-wider">{day}</div>
                    <div className="text-lg font-bold mt-1">{formatDate(daysOfWeek[idx])}</div>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-7 min-h-[700px]">
                {daysOfWeek.map((day, dayIdx) => {
                  const postsForDay = getPostsForDay(day);
                  const isToday = day.toDateString() === new Date().toDateString();
                  
                  return (
                    <div 
                      key={dayIdx} 
                      className={`border-r border-gray-700 last:border-r-0 p-2 min-h-[700px] ${isToday ? 'bg-white/5' : ''}`}
                    >
                      <div className="space-y-2">
                        {postsForDay.length > 0 ? (
                          postsForDay.map((post) => {
                            const category = categories.find(c => c.id === post.category);
                            const postPlatforms = post.selectedPlatforms || [post.platform];
                            return (
                              <div 
                                key={post.id}
                                onClick={() => openEditPostModal(post)}
                                className="bg-gray-900 border border-gray-700 rounded-lg p-2 hover:border-gray-500 hover:shadow-[0_0_15px_rgba(156,163,175,0.2)] transition-all duration-200 cursor-pointer group"
                                data-testid={`post-card-${post.id}`}
                              >
                                <div className="flex items-center justify-between mb-2">
                                  <div className="flex items-center gap-1">
                                    {postPlatforms.map((platformId) => {
                                      const platform = platforms.find(p => p.id === platformId || (platformId === 'x' && p.id === 'twitter'));
                                      return platform ? (
                                        <span key={platformId} className={platform.color} title={platform.name}>
                                          {React.createElement(platform.icon, { size: 14 })}
                                        </span>
                                      ) : null;
                                    })}
                                  </div>
                                  <div className="flex items-center gap-1 text-xs text-gray-400">
                                    <Clock size={12} />
                                    <span>{formatTimeToCST(post.time)}</span>
                                  </div>
                                </div>

                                {post.image && (
                                  <div className="relative mb-2 rounded-lg overflow-hidden">
                                    {post.mediaType === 'video' ? (
                                      <video 
                                        src={post.image} 
                                        className="w-full h-24 object-cover"
                                        preload="metadata"
                                        muted
                                      />
                                    ) : (
                                      <img 
                                        src={post.image} 
                                        alt={post.title}
                                        className="w-full h-24 object-cover"
                                      />
                                    )}
                                    {post.mediaType === 'video' && (
                                      <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                                        <Play size={24} className="text-white" />
                                      </div>
                                    )}
                                  </div>
                                )}

                                <h4 className="text-xs font-semibold text-white truncate mb-1">
                                  {post.title}
                                </h4>
                                <p className="text-[10px] text-gray-400 line-clamp-2">
                                  {post.description}
                                </p>

                                <div className="flex items-center justify-between mt-2 pt-2 border-t border-gray-700">
                                  {category && (
                                    <span className={`text-[10px] px-2 py-0.5 rounded-full ${category.color} text-white`}>
                                      {category.name}
                                    </span>
                                  )}
                                  {(() => {
                                    const statusDisplay = getStatusDisplay(post.status);
                                    return (
                                      <span className={`text-[10px] px-2 py-0.5 rounded-full flex items-center gap-1 ${statusDisplay.className}`}>
                                        {statusDisplay.icon}
                                        {statusDisplay.label}
                                      </span>
                                    );
                                  })()}
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="text-center py-4 opacity-30">
                            <Plus size={20} className="mx-auto text-gray-500 mb-1" />
                            <p className="text-[10px] text-gray-500">No posts</p>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Mobile: Scrollable horizontal or list view */}
            <div className="md:hidden">
              {/* Day selector - horizontal scroll */}
              <div className="flex overflow-x-auto scrollbar-hide border-b border-gray-700">
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, idx) => {
                  const isToday = daysOfWeek[idx]?.toDateString() === new Date().toDateString();
                  const postsCount = getPostsForDay(daysOfWeek[idx]).length;
                  return (
                    <div 
                      key={day} 
                      className={`flex-shrink-0 w-[14.28%] min-w-[52px] p-2 text-center border-r border-gray-700 last:border-r-0 ${isToday ? 'bg-cyan-500/10' : ''}`}
                    >
                      <div className="text-[10px] text-gray-500 uppercase">{day}</div>
                      <div className={`text-sm font-bold mt-0.5 ${isToday ? 'text-cyan-400' : ''}`}>
                        {formatDate(daysOfWeek[idx])}
                      </div>
                      {postsCount > 0 && (
                        <div className="text-[10px] text-cyan-400 mt-0.5">{postsCount} post{postsCount > 1 ? 's' : ''}</div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Posts list for mobile */}
              <div className="p-3 space-y-3 max-h-[60vh] overflow-y-auto">
                {daysOfWeek.map((day, dayIdx) => {
                  const postsForDay = getPostsForDay(day);
                  if (postsForDay.length === 0) return null;
                  
                  return (
                    <div key={dayIdx}>
                      <div className="text-xs text-gray-500 mb-2 font-medium">
                        {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][dayIdx]} - {formatDate(day)}
                      </div>
                      <div className="space-y-2">
                        {postsForDay.map((post) => {
                          const category = categories.find(c => c.id === post.category);
                          const postPlatforms = post.selectedPlatforms || [post.platform];
                          return (
                            <div 
                              key={post.id}
                              onClick={() => openEditPostModal(post)}
                              className="bg-gray-900 border border-gray-700 rounded-lg p-3 flex gap-3 cursor-pointer active:bg-gray-800"
                              data-testid={`mobile-post-card-${post.id}`}
                            >
                              {post.image && (
                                <div className="relative w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
                                  {post.mediaType === 'video' ? (
                                    <video 
                                      src={post.image} 
                                      className="w-full h-full object-cover"
                                      preload="metadata"
                                      muted
                                    />
                                  ) : (
                                    <img 
                                      src={post.image} 
                                      alt={post.title}
                                      className="w-full h-full object-cover"
                                    />
                                  )}
                                  {post.mediaType === 'video' && (
                                    <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                                      <Play size={16} className="text-white" />
                                    </div>
                                  )}
                                </div>
                              )}
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 mb-1">
                                  <div className="flex items-center gap-1">
                                    {postPlatforms.map((platformId) => {
                                      const platform = platforms.find(p => p.id === platformId || (platformId === 'x' && p.id === 'twitter'));
                                      return platform ? (
                                        <span key={platformId} className={platform.color} title={platform.name}>
                                          {React.createElement(platform.icon, { size: 14 })}
                                        </span>
                                      ) : null;
                                    })}
                                  </div>
                                  <span className="text-xs text-gray-400">{formatTimeToCST(post.time)}</span>
                                  {(() => {
                                    const statusDisplay = getStatusDisplay(post.status);
                                    return (
                                      <span className={`text-[10px] px-1.5 py-0.5 rounded-full ml-auto flex items-center gap-1 ${statusDisplay.className}`}>
                                        {statusDisplay.icon}
                                        {statusDisplay.label}
                                      </span>
                                    );
                                  })()}
                                </div>
                                <h4 className="text-sm font-medium text-white truncate">{post.title}</h4>
                                <p className="text-xs text-gray-400 line-clamp-1">{post.description}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
                {posts.length === 0 && (
                  <div className="text-center py-8">
                    <Plus size={32} className="mx-auto text-gray-600 mb-2" />
                    <p className="text-gray-500 text-sm">No posts scheduled</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          )}

          {viewMode === 'monthly' && (
            /* Monthly View - Full month calendar */
            <div className="bg-black border border-gray-400 rounded-xl overflow-hidden hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
              {/* Month header */}
              <div className="p-4 border-b border-gray-700 flex items-center justify-between">
                <button 
                  onClick={() => {
                    const newDate = new Date(currentWeekStart);
                    newDate.setMonth(newDate.getMonth() - 1);
                    setCurrentWeekStart(newDate);
                  }}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <ChevronLeft size={20} />
                </button>
                <div className="text-xl font-bold">
                  {currentWeekStart.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                </div>
                <button 
                  onClick={() => {
                    const newDate = new Date(currentWeekStart);
                    newDate.setMonth(newDate.getMonth() + 1);
                    setCurrentWeekStart(newDate);
                  }}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <ChevronRight size={20} />
                </button>
              </div>

              {/* Day headers */}
              <div className="grid grid-cols-7 border-b border-gray-700">
                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                  <div key={day} className="p-2 text-center text-xs text-gray-500 font-medium">
                    {day}
                  </div>
                ))}
              </div>

              {/* Calendar grid */}
              <div className="grid grid-cols-7">
                {(() => {
                  const year = currentWeekStart.getFullYear();
                  const month = currentWeekStart.getMonth();
                  const firstDay = new Date(year, month, 1);
                  const lastDay = new Date(year, month + 1, 0);
                  const startPadding = firstDay.getDay(); // 0 = Sunday
                  const daysInMonth = lastDay.getDate();
                  const totalCells = Math.ceil((startPadding + daysInMonth) / 7) * 7;
                  
                  return Array.from({ length: totalCells }, (_, i) => {
                    const dayNum = i - startPadding + 1;
                    const isCurrentMonth = dayNum > 0 && dayNum <= daysInMonth;
                    const date = new Date(year, month, dayNum);
                    const isToday = date.toDateString() === new Date().toDateString();
                    
                    const dayPosts = isCurrentMonth ? posts.filter(post => {
                      // Filter out expired scheduled posts
                      if (isScheduledPostExpired(post)) return false;
                      const postDate = new Date(post.date);
                      return postDate.toDateString() === date.toDateString();
                    }) : [];
                    
                    return (
                      <div 
                        key={i}
                        className={`min-h-[100px] p-2 border-b border-r border-gray-800 ${
                          !isCurrentMonth ? 'bg-gray-900/50' : isToday ? 'bg-white/5' : ''
                        }`}
                      >
                        {isCurrentMonth && (
                          <>
                            <div className={`text-sm mb-1 ${isToday ? 'text-cyan-400 font-bold' : 'text-gray-400'}`}>
                              {dayNum}
                            </div>
                            <div className="space-y-1">
                              {dayPosts.slice(0, 3).map((post) => {
                                const postPlatforms = post.selectedPlatforms || [post.platform];
                                const platform = platforms.find(p => p.id === postPlatforms[0] || (postPlatforms[0] === 'x' && p.id === 'twitter'));
                                return (
                                  <div 
                                    key={post.id}
                                    onClick={() => openEditPostModal(post)}
                                    className="text-[10px] p-1 rounded bg-gray-800 hover:bg-gray-700 cursor-pointer truncate flex items-center gap-1"
                                  >
                                    {platform && <span className={platform.color}>{React.createElement(platform.icon, { size: 10 })}</span>}
                                    <span className="truncate">{post.title}</span>
                                  </div>
                                );
                              })}
                              {dayPosts.length > 3 && (
                                <div className="text-[10px] text-gray-500 text-center">
                                  +{dayPosts.length - 3} more
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    );
                  });
                })()}
              </div>
            </div>
          )}
        </>
      )}

      {/* Layout Tab Content - Shows content grid for connected accounts */}
      {activeTab === 'layout' && (
        <>
          {/* Platform Switcher Header - Dynamically generated */}
          <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex items-center gap-2">
                <h2 className="text-lg font-bold text-white">Content Layout</h2>
                <span className="text-sm text-gray-400">({getLayoutPlatforms().length} connected)</span>
              </div>
              
              {/* Dynamic Platform Tabs */}
              <div className="flex items-center gap-2 flex-wrap">
                {getLayoutPlatforms().map((platform) => {
                  const IconComponent = platform.icon;
                  return (
                    <button
                      key={platform.id}
                      onClick={() => setLayoutPlatform(platform.id)}
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all ${
                        layoutPlatform === platform.id
                          ? `${platform.bgColor} text-white`
                          : 'bg-gray-800 text-gray-400 hover:text-white'
                      }`}
                      data-testid={`layout-${platform.id}-btn`}
                    >
                      <div className="w-5 h-5"><IconComponent /></div>
                      <span className="text-sm font-medium">{platform.name}</span>
                      <CheckCircle size={14} className="text-green-400" />
                    </button>
                  );
                })}
                
                {/* Add Account Button */}
                <button
                  onClick={() => openUploadPostConnect()}
                  className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-800 hover:bg-gray-700 text-gray-400 hover:text-white transition-all border border-dashed border-gray-600"
                  data-testid="layout-add-account-btn"
                >
                  <Plus size={16} />
                  <span className="text-sm">Add Account</span>
                </button>
              </div>
            </div>
          </div>

          {/* No Platforms Connected State */}
          {getLayoutPlatforms().length === 0 && (
            <div className="bg-black border border-gray-400 rounded-xl p-12 text-center">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center mx-auto mb-4">
                <Users className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">No Accounts Connected</h3>
              <p className="text-gray-400 mb-4">Connect your social media accounts to view your content here</p>
              <button
                onClick={() => openUploadPostConnect()}
                className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-lg text-white font-medium hover:from-cyan-600 hover:to-blue-700 transition-colors"
                data-testid="layout-connect-accounts-btn"
              >
                Connect Accounts
              </button>
            </div>
          )}

          {/* Instagram Layout View */}
          {layoutPlatform === 'instagram' && (
            <>
              {/* Instagram Header with Grid Preview Toggle */}
              <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 flex items-center justify-center">
                      <div className="w-6 h-6"><InstagramIcon /></div>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-white">
                        {instagramStatus?.connected ? `@${instagramStatus.account?.username}` : 'Instagram'}
                      </h3>
                      <p className="text-sm text-gray-400">
                        {instagramStatus?.connected ? `${instagramPosts.length} posts` : 'Not connected'}
                        {getDraftPostsForPlatform('instagram').length > 0 && (
                          <span className="text-pink-400"> • {getDraftPostsForPlatform('instagram').length} drafts</span>
                        )}
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-2">
                    {/* Preview Mode Toggle */}
                    <button
                      onClick={() => setLayoutPreviewMode(!layoutPreviewMode)}
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                        layoutPreviewMode 
                          ? 'bg-gradient-to-r from-pink-500 to-purple-600 text-white' 
                          : 'bg-gray-800 hover:bg-gray-700 text-white'
                      }`}
                      data-testid="layout-preview-mode-toggle"
                    >
                      <Move size={16} />
                      {layoutPreviewMode ? 'Exit Preview' : 'Grid Preview'}
                    </button>
                    
                    <button
                      onClick={() => { fetchInstagramStatus(); fetchInstagramPosts(); }}
                      className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
                    >
                      <RefreshCw size={16} className={instagramPostsLoading ? 'animate-spin' : ''} />
                      Refresh
                    </button>
                  </div>
                </div>
                
                {/* Preview Mode Info Banner */}
                {layoutPreviewMode && (
                  <div className="mt-4 p-3 bg-gradient-to-r from-pink-500/10 to-purple-500/10 border border-pink-500/30 rounded-lg">
                    <div className="flex items-start gap-3">
                      <Info size={18} className="text-pink-400 flex-shrink-0 mt-0.5" />
                      <div>
                        <p className="text-sm text-white font-medium">Grid Preview Mode</p>
                        <p className="text-xs text-gray-400">Drag and drop posts to see how your grid will look. Draft posts appear with a yellow border.</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Instagram Grid - with Drag & Drop in Preview Mode */}
              {instagramPostsLoading ? (
                <div className="flex items-center justify-center py-20">
                  <Loader2 className="w-8 h-8 animate-spin text-pink-500" />
                  <span className="ml-3 text-gray-400">Loading Instagram posts...</span>
                </div>
              ) : !instagramStatus?.connected && getDraftPostsForPlatform('instagram').length === 0 ? (
                <div className="bg-black border border-gray-400 rounded-xl p-12 text-center">
                  <div className="w-20 h-20 rounded-full bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 flex items-center justify-center mx-auto mb-4">
                    <div className="w-10 h-10"><InstagramIcon /></div>
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-2">Instagram Not Connected</h3>
                  <p className="text-gray-400 mb-4">Connect your Instagram account to view your content grid</p>
                  <button
                    onClick={() => setActiveTab('accounts')}
                    className="px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-600 rounded-lg text-white font-medium"
                  >
                    Go to Accounts
                  </button>
                </div>
              ) : layoutPreviewMode ? (
                /* Drag & Drop Grid Preview Mode */
                <DragDropContext onDragEnd={handleLayoutDragEnd}>
                  <Droppable droppableId="instagram-grid" direction="horizontal">
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className={`grid grid-cols-3 gap-1 md:gap-2 ${snapshot.isDraggingOver ? 'bg-pink-500/5 rounded-xl p-2' : ''}`}
                      >
                        {layoutGridOrder.map((item, index) => (
                          <Draggable key={item.id} draggableId={item.id} index={index}>
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className={`aspect-square relative overflow-hidden cursor-grab active:cursor-grabbing group ${
                                  snapshot.isDragging ? 'z-50 shadow-2xl scale-105' : ''
                                } ${item.type === 'draft' ? 'ring-2 ring-yellow-400 ring-offset-2 ring-offset-black' : ''}`}
                                data-testid={`layout-grid-item-${item.id}`}
                              >
                                {/* Draft Badge */}
                                {item.type === 'draft' && (
                                  <div className="absolute top-2 left-2 z-10 px-2 py-1 bg-yellow-500 text-black text-xs font-bold rounded">
                                    DRAFT
                                  </div>
                                )}
                                
                                {/* Drag Handle Indicator */}
                                <div className="absolute top-2 right-2 z-10 p-1 bg-black/60 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                                  <GripVertical size={16} className="text-white" />
                                </div>
                                
                                {/* Image/Content */}
                                {item.type === 'published' ? (
                                  // Published post from Instagram API
                                  item.data.media_type === 'VIDEO' ? (
                                    <img 
                                      src={item.data.thumbnail_url || item.data.media_url} 
                                      alt="Video"
                                      className="w-full h-full object-cover"
                                    />
                                  ) : (
                                    <img 
                                      src={item.data.media_url} 
                                      alt={item.data.caption?.substring(0, 30) || 'Post'}
                                      className="w-full h-full object-cover"
                                    />
                                  )
                                ) : (
                                  // Draft post - show image or placeholder
                                  item.data.image ? (
                                    item.data.mediaType === 'video' ? (
                                      <video 
                                        src={item.data.image} 
                                        className="w-full h-full object-cover"
                                        muted
                                      />
                                    ) : (
                                      <img 
                                        src={item.data.image} 
                                        alt={item.data.title || 'Draft'}
                                        className="w-full h-full object-cover"
                                      />
                                    )
                                  ) : (
                                    <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 flex flex-col items-center justify-center p-2">
                                      <FileText size={32} className="text-gray-600 mb-2" />
                                      <p className="text-xs text-gray-400 text-center line-clamp-2">{item.data.title || 'Untitled Draft'}</p>
                                    </div>
                                  )
                                )}
                                
                                {/* Hover Overlay */}
                                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center gap-2 p-2">
                                  {item.type === 'published' ? (
                                    <div className="flex items-center gap-4">
                                      <div className="flex items-center gap-1 text-white">
                                        <Heart size={18} className="fill-white" />
                                        <span className="text-sm font-semibold">{formatNumber(item.data.like_count || 0)}</span>
                                      </div>
                                      <div className="flex items-center gap-1 text-white">
                                        <MessageCircle size={18} className="fill-white" />
                                        <span className="text-sm font-semibold">{formatNumber(item.data.comments_count || 0)}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <p className="text-white text-xs text-center font-medium line-clamp-2">{item.data.title || 'Untitled'}</p>
                                      <p className="text-gray-300 text-xs">{item.data.status === 'scheduled' ? 'Scheduled' : 'Draft'}</p>
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedPost(item.data);
                                          setShowPostModal(true);
                                          setActiveTab('posts');
                                        }}
                                        className="mt-1 px-3 py-1 bg-pink-500 hover:bg-pink-600 rounded text-xs text-white font-medium"
                                      >
                                        Edit
                                      </button>
                                    </>
                                  )}
                                </div>
                                
                                {/* Position number */}
                                <div className="absolute bottom-2 left-2 w-6 h-6 bg-black/80 rounded-full flex items-center justify-center">
                                  <span className="text-xs text-white font-bold">{index + 1}</span>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              ) : (
                /* Normal Grid View (no drag and drop) */
                <>
                  {/* Draft Posts Section */}
                  {getDraftPostsForPlatform('instagram').length > 0 && (
                    <div className="mb-6">
                      <div className="flex items-center justify-between mb-3">
                        <h4 className="text-white font-semibold flex items-center gap-2">
                          <FileText size={18} className="text-yellow-400" />
                          Draft & Scheduled Posts ({getDraftPostsForPlatform('instagram').length})
                        </h4>
                        <button
                          onClick={() => setLayoutPreviewMode(true)}
                          className="text-sm text-pink-400 hover:text-pink-300 flex items-center gap-1"
                        >
                          <Move size={14} />
                          Arrange Grid
                        </button>
                      </div>
                      <div className="grid grid-cols-3 gap-1 md:gap-2">
                        {getDraftPostsForPlatform('instagram').map((post) => (
                          <div 
                            key={post.id}
                            className="aspect-square relative overflow-hidden cursor-pointer group ring-2 ring-yellow-400 ring-offset-2 ring-offset-black rounded-lg"
                            onClick={() => {
                              setSelectedPost(post);
                              setShowPostModal(true);
                            }}
                            data-testid={`draft-post-${post.id}`}
                          >
                            {/* Draft Badge */}
                            <div className="absolute top-2 left-2 z-10 px-2 py-1 bg-yellow-500 text-black text-xs font-bold rounded">
                              {post.status === 'scheduled' ? 'SCHEDULED' : 'DRAFT'}
                            </div>
                            
                            {post.image ? (
                              post.mediaType === 'video' ? (
                                <video 
                                  src={post.image} 
                                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                  muted
                                />
                              ) : (
                                <img 
                                  src={post.image} 
                                  alt={post.title || 'Draft'}
                                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                />
                              )
                            ) : (
                              <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 flex flex-col items-center justify-center p-3 group-hover:from-gray-700 group-hover:to-gray-800 transition-colors">
                                <FileText size={36} className="text-gray-600 mb-2" />
                                <p className="text-sm text-gray-400 text-center line-clamp-3">{post.title || 'Untitled Draft'}</p>
                              </div>
                            )}
                            
                            {/* Hover Overlay */}
                            <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center gap-2 p-3">
                              <p className="text-white text-sm text-center font-medium line-clamp-2">{post.title || 'Untitled'}</p>
                              <p className="text-gray-300 text-xs">{post.date} {post.time}</p>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedPost(post);
                                  setShowPostModal(true);
                                }}
                                className="mt-1 px-4 py-2 bg-pink-500 hover:bg-pink-600 rounded-lg text-sm text-white font-medium"
                              >
                                Edit Post
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {/* Published Posts Section */}
                  {instagramPosts.length > 0 && (
                    <>
                      <div className="flex items-center justify-between mb-3">
                        <h4 className="text-white font-semibold flex items-center gap-2">
                          <CheckCircle size={18} className="text-green-400" />
                          Published Posts ({instagramPosts.length})
                        </h4>
                      </div>
                      <div className="grid grid-cols-3 gap-1 md:gap-2">
                        {instagramPosts.map((post) => (
                          <div 
                            key={post.id}
                            className="aspect-square relative overflow-hidden cursor-pointer group"
                            onClick={() => setSelectedInstagramPost(post)}
                            data-testid={`instagram-post-${post.id}`}
                          >
                            {post.media_type === 'VIDEO' ? (
                              <img 
                                src={post.thumbnail_url || post.media_url} 
                                alt="Video"
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                              />
                            ) : (
                              <img 
                                src={post.media_url} 
                                alt={post.caption?.substring(0, 30) || 'Post'}
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                              />
                            )}
                            
                            {/* Overlay on hover */}
                            <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-4">
                              <div className="flex items-center gap-1 text-white">
                                <Heart size={20} className="fill-white" />
                                <span className="font-semibold">{formatNumber(post.like_count || 0)}</span>
                              </div>
                              <div className="flex items-center gap-1 text-white">
                                <MessageCircle size={20} className="fill-white" />
                                <span className="font-semibold">{formatNumber(post.comments_count || 0)}</span>
                              </div>
                            </div>
                            
                            {/* Media type indicators */}
                            {post.media_type === 'VIDEO' && (
                              <div className="absolute top-2 right-2">
                                <Video size={20} className="text-white drop-shadow-lg" />
                              </div>
                            )}
                            {post.media_type === 'CAROUSEL_ALBUM' && (
                              <div className="absolute top-2 right-2">
                                <Grid size={20} className="text-white drop-shadow-lg" />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  
                  {/* Empty State */}
                  {instagramPosts.length === 0 && getDraftPostsForPlatform('instagram').length === 0 && (
                    <div className="bg-black border border-gray-400 rounded-xl p-12 text-center">
                      <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mx-auto mb-4">
                        <ImageIcon className="w-8 h-8 text-gray-600" />
                      </div>
                      <h3 className="text-xl font-semibold text-white mb-2">No Posts Yet</h3>
                      <p className="text-gray-400 mb-4">Create draft posts to preview your Instagram grid layout</p>
                      <button
                        onClick={() => setActiveTab('posts')}
                        className="px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-600 rounded-lg text-white font-medium"
                      >
                        Create Post
                      </button>
                    </div>
                  )}
                </>
              )}

              {/* Load More */}
              {instagramNextPage && instagramPosts.length > 0 && !layoutPreviewMode && (
                <div className="flex justify-center mt-6">
                  <button
                    onClick={() => fetchInstagramPosts(true)}
                    disabled={instagramLoadingMore}
                    className="flex items-center gap-2 px-6 py-3 bg-gray-800 hover:bg-gray-700 disabled:bg-gray-900 rounded-lg text-white text-sm font-medium transition-colors"
                  >
                    {instagramLoadingMore ? (
                      <>
                        <Loader2 className="w-4 h-4 animate-spin" />
                        Loading...
                      </>
                    ) : (
                      <>
                        <ChevronDown className="w-4 h-4" />
                        Load More
                      </>
                    )}
                  </button>
                </div>
              )}
            </>
          )}

          {/* Instagram (Upload-Post) Layout View */}
          {layoutPlatform === 'instagram-uploadpost' && (
            <>
              {/* Upload-Post Instagram Header with Grid Preview Toggle */}
              <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div className="flex items-center gap-3">
                    {uploadPostAccounts.find(a => a.platform === 'instagram')?.profile_picture ? (
                      <img 
                        src={uploadPostAccounts.find(a => a.platform === 'instagram')?.profile_picture} 
                        alt="Profile"
                        className="w-12 h-12 rounded-full object-cover border-2 border-pink-500"
                      />
                    ) : (
                      <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 flex items-center justify-center">
                        <div className="w-6 h-6"><InstagramIcon /></div>
                      </div>
                    )}
                    <div>
                      <h3 className="text-lg font-bold text-white">
                        @{uploadPostAccounts.find(a => a.platform === 'instagram')?.friendly_name || 'instagram'}
                      </h3>
                      <p className="text-sm text-gray-400">
                        Personal Account • Connected via Upload-Post
                        {getDraftPostsForPlatform('instagram').length > 0 && (
                          <span className="text-pink-400"> • {getDraftPostsForPlatform('instagram').length} drafts</span>
                        )}
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-2">
                    {/* Preview Mode Toggle */}
                    {getDraftPostsForPlatform('instagram').length > 0 && (
                      <button
                        onClick={() => setLayoutPreviewMode(!layoutPreviewMode)}
                        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                          layoutPreviewMode 
                            ? 'bg-gradient-to-r from-pink-500 to-purple-600 text-white' 
                            : 'bg-gray-800 hover:bg-gray-700 text-white'
                        }`}
                        data-testid="layout-preview-mode-toggle-uploadpost"
                      >
                        <Move size={16} />
                        {layoutPreviewMode ? 'Exit Preview' : 'Grid Preview'}
                      </button>
                    )}
                    
                    <button
                      onClick={() => fetchUploadPostStatus()}
                      className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
                    >
                      <RefreshCw size={16} />
                      Refresh
                    </button>
                  </div>
                </div>
                
                {/* Preview Mode Info Banner */}
                {layoutPreviewMode && (
                  <div className="mt-4 p-3 bg-gradient-to-r from-pink-500/10 to-purple-500/10 border border-pink-500/30 rounded-lg">
                    <div className="flex items-start gap-3">
                      <Info size={18} className="text-pink-400 flex-shrink-0 mt-0.5" />
                      <div>
                        <p className="text-sm text-white font-medium">Grid Preview Mode</p>
                        <p className="text-xs text-gray-400">Drag and drop posts to see how your grid will look. Draft posts appear with a yellow border.</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Draft Posts Grid with Drag & Drop */}
              {getDraftPostsForPlatform('instagram').length > 0 ? (
                <>
                  {layoutPreviewMode ? (
                    /* Drag & Drop Grid Preview Mode */
                    <DragDropContext onDragEnd={handleLayoutDragEnd}>
                      <Droppable droppableId="instagram-uploadpost-grid" direction="horizontal">
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={`grid grid-cols-3 gap-1 md:gap-2 ${snapshot.isDraggingOver ? 'bg-pink-500/5 rounded-xl p-2' : ''}`}
                          >
                            {getDraftPostsForPlatform('instagram').map((post, index) => (
                              <Draggable key={post.id} draggableId={post.id} index={index}>
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    className={`aspect-square relative overflow-hidden cursor-grab active:cursor-grabbing group ring-2 ring-yellow-400 ring-offset-2 ring-offset-black rounded-lg ${
                                      snapshot.isDragging ? 'z-50 shadow-2xl scale-105' : ''
                                    }`}
                                    data-testid={`layout-grid-item-${post.id}`}
                                  >
                                    {/* Draft Badge */}
                                    <div className="absolute top-2 left-2 z-10 px-2 py-1 bg-yellow-500 text-black text-xs font-bold rounded">
                                      {post.status === 'scheduled' ? 'SCHEDULED' : 'DRAFT'}
                                    </div>
                                    
                                    {/* Drag Handle Indicator */}
                                    <div className="absolute top-2 right-2 z-10 p-1 bg-black/60 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                                      <GripVertical size={16} className="text-white" />
                                    </div>
                                    
                                    {/* Image/Content */}
                                    {post.image ? (
                                      post.mediaType === 'video' ? (
                                        <video 
                                          src={post.image} 
                                          className="w-full h-full object-cover"
                                          muted
                                        />
                                      ) : (
                                        <img 
                                          src={post.image} 
                                          alt={post.title || 'Draft'}
                                          className="w-full h-full object-cover"
                                        />
                                      )
                                    ) : (
                                      <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 flex flex-col items-center justify-center p-2">
                                        <FileText size={32} className="text-gray-600 mb-2" />
                                        <p className="text-xs text-gray-400 text-center line-clamp-2">{post.title || 'Untitled Draft'}</p>
                                      </div>
                                    )}
                                    
                                    {/* Hover Overlay */}
                                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center gap-2 p-2">
                                      <p className="text-white text-xs text-center font-medium line-clamp-2">{post.title || 'Untitled'}</p>
                                      <p className="text-gray-300 text-xs">{post.date} {post.time}</p>
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedPost(post);
                                          setShowPostModal(true);
                                          setActiveTab('posts');
                                        }}
                                        className="mt-1 px-3 py-1 bg-pink-500 hover:bg-pink-600 rounded text-xs text-white font-medium"
                                      >
                                        Edit
                                      </button>
                                    </div>
                                    
                                    {/* Position number */}
                                    <div className="absolute bottom-2 left-2 w-6 h-6 bg-black/80 rounded-full flex items-center justify-center">
                                      <span className="text-xs text-white font-bold">{index + 1}</span>
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  ) : (
                    /* Normal Grid View */
                    <>
                      <div className="flex items-center justify-between mb-3">
                        <h4 className="text-white font-semibold flex items-center gap-2">
                          <FileText size={18} className="text-yellow-400" />
                          Draft & Scheduled Posts ({getDraftPostsForPlatform('instagram').length})
                        </h4>
                        <button
                          onClick={() => setLayoutPreviewMode(true)}
                          className="text-sm text-pink-400 hover:text-pink-300 flex items-center gap-1"
                        >
                          <Move size={14} />
                          Arrange Grid
                        </button>
                      </div>
                      <div className="grid grid-cols-3 gap-1 md:gap-2">
                        {getDraftPostsForPlatform('instagram').map((post) => (
                          <div 
                            key={post.id}
                            className="aspect-square relative overflow-hidden cursor-pointer group ring-2 ring-yellow-400 ring-offset-2 ring-offset-black rounded-lg"
                            onClick={() => {
                              setSelectedPost(post);
                              setShowPostModal(true);
                            }}
                            data-testid={`draft-post-uploadpost-${post.id}`}
                          >
                            {/* Draft Badge */}
                            <div className="absolute top-2 left-2 z-10 px-2 py-1 bg-yellow-500 text-black text-xs font-bold rounded">
                              {post.status === 'scheduled' ? 'SCHEDULED' : 'DRAFT'}
                            </div>
                            
                            {post.image ? (
                              post.mediaType === 'video' ? (
                                <video 
                                  src={post.image} 
                                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                  muted
                                />
                              ) : (
                                <img 
                                  src={post.image} 
                                  alt={post.title || 'Draft'}
                                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                />
                              )
                            ) : (
                              <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 flex flex-col items-center justify-center p-3 group-hover:from-gray-700 group-hover:to-gray-800 transition-colors">
                                <FileText size={36} className="text-gray-600 mb-2" />
                                <p className="text-sm text-gray-400 text-center line-clamp-3">{post.title || 'Untitled Draft'}</p>
                              </div>
                            )}
                            
                            {/* Hover Overlay */}
                            <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center gap-2 p-3">
                              <p className="text-white text-sm text-center font-medium line-clamp-2">{post.title || 'Untitled'}</p>
                              <p className="text-gray-300 text-xs">{post.date} {post.time}</p>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedPost(post);
                                  setShowPostModal(true);
                                }}
                                className="mt-1 px-4 py-2 bg-pink-500 hover:bg-pink-600 rounded-lg text-sm text-white font-medium"
                              >
                                Edit Post
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </>
              ) : (
                /* Empty State - No Drafts */
                <div className="bg-black border border-gray-400 rounded-xl p-8 text-center">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 flex items-center justify-center mx-auto mb-4">
                    <div className="w-8 h-8"><InstagramIcon /></div>
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2">Plan Your Instagram Grid</h3>
                  <p className="text-gray-400 mb-4 text-sm max-w-md mx-auto">
                    Create draft posts to preview how your Instagram feed will look before publishing. 
                    Drag and drop to rearrange your content.
                  </p>
                  <div className="flex justify-center gap-3">
                    <button
                      onClick={() => setActiveTab('posts')}
                      className="px-5 py-2 bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 rounded-lg text-white text-sm font-medium transition-colors flex items-center gap-2"
                    >
                      <Plus size={14} />
                      Create Draft Post
                    </button>
                    <a
                      href={`https://instagram.com/${uploadPostAccounts.find(a => a.platform === 'instagram')?.username || ''}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-5 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm font-medium transition-colors flex items-center gap-2"
                    >
                      <ExternalLink size={14} />
                      View on Instagram
                    </a>
                  </div>
                </div>
              )}
            </>
          )}

          {/* YouTube Layout View */}
          {layoutPlatform === 'youtube' && (
            <>
              {/* YouTube Header */}
              <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-red-600 flex items-center justify-center">
                      <div className="w-6 h-6"><YouTubeIcon /></div>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-white">
                        {youtubeAnalyticsStatus?.channel?.channel_title || 
                         uploadPostAccounts.find(a => a.platform === 'youtube')?.friendly_name || 
                         'YouTube Channel'}
                      </h3>
                      <p className="text-sm text-gray-400">
                        {youtubeAnalyticsStatus?.connected 
                          ? `${youtubeVideos.length} videos` 
                          : 'Connect to view content'}
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-2">
                    {/* Sub-tabs for Videos/Playlists */}
                    <div className="flex bg-gray-900 rounded-lg p-1">
                      <button
                        onClick={() => setYoutubeLayoutSubTab('videos')}
                        className={`px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${
                          youtubeLayoutSubTab === 'videos' ? 'bg-red-600 text-white' : 'text-gray-400 hover:text-white'
                        }`}
                      >
                        Videos
                      </button>
                      <button
                        onClick={() => setYoutubeLayoutSubTab('playlists')}
                        className={`px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${
                          youtubeLayoutSubTab === 'playlists' ? 'bg-red-600 text-white' : 'text-gray-400 hover:text-white'
                        }`}
                      >
                        Playlists
                      </button>
                    </div>
                    
                    <button
                      onClick={fetchYoutubeVideos}
                      className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
                    >
                      <RefreshCw size={16} className={youtubeVideosLoading ? 'animate-spin' : ''} />
                      Refresh
                    </button>
                  </div>
                </div>
              </div>

              {/* YouTube Content */}
              {!youtubeAnalyticsStatus?.connected ? (
                <div className="bg-black border border-gray-400 rounded-xl p-12 text-center">
                  <div className="w-20 h-20 rounded-full bg-red-600 flex items-center justify-center mx-auto mb-4">
                    <div className="w-10 h-10"><YouTubeIcon /></div>
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-2">Connect YouTube Analytics</h3>
                  <p className="text-gray-400 mb-4">
                    Authorize YouTube Analytics to view your videos and playlists
                  </p>
                  <button
                    onClick={connectYoutubeAnalytics}
                    className="px-6 py-2 bg-red-600 hover:bg-red-700 rounded-lg text-white font-medium transition-colors"
                    data-testid="layout-connect-youtube-btn"
                  >
                    Connect YouTube
                  </button>
                </div>
              ) : youtubeVideosLoading ? (
                <div className="flex items-center justify-center py-20">
                  <Loader2 className="w-8 h-8 animate-spin text-red-500" />
                  <span className="ml-3 text-gray-400">Loading YouTube content...</span>
                </div>
              ) : youtubeLayoutSubTab === 'videos' ? (
                /* Videos Grid - 3 columns */
                youtubeVideos.length === 0 ? (
                  <div className="bg-black border border-gray-400 rounded-xl p-12 text-center">
                    <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mx-auto mb-4">
                      <Video className="w-8 h-8 text-gray-600" />
                    </div>
                    <h3 className="text-xl font-semibold text-white mb-2">No Videos Yet</h3>
                    <p className="text-gray-400">Your YouTube channel has no uploaded videos</p>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {youtubeVideos.map((video) => (
                      <a
                        key={video.id}
                        href={video.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-black border border-gray-400 rounded-xl overflow-hidden hover:border-red-500 hover:shadow-[0_0_20px_rgba(239,68,68,0.2)] transition-all duration-300 group"
                        data-testid={`youtube-video-${video.id}`}
                      >
                        {/* Thumbnail */}
                        <div className="relative aspect-video">
                          <img 
                            src={video.thumbnail || video.thumbnail_high} 
                            alt={video.title}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                          />
                          {/* Play button overlay */}
                          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                            <div className="w-16 h-16 rounded-full bg-red-600 flex items-center justify-center">
                              <Play size={32} className="text-white ml-1" />
                            </div>
                          </div>
                          {/* Duration badge */}
                          {video.duration && (
                            <div className="absolute bottom-2 right-2 bg-black/80 px-2 py-0.5 rounded text-xs text-white font-medium">
                              {formatDuration(video.duration)}
                            </div>
                          )}
                        </div>
                        
                        {/* Video Info */}
                        <div className="p-4">
                          <h4 className="text-white font-medium text-sm line-clamp-2 mb-2 group-hover:text-red-400 transition-colors">
                            {video.title}
                          </h4>
                          <div className="flex items-center gap-3 text-xs text-gray-400">
                            <span className="flex items-center gap-1">
                              <Eye size={12} />
                              {formatNumber(video.view_count)}
                            </span>
                            <span className="flex items-center gap-1">
                              <Heart size={12} />
                              {formatNumber(video.like_count)}
                            </span>
                            <span className="flex items-center gap-1">
                              <MessageCircle size={12} />
                              {formatNumber(video.comment_count)}
                            </span>
                          </div>
                          {video.published_at && (
                            <p className="text-xs text-gray-500 mt-2">
                              {new Date(video.published_at).toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                              })}
                            </p>
                          )}
                        </div>
                      </a>
                    ))}
                  </div>
                )
              ) : (
                /* Playlists Grid */
                youtubePlaylists.length === 0 ? (
                  <div className="bg-black border border-gray-400 rounded-xl p-12 text-center">
                    <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mx-auto mb-4">
                      <List className="w-8 h-8 text-gray-600" />
                    </div>
                    <h3 className="text-xl font-semibold text-white mb-2">No Playlists Yet</h3>
                    <p className="text-gray-400">Your YouTube channel has no playlists</p>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {youtubePlaylists.map((playlist) => (
                      <a
                        key={playlist.id}
                        href={playlist.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-black border border-gray-400 rounded-xl overflow-hidden hover:border-red-500 hover:shadow-[0_0_20px_rgba(239,68,68,0.2)] transition-all duration-300 group"
                        data-testid={`youtube-playlist-${playlist.id}`}
                      >
                        {/* Thumbnail */}
                        <div className="relative aspect-video">
                          <img 
                            src={playlist.thumbnail} 
                            alt={playlist.title}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                          />
                          {/* Playlist overlay */}
                          <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                          <div className="absolute bottom-2 right-2 bg-black/80 px-2 py-1 rounded flex items-center gap-1">
                            <List size={14} className="text-white" />
                            <span className="text-xs text-white font-medium">{playlist.video_count} videos</span>
                          </div>
                        </div>
                        
                        {/* Playlist Info */}
                        <div className="p-4">
                          <h4 className="text-white font-medium text-sm line-clamp-2 mb-2 group-hover:text-red-400 transition-colors">
                            {playlist.title}
                          </h4>
                          {playlist.description && (
                            <p className="text-xs text-gray-400 line-clamp-2 mb-2">
                              {playlist.description}
                            </p>
                          )}
                          {playlist.published_at && (
                            <p className="text-xs text-gray-500">
                              Created {new Date(playlist.published_at).toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                              })}
                            </p>
                          )}
                        </div>
                      </a>
                    ))}
                  </div>
                )
              )}
            </>
          )}

          {/* X (Twitter) Layout View */}
          {(layoutPlatform === 'x' || layoutPlatform === 'twitter') && (
            <>
              {/* X Header */}
              <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-black border border-white flex items-center justify-center">
                      <div className="w-6 h-6"><XTwitterIcon /></div>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-white">
                        @{uploadPostAccounts.find(a => a.platform === 'x' || a.platform === 'twitter')?.friendly_name || 'X Account'}
                      </h3>
                      <p className="text-sm text-gray-400">Posts and Tweets</p>
                    </div>
                  </div>
                  
                  <button
                    onClick={() => fetchUploadPostStatus()}
                    className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
                  >
                    <RefreshCw size={16} />
                    Refresh
                  </button>
                </div>
              </div>

              {/* X Content Placeholder */}
              <div className="bg-black border border-gray-400 rounded-xl p-12 text-center">
                <div className="w-20 h-20 rounded-full bg-black border-2 border-white flex items-center justify-center mx-auto mb-4">
                  <div className="w-10 h-10"><XTwitterIcon /></div>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">X (Twitter) Connected</h3>
                <p className="text-gray-400 mb-4">
                  Your X account is connected via Upload-Post. Content display coming soon!
                </p>
                <div className="flex justify-center gap-2">
                  <a
                    href={`https://x.com/${uploadPostAccounts.find(a => a.platform === 'x' || a.platform === 'twitter')?.username || ''}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-6 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors flex items-center gap-2"
                  >
                    <ExternalLink size={16} />
                    View on X
                  </a>
                </div>
              </div>
            </>
          )}

          {/* Generic Platform View (for Facebook, LinkedIn, TikTok, etc.) */}
          {layoutPlatform && 
           !['instagram', 'youtube', 'x', 'twitter'].includes(layoutPlatform) && 
           getLayoutPlatforms().some(p => p.id === layoutPlatform) && (
            <>
              {/* Platform Header */}
              {(() => {
                const platform = getLayoutPlatforms().find(p => p.id === layoutPlatform);
                const IconComponent = platform?.icon;
                return (
                  <>
                    <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div className="flex items-center gap-3">
                          <div className={`w-12 h-12 rounded-full ${platform?.bgColor || 'bg-gray-800'} flex items-center justify-center`}>
                            {IconComponent && <div className="w-6 h-6"><IconComponent /></div>}
                          </div>
                          <div>
                            <h3 className="text-lg font-bold text-white">
                              {platform?.username ? `@${platform.username}` : platform?.name}
                            </h3>
                            <p className="text-sm text-gray-400">{platform?.name} Account</p>
                          </div>
                        </div>
                        
                        <button
                          onClick={() => fetchUploadPostStatus()}
                          className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
                        >
                          <RefreshCw size={16} />
                          Refresh
                        </button>
                      </div>
                    </div>

                    {/* Generic Platform Content Placeholder */}
                    <div className={`bg-black border border-gray-400 rounded-xl p-12 text-center ${platform?.hoverShadow || ''}`}>
                      <div className={`w-20 h-20 rounded-full ${platform?.bgColor || 'bg-gray-800'} flex items-center justify-center mx-auto mb-4`}>
                        {IconComponent && <div className="w-10 h-10"><IconComponent /></div>}
                      </div>
                      <h3 className="text-xl font-semibold text-white mb-2">{platform?.name} Connected</h3>
                      <p className="text-gray-400 mb-4">
                        Your {platform?.name} account is connected via Upload-Post.
                      </p>
                      <p className="text-sm text-gray-500 mb-4">
                        Content grid display for this platform coming soon!
                      </p>
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() => setActiveTab('posts')}
                          className="px-6 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors flex items-center gap-2"
                        >
                          <Calendar size={16} />
                          Schedule Post
                        </button>
                      </div>
                    </div>
                  </>
                );
              })()}
            </>
          )}
        </>
      )}

      {/* Media Tab Content */}
      {activeTab === 'media' && (
        <>
          {/* Search and Filters Bar */}
          <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            <div className="flex flex-col lg:flex-row lg:items-center gap-4">
              {/* Search */}
              <div className="relative flex-1 max-w-md">
                <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search media..."
                  value={mediaSearch}
                  onChange={(e) => setMediaSearch(e.target.value)}
                  className="w-full bg-black border border-gray-600 rounded-lg pl-10 pr-4 py-2 text-white placeholder-gray-500 focus:outline-none focus:border-gray-400"
                />
              </div>

              {/* Filters */}
              <div className="flex flex-wrap items-center gap-3">
                <select 
                  value={mediaTypeFilter}
                  onChange={(e) => setMediaTypeFilter(e.target.value)}
                  className="bg-black border border-gray-600 rounded-lg px-4 py-2 text-white text-sm focus:outline-none focus:border-gray-400"
                >
                  <option value="all">All Types</option>
                  <option value="image">Images</option>
                  <option value="video">Videos</option>
                </select>

                <button
                  onClick={() => fetchMediaAssets()}
                  className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
                >
                  <RefreshCw size={16} />
                  Refresh
                </button>

                <button
                  data-testid="upload-media-btn"
                  onClick={() => setShowMediaUploadModal(true)}
                  className="flex items-center gap-2 px-4 py-2 bg-white text-black rounded-lg text-sm font-medium hover:bg-gray-200 transition-colors"
                >
                  <Upload size={16} />
                  Upload Media
                </button>
              </div>
            </div>
          </div>

          {/* Category Tags */}
          <div className="bg-black border border-gray-400 rounded-xl p-4 mb-6 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            <div className="flex flex-wrap items-center gap-3">
              {mediaCategories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setMediaCategory(cat.id)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${
                    mediaCategory === cat.id
                      ? 'bg-white text-black'
                      : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white'
                  }`}
                >
                  {cat.icon && <span>{cat.icon}</span>}
                  {cat.name}
                </button>
              ))}
            </div>
          </div>

          {/* Media Grid */}
          {mediaLoading ? (
            <div className="flex items-center justify-center py-20">
              <Loader2 className="w-8 h-8 animate-spin text-white" />
              <span className="ml-3 text-gray-400">Loading media...</span>
            </div>
          ) : mediaItems.length === 0 ? (
            <div className="bg-black border border-gray-400 rounded-xl p-12 text-center hover:border-gray-300 transition-all">
              <div className="w-20 h-20 rounded-full bg-gray-800 flex items-center justify-center mx-auto mb-4">
                <ImageIcon className="w-10 h-10 text-gray-600" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">No media uploaded yet</h3>
              <p className="text-gray-400 mb-6">Upload photos and videos to use in your social media posts</p>
              <button
                onClick={() => setShowMediaUploadModal(true)}
                className="flex items-center gap-2 px-6 py-3 bg-white text-black rounded-lg font-medium hover:bg-gray-200 transition-colors mx-auto"
              >
                <Upload size={18} />
                Upload Your First Media
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {/* Add Media Button */}
              <button 
                onClick={() => setShowMediaUploadModal(true)}
                className="aspect-square bg-black border-2 border-dashed border-gray-600 rounded-xl flex flex-col items-center justify-center hover:border-gray-400 hover:bg-white/5 transition-all group"
              >
                <div className="w-12 h-12 rounded-full bg-gray-800 flex items-center justify-center mb-3 group-hover:bg-gray-700 transition-colors">
                  <Plus size={24} className="text-gray-400 group-hover:text-white" />
                </div>
                <span className="text-gray-400 font-medium group-hover:text-white transition-colors">Add media</span>
              </button>

              {/* Media Items */}
              {mediaItems
                .filter(item => {
                  // Filter by search
                  if (mediaSearch && !item.name.toLowerCase().includes(mediaSearch.toLowerCase())) return false;
                  // Filter by type
                  if (mediaTypeFilter !== 'all' && item.type !== mediaTypeFilter) return false;
                  // Filter by category
                  if (mediaCategory === 'favorites' && !item.favorite) return false;
                  if (mediaCategory !== 'all' && mediaCategory !== 'favorites' && item.category !== mediaCategory) return false;
                  return true;
                })
                .map((item) => (
                  <div 
                    key={item.id}
                    data-testid={`media-item-${item.id}`}
                    className={`relative aspect-square bg-black border rounded-xl overflow-hidden cursor-pointer group transition-all duration-300 ${
                      selectedMedia.includes(item.id)
                        ? 'border-white shadow-[0_0_20px_rgba(255,255,255,0.3)]'
                        : 'border-gray-700 hover:border-gray-500 hover:shadow-[0_0_15px_rgba(156,163,175,0.2)]'
                    }`}
                    onClick={() => toggleMediaSelection(item.id)}
                  >
                    {/* Selection Circle */}
                    <div className={`absolute top-3 right-3 w-6 h-6 rounded-full border-2 flex items-center justify-center z-10 transition-all ${
                      selectedMedia.includes(item.id)
                        ? 'bg-white border-white'
                        : 'border-gray-400 bg-black/50 opacity-0 group-hover:opacity-100'
                    }`}>
                      {selectedMedia.includes(item.id) && (
                        <svg className="w-4 h-4 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                        </svg>
                      )}
                    </div>

                    {/* Favorite Star Toggle */}
                    <button
                      onClick={(e) => { e.stopPropagation(); handleToggleFavorite(item.id); }}
                      className={`absolute top-3 left-3 z-10 p-1 rounded-full transition-all ${
                        item.favorite ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
                      }`}
                    >
                      <span className={`text-lg ${item.favorite ? 'text-yellow-400' : 'text-gray-400 hover:text-yellow-400'}`}>
                        {item.favorite ? '⭐' : '☆'}
                      </span>
                    </button>

                    {/* Delete Button */}
                    <button
                      onClick={(e) => { e.stopPropagation(); handleDeleteMedia(item.id); }}
                      className="absolute top-3 right-12 z-10 p-1.5 rounded-full bg-black/50 opacity-0 group-hover:opacity-100 hover:bg-red-500/80 transition-all"
                    >
                      <Trash2 className="w-4 h-4 text-white" />
                    </button>

                    {/* Video Play Button */}
                    {item.type === 'video' && (
                      <div className="absolute inset-0 flex items-center justify-center z-5 pointer-events-none">
                        <div className="w-12 h-12 rounded-full bg-black/70 flex items-center justify-center">
                          <Video className="w-6 h-6 text-white" />
                        </div>
                      </div>
                    )}

                    {/* Media Image/Video */}
                    {item.type === 'video' ? (
                      <video 
                        src={item.url} 
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        muted
                      />
                    ) : (
                      <img 
                        src={item.url} 
                        alt={item.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect fill="%23333" width="100" height="100"/><text x="50" y="55" font-size="12" text-anchor="middle" fill="%23666">No Preview</text></svg>';
                        }}
                      />
                    )}

                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                      <div className="absolute bottom-0 left-0 right-0 p-3">
                        <p className="text-white text-sm font-medium truncate">{item.name}</p>
                        <p className="text-gray-400 text-xs">{item.size}</p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}

          {/* Selected Items Bar */}
          {selectedMedia.length > 0 && (
            <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-black border border-gray-400 rounded-xl px-6 py-4 flex items-center gap-4 shadow-[0_0_30px_rgba(0,0,0,0.5)] z-40">
              <span className="text-white font-medium">{selectedMedia.length} selected</span>
              <div className="flex items-center gap-2">
                <button 
                  onClick={handleDeleteSelectedMedia}
                  disabled={deletingMedia}
                  className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 disabled:bg-red-800 text-white rounded-lg text-sm font-medium transition-colors"
                >
                  {deletingMedia ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 size={16} />}
                  Delete
                </button>
                <button 
                  onClick={() => setSelectedMedia([])}
                  className="px-4 py-2 text-gray-400 hover:text-white transition-colors"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </>
      )}

      {/* Media Upload Modal */}
      {showMediaUploadModal && (
        <div 
          className="fixed inset-0 bg-black/80 z-[70] flex items-center justify-center p-4"
          onClick={() => setShowMediaUploadModal(false)}
        >
          <div 
            className="bg-gray-900 rounded-xl max-w-lg w-full"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-700">
              <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                <Upload className="w-5 h-5" />
                Upload Media
              </h3>
              <button 
                onClick={() => setShowMediaUploadModal(false)}
                className="p-2 hover:bg-gray-800 rounded-full transition-colors"
              >
                <X className="w-5 h-5 text-gray-400" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-4">
              {/* File Drop Zone */}
              <div 
                className={`border-2 border-dashed rounded-xl p-8 text-center transition-all ${
                  mediaUploadFile ? 'border-green-500 bg-green-500/10' : 'border-gray-600 hover:border-gray-400'
                }`}
              >
                {mediaUploadFile ? (
                  <div className="flex flex-col items-center">
                    {mediaUploadFile.type.startsWith('image/') ? (
                      <img 
                        src={URL.createObjectURL(mediaUploadFile)} 
                        alt="Preview" 
                        className="w-32 h-32 object-cover rounded-lg mb-3"
                      />
                    ) : (
                      <div className="w-32 h-32 bg-gray-800 rounded-lg flex items-center justify-center mb-3">
                        <Video className="w-12 h-12 text-gray-400" />
                      </div>
                    )}
                    <p className="text-white font-medium">{mediaUploadFile.name}</p>
                    <p className="text-gray-400 text-sm">{(mediaUploadFile.size / 1024 / 1024).toFixed(2)} MB</p>
                    <button
                      onClick={() => setMediaUploadFile(null)}
                      className="mt-2 text-red-400 hover:text-red-300 text-sm"
                    >
                      Remove
                    </button>
                  </div>
                ) : (
                  <>
                    <ImageIcon className="w-12 h-12 text-gray-500 mx-auto mb-3" />
                    <p className="text-white font-medium mb-1">Drop your file here</p>
                    <p className="text-gray-400 text-sm mb-4">or click to browse</p>
                    <input
                      type="file"
                      accept="image/*,video/*"
                      onChange={(e) => {
                        if (e.target.files?.[0]) {
                          setMediaUploadFile(e.target.files[0]);
                          setMediaUploadName(e.target.files[0].name.split('.')[0]);
                        }
                      }}
                      className="hidden"
                      id="media-upload-input"
                    />
                    <label
                      htmlFor="media-upload-input"
                      className="inline-flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm cursor-pointer transition-colors"
                    >
                      <Upload size={16} />
                      Select File
                    </label>
                  </>
                )}
              </div>

              {/* Name Input */}
              <div>
                <label className="block text-sm text-gray-400 mb-2">Name</label>
                <input
                  type="text"
                  data-testid="media-upload-name"
                  value={mediaUploadName}
                  onChange={(e) => setMediaUploadName(e.target.value)}
                  placeholder="Enter a name for this media"
                  className="w-full bg-black border border-gray-600 rounded-lg px-4 py-2 text-white placeholder-gray-500 focus:outline-none focus:border-gray-400"
                />
              </div>

              {/* Category Select */}
              <div>
                <label className="block text-sm text-gray-400 mb-2">Category</label>
                <select
                  data-testid="media-upload-category"
                  value={mediaUploadCategory}
                  onChange={(e) => setMediaUploadCategory(e.target.value)}
                  className="w-full bg-black border border-gray-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-gray-400"
                >
                  <option value="uncategorized">Uncategorized</option>
                  <option value="lifestyle">Lifestyle</option>
                  <option value="business">Business</option>
                  <option value="real-estate">Real Estate</option>
                </select>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end gap-3 p-4 border-t border-gray-700">
              <button
                onClick={() => {
                  setShowMediaUploadModal(false);
                  setMediaUploadFile(null);
                  setMediaUploadName('');
                  setMediaUploadCategory('uncategorized');
                }}
                className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm transition-colors"
              >
                Cancel
              </button>
              <button
                data-testid="upload-media-submit-btn"
                onClick={handleMediaUpload}
                disabled={uploadingMedia || !mediaUploadFile}
                className="flex items-center gap-2 px-6 py-2 bg-white hover:bg-gray-200 disabled:bg-gray-600 disabled:cursor-not-allowed rounded-lg text-black text-sm font-medium transition-colors"
              >
                {uploadingMedia ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    Uploading...
                  </>
                ) : (
                  <>
                    <Upload className="w-4 h-4" />
                    Upload
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Analytics Tab Content - Instagram Analytics */}
      {activeTab === 'analytics' && (
        <>
          {/* Analytics Header with Source Switcher */}
          <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              {/* Source Switcher */}
              <div className="flex items-center gap-4">
                <div className="flex flex-wrap bg-gray-800 rounded-lg p-1 gap-1">
                  <button
                    data-testid="analytics-source-instagram"
                    onClick={() => setAnalyticsSource('instagram')}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      analyticsSource === 'instagram'
                        ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                        : 'text-gray-400 hover:text-white'
                    }`}
                  >
                    <div className="w-5 h-5"><InstagramIcon /></div>
                    Instagram
                  </button>
                  <button
                    data-testid="analytics-source-facebook"
                    onClick={() => setAnalyticsSource('facebook')}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      analyticsSource === 'facebook'
                        ? 'bg-blue-500 text-white'
                        : 'text-gray-400 hover:text-white'
                    }`}
                  >
                    <div className="w-5 h-5"><FacebookIcon /></div>
                    Facebook
                  </button>
                  {/* Upload-Post Instagram Accounts (Personal) */}
                  {uploadPostAccounts.filter(a => a.platform === 'instagram').map((account, index) => (
                    <button
                      key={`instagram-uploadpost-${account.username || index}`}
                      data-testid={`analytics-source-instagram-personal-${index}`}
                      onClick={() => setAnalyticsSource(`instagram-personal-${index}`)}
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                        analyticsSource === `instagram-personal-${index}`
                          ? 'bg-gradient-to-r from-orange-500 to-pink-500 text-white'
                          : 'text-gray-400 hover:text-white'
                      }`}
                    >
                      <div className="w-5 h-5"><InstagramIcon /></div>
                      {account.friendly_name || account.username || 'Personal'}
                    </button>
                  ))}
                  {/* Other Upload-Post Connected Accounts (excluding Instagram) */}
                  {uploadPostAccounts.filter(a => a.platform !== 'instagram').map((account) => (
                    <button
                      key={account.platform}
                      data-testid={`analytics-source-${account.platform}`}
                      onClick={() => setAnalyticsSource(account.platform)}
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                        analyticsSource === account.platform
                          ? account.platform === 'youtube' 
                            ? 'bg-red-600 text-white'
                            : account.platform === 'tiktok'
                              ? 'bg-black border border-white text-white'
                              : 'bg-cyan-500 text-white'
                          : 'text-gray-400 hover:text-white'
                      }`}
                    >
                      <div className="w-5 h-5">
                        {account.platform === 'youtube' && <YouTubeIcon />}
                        {account.platform === 'tiktok' && <TikTokIcon />}
                        {account.platform === 'linkedin' && <LinkedInIcon />}
                        {account.platform === 'x' && <XTwitterIcon />}
                      </div>
                      {account.platform.charAt(0).toUpperCase() + account.platform.slice(1)}
                    </button>
                  ))}
                </div>
              </div>

              {/* Account Info */}
              <div className="flex items-center gap-4">
                {analyticsSource === 'instagram' ? (
                  <>
                    {instagramStatus?.account?.profile_picture_url ? (
                      <img 
                        src={instagramStatus.account.profile_picture_url} 
                        alt="Profile"
                        className="w-10 h-10 rounded-full object-cover border-2 border-pink-500"
                      />
                    ) : (
                      <div className="w-10 h-10 bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 rounded-full flex items-center justify-center">
                        <div className="w-5 h-5"><InstagramIcon /></div>
                      </div>
                    )}
                    <div>
                      <h3 className="text-white font-medium">
                        {instagramStatus?.connected ? `@${instagramStatus.account?.username}` : 'Not Connected'}
                      </h3>
                      <p className="text-xs text-gray-400">
                        {instagramStatus?.connected ? `${instagramStatus.account?.media_count || 0} posts` : 'Connect in Accounts tab'}
                      </p>
                    </div>
                  </>
                ) : analyticsSource.startsWith('instagram-personal') ? (
                  // Personal Instagram from Upload-Post
                  (() => {
                    const index = parseInt(analyticsSource.split('-')[2] || '0');
                    const personalIgAccounts = uploadPostAccounts.filter(a => a.platform === 'instagram');
                    const account = personalIgAccounts[index];
                    return account ? (
                      <>
                        {account.profile_picture ? (
                          <img 
                            src={account.profile_picture} 
                            alt={account.friendly_name}
                            className="w-10 h-10 rounded-full object-cover border-2 border-orange-500"
                          />
                        ) : (
                          <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-pink-500 rounded-full flex items-center justify-center">
                            <div className="w-5 h-5"><InstagramIcon /></div>
                          </div>
                        )}
                        <div>
                          <h3 className="text-white font-medium">
                            @{account.friendly_name || account.display_name || account.username}
                          </h3>
                          <p className="text-xs text-gray-400">Connected via Upload-Post</p>
                        </div>
                      </>
                    ) : null;
                  })()
                ) : analyticsSource === 'facebook' ? (
                  <>
                    {facebookStatus?.page?.picture_url ? (
                      <img 
                        src={facebookStatus.page.picture_url} 
                        alt="Page"
                        className="w-10 h-10 rounded-full object-cover border-2 border-blue-500"
                      />
                    ) : (
                      <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                        <div className="w-5 h-5"><FacebookIcon /></div>
                      </div>
                    )}
                    <div>
                      <h3 className="text-white font-medium">
                        {facebookStatus?.page?.connected ? facebookStatus.page.name : 'Not Connected'}
                      </h3>
                      <p className="text-xs text-gray-400">
                        {facebookStatus?.page?.connected ? `${facebookStatus.page.followers_count?.toLocaleString() || 0} followers` : 'Connect in Accounts tab'}
                      </p>
                    </div>
                  </>
                ) : (
                  // Upload-Post account info
                  (() => {
                    const account = uploadPostAccounts.find(a => a.platform === analyticsSource);
                    return account ? (
                      <>
                        {account.profile_picture ? (
                          <img 
                            src={account.profile_picture} 
                            alt={account.friendly_name}
                            className={`w-10 h-10 rounded-full object-cover border-2 ${
                              account.platform === 'youtube' ? 'border-red-500' : 'border-cyan-500'
                            }`}
                          />
                        ) : (
                          <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                            account.platform === 'youtube' ? 'bg-red-600' : 'bg-gray-800'
                          }`}>
                            <div className="w-5 h-5">
                              {account.platform === 'youtube' && <YouTubeIcon />}
                              {account.platform === 'tiktok' && <TikTokIcon />}
                              {account.platform === 'linkedin' && <LinkedInIcon />}
                              {account.platform === 'x' && <XTwitterIcon />}
                            </div>
                          </div>
                        )}
                        <div>
                          <h3 className="text-white font-medium">
                            @{account.friendly_name || account.display_name || account.username}
                          </h3>
                          <p className="text-xs text-gray-400 capitalize">
                            {account.platform} • Connected via Upload-Post
                          </p>
                        </div>
                      </>
                    ) : null;
                  })()
                )}
              </div>

              {/* Action Buttons */}
              <div className="flex items-center gap-3">
                <button 
                  onClick={() => {
                    if (analyticsSource === 'instagram') {
                      fetchInstagramStatus();
                      fetchInstagramPosts();
                    } else if (analyticsSource === 'facebook') {
                      fetchFacebookStatus();
                      fetchFacebookPosts();
                    } else {
                      fetchUploadPostStatus();
                    }
                  }}
                  className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm font-medium transition-colors"
                >
                  <RefreshCw size={16} />
                  Refresh
                </button>
              </div>
            </div>
          </div>

          {/* Date Range Filter */}
          <div className="bg-black border border-gray-400 rounded-xl p-4 mb-4 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex items-center gap-2">
                <Calendar size={18} className="text-gray-400" />
                <span className="text-white font-medium">Date Range</span>
              </div>
              <div className="flex items-center gap-3">
                {[
                  { id: '7days', label: '7 Days' },
                  { id: '30days', label: '30 Days' },
                  { id: '90days', label: '90 Days' },
                  { id: 'year', label: 'Year' },
                ].map((range) => (
                  <button
                    key={range.id}
                    onClick={() => setAnalyticsDateRange(range.id)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      analyticsDateRange === range.id
                        ? analyticsSource === 'instagram' ? 'bg-pink-500 text-white' : 'bg-blue-500 text-white'
                        : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white'
                    }`}
                  >
                    {range.label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Loading State */}
          {(analyticsLoading || (analyticsSource === 'instagram' ? instagramPostsLoading : facebookPostsLoading)) && (
            <div className="flex items-center justify-center py-20">
              <Loader2 className={`w-8 h-8 animate-spin ${analyticsSource === 'instagram' ? 'text-pink-500' : 'text-blue-500'}`} />
              <span className="ml-3 text-gray-400">Loading analytics...</span>
            </div>
          )}

          {/* Not Connected State - Instagram */}
          {analyticsSource === 'instagram' && !instagramStatus?.connected && !analyticsLoading && (
            <div className="bg-black border border-gray-400 rounded-xl p-12 text-center">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 flex items-center justify-center mx-auto mb-4">
                <InstagramIcon />
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Instagram Not Connected</h3>
              <p className="text-gray-400 mb-4">Connect your Instagram account to view analytics</p>
              <button
                onClick={() => setActiveTab('instagram')}
                className="px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-600 rounded-lg text-white font-medium"
              >
                Go to Instagram Tab
              </button>
            </div>
          )}

          {/* Not Connected State - Facebook */}
          {analyticsSource === 'facebook' && !facebookStatus?.page?.connected && !analyticsLoading && (
            <div className="bg-black border border-gray-400 rounded-xl p-12 text-center">
              <div className="w-20 h-20 rounded-full bg-blue-600 flex items-center justify-center mx-auto mb-4">
                <FacebookIcon />
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Facebook Page Not Connected</h3>
              <p className="text-gray-400 mb-4">Connect your Facebook Page to view analytics</p>
              <button
                onClick={() => setActiveTab('facebook')}
                className="px-6 py-2 bg-blue-500 hover:bg-blue-600 rounded-lg text-white font-medium"
              >
                Go to Facebook Tab
              </button>
            </div>
          )}

          {/* Upload-Post Account Analytics (YouTube, TikTok, etc.) */}
          {!['instagram', 'facebook'].includes(analyticsSource) && uploadPostAccounts.some(acc => acc.platform === analyticsSource) && (
            <div className="space-y-6">
              {/* Account Info Card */}
              {(() => {
                const account = uploadPostAccounts.find(a => a.platform === analyticsSource);
                if (!account) return null;
                
                // For YouTube, show real analytics if connected via OAuth
                if (analyticsSource === 'youtube') {
                  // YouTube Analytics - Check if OAuth is connected
                  if (youtubeAnalyticsStatus?.connected) {
                    // Show real YouTube Analytics
                    const channel = youtubeChannelStats || youtubeAnalyticsStatus?.channel || {};
                    const metrics = youtubeAnalytics?.metrics || {};
                    
                    return (
                      <>
                        {/* Connected Account Header */}
                        <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-xl p-6">
                          <div className="flex items-center gap-4">
                            {channel.thumbnail_url ? (
                              <img 
                                src={channel.thumbnail_url} 
                                alt={channel.channel_title}
                                className="w-16 h-16 rounded-full object-cover border-2 border-white/30"
                              />
                            ) : (
                              <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center">
                                <div className="w-8 h-8"><YouTubeIcon /></div>
                              </div>
                            )}
                            <div className="flex-1">
                              <h3 className="text-2xl font-bold text-white">{channel.channel_title || account.friendly_name}</h3>
                              <p className="text-white/70 text-sm">
                                {channel.custom_url ? `${channel.custom_url} • ` : ''}YouTube • Analytics Connected
                              </p>
                            </div>
                            <div className="flex items-center gap-2">
                              <button
                                onClick={() => { fetchYoutubeAnalyticsStatus(); fetchYoutubeAnalyticsData(); }}
                                className="p-2 bg-white/20 hover:bg-white/30 rounded-lg transition-colors"
                                title="Refresh Analytics"
                              >
                                <RefreshCw size={18} className={youtubeAnalyticsLoading ? 'animate-spin' : ''} />
                              </button>
                              <CheckCircle className="w-8 h-8 text-green-400" />
                            </div>
                          </div>
                        </div>

                        {/* Real Stats Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                          <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-red-400 hover:shadow-[0_0_20px_rgba(239,68,68,0.2)] transition-all duration-300">
                            <div className="flex items-center justify-between mb-3">
                              <span className="text-gray-400 text-sm">Subscribers</span>
                              <div className="p-2 rounded-lg bg-red-500/20">
                                <Users size={18} className="text-red-400" />
                              </div>
                            </div>
                            <p className="text-2xl font-bold text-white">{formatNumber(channel.subscriber_count || 0)}</p>
                            <p className="text-xs text-gray-500 mt-1">
                              {metrics.subscribersGained ? `+${formatNumber(metrics.subscribersGained - (metrics.subscribersLost || 0))} this period` : 'Total subscribers'}
                            </p>
                          </div>
                          
                          <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-red-400 hover:shadow-[0_0_20px_rgba(239,68,68,0.2)] transition-all duration-300">
                            <div className="flex items-center justify-between mb-3">
                              <span className="text-gray-400 text-sm">Total Views</span>
                              <div className="p-2 rounded-lg bg-red-500/20">
                                <Eye size={18} className="text-red-400" />
                              </div>
                            </div>
                            <p className="text-2xl font-bold text-white">{formatNumber(metrics.views || channel.view_count || 0)}</p>
                            <p className="text-xs text-gray-500 mt-1">
                              {metrics.views ? 'Views this period' : 'Lifetime views'}
                            </p>
                          </div>
                          
                          <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-red-400 hover:shadow-[0_0_20px_rgba(239,68,68,0.2)] transition-all duration-300">
                            <div className="flex items-center justify-between mb-3">
                              <span className="text-gray-400 text-sm">Watch Time</span>
                              <div className="p-2 rounded-lg bg-red-500/20">
                                <Clock size={18} className="text-red-400" />
                              </div>
                            </div>
                            <p className="text-2xl font-bold text-white">
                              {metrics.estimatedMinutesWatched 
                                ? `${formatNumber(Math.round(metrics.estimatedMinutesWatched / 60))}h`
                                : '—'
                              }
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                              {metrics.estimatedMinutesWatched ? 'Watch hours this period' : 'Connect to see data'}
                            </p>
                          </div>
                          
                          <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-red-400 hover:shadow-[0_0_20px_rgba(239,68,68,0.2)] transition-all duration-300">
                            <div className="flex items-center justify-between mb-3">
                              <span className="text-gray-400 text-sm">Total Videos</span>
                              <div className="p-2 rounded-lg bg-red-500/20">
                                <Video size={18} className="text-red-400" />
                              </div>
                            </div>
                            <p className="text-2xl font-bold text-white">{formatNumber(channel.video_count || 0)}</p>
                            <p className="text-xs text-gray-500 mt-1">Published videos</p>
                          </div>
                        </div>

                        {/* Engagement Stats */}
                        {(metrics.likes || metrics.comments || metrics.shares) && (
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div className="bg-black border border-gray-400 rounded-xl p-5">
                              <div className="flex items-center gap-3">
                                <div className="p-2 rounded-lg bg-pink-500/20">
                                  <Heart size={18} className="text-pink-400" />
                                </div>
                                <div>
                                  <p className="text-2xl font-bold text-white">{formatNumber(metrics.likes || 0)}</p>
                                  <p className="text-xs text-gray-500">Likes this period</p>
                                </div>
                              </div>
                            </div>
                            <div className="bg-black border border-gray-400 rounded-xl p-5">
                              <div className="flex items-center gap-3">
                                <div className="p-2 rounded-lg bg-blue-500/20">
                                  <MessageCircle size={18} className="text-blue-400" />
                                </div>
                                <div>
                                  <p className="text-2xl font-bold text-white">{formatNumber(metrics.comments || 0)}</p>
                                  <p className="text-xs text-gray-500">Comments this period</p>
                                </div>
                              </div>
                            </div>
                            <div className="bg-black border border-gray-400 rounded-xl p-5">
                              <div className="flex items-center gap-3">
                                <div className="p-2 rounded-lg bg-green-500/20">
                                  <Share2 size={18} className="text-green-400" />
                                </div>
                                <div>
                                  <p className="text-2xl font-bold text-white">{formatNumber(metrics.shares || 0)}</p>
                                  <p className="text-xs text-gray-500">Shares this period</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Top Videos */}
                        {youtubeTopVideos.length > 0 && (
                          <div className="bg-black border border-gray-400 rounded-xl p-6">
                            <h4 className="text-white font-semibold mb-4 flex items-center gap-2">
                              <TrendingUp size={18} className="text-red-400" />
                              Top Performing Videos
                            </h4>
                            <div className="space-y-3">
                              {youtubeTopVideos.slice(0, 5).map((video, index) => (
                                <div key={video.video || index} className="flex items-center gap-4 p-3 bg-gray-900 rounded-lg">
                                  <span className="text-gray-500 text-sm font-medium w-6">#{index + 1}</span>
                                  {video.thumbnail && (
                                    <img src={video.thumbnail} alt="" className="w-20 h-12 object-cover rounded" />
                                  )}
                                  <div className="flex-1 min-w-0">
                                    <p className="text-white text-sm font-medium truncate">{video.title || video.video}</p>
                                    <p className="text-gray-500 text-xs">
                                      {formatNumber(video.views || 0)} views • {formatNumber(Math.round((video.estimatedMinutesWatched || 0) / 60))}h watch time
                                    </p>
                                  </div>
                                  <div className="flex items-center gap-3 text-gray-400 text-xs">
                                    <span className="flex items-center gap-1">
                                      <Heart size={12} /> {formatNumber(video.likes || 0)}
                                    </span>
                                    <span className="flex items-center gap-1">
                                      <MessageCircle size={12} /> {formatNumber(video.comments || 0)}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Quick Actions */}
                        <div className="bg-black border border-gray-400 rounded-xl p-6">
                          <h4 className="text-white font-semibold mb-4">Quick Actions</h4>
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                            <button 
                              onClick={() => setActiveTab('posts')}
                              className="flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-red-600 to-red-700 rounded-lg text-white font-medium hover:opacity-90 transition-opacity"
                            >
                              <Plus size={18} />
                              Create Post
                            </button>
                            <a 
                              href="https://studio.youtube.com" 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="flex items-center justify-center gap-2 px-4 py-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors"
                            >
                              <ExternalLink size={18} />
                              YouTube Studio
                            </a>
                            <button 
                              onClick={() => { fetchYoutubeAnalyticsStatus(); fetchYoutubeAnalyticsData(); }}
                              className="flex items-center justify-center gap-2 px-4 py-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors"
                            >
                              <RefreshCw size={18} className={youtubeAnalyticsLoading ? 'animate-spin' : ''} />
                              Refresh Data
                            </button>
                          </div>
                        </div>
                      </>
                    );
                  } else {
                    // YouTube account connected via Upload-Post but Analytics OAuth not connected
                    return (
                      <>
                        {/* Connected Account Header */}
                        <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-xl p-6">
                          <div className="flex items-center gap-4">
                            {account.profile_picture ? (
                              <img 
                                src={account.profile_picture} 
                                alt={account.friendly_name}
                                className="w-16 h-16 rounded-full object-cover border-2 border-white/30"
                              />
                            ) : (
                              <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center">
                                <div className="w-8 h-8"><YouTubeIcon /></div>
                              </div>
                            )}
                            <div className="flex-1">
                              <h3 className="text-2xl font-bold text-white">@{account.friendly_name || account.display_name}</h3>
                              <p className="text-white/70 text-sm">YouTube • Connected for Posting</p>
                            </div>
                            <CheckCircle className="w-8 h-8 text-green-400" />
                          </div>
                        </div>

                        {/* Connect Analytics Notice */}
                        <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-6">
                          <div className="flex items-start gap-4">
                            <div className="p-3 bg-red-500/20 rounded-lg">
                              <BarChart3 className="w-6 h-6 text-red-400" />
                            </div>
                            <div className="flex-1">
                              <h4 className="text-white font-semibold mb-2">Connect YouTube Analytics</h4>
                              <p className="text-gray-400 text-sm mb-4">
                                Your YouTube account is connected for posting via Upload-Post. To view detailed analytics 
                                (views, watch time, subscribers, video performance), you need to authorize YouTube Analytics separately.
                              </p>
                              <div className="flex flex-wrap gap-3">
                                <button
                                  onClick={connectYoutubeAnalytics}
                                  className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg text-white font-medium transition-colors"
                                  data-testid="connect-youtube-analytics-btn"
                                >
                                  <BarChart3 size={16} />
                                  Connect YouTube Analytics
                                </button>
                                <button
                                  onClick={fetchYoutubeAnalyticsStatus}
                                  className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors"
                                >
                                  <RefreshCw size={16} className={youtubeAnalyticsLoading ? 'animate-spin' : ''} />
                                  Refresh Status
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* What You Get Section */}
                        <div className="bg-black border border-gray-400 rounded-xl p-6">
                          <h4 className="text-white font-semibold mb-4">What You'll Get with YouTube Analytics</h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                            {[
                              { label: 'Subscribers', desc: 'Track growth over time', icon: Users },
                              { label: 'Watch Time', desc: 'Hours watched per video', icon: Clock },
                              { label: 'Views', desc: 'Total and per-video views', icon: Eye },
                              { label: 'Top Videos', desc: 'Best performing content', icon: TrendingUp }
                            ].map((item, index) => {
                              const ItemIcon = item.icon;
                              return (
                                <div key={index} className="p-4 bg-gray-900 rounded-lg">
                                  <div className="flex items-center gap-3 mb-2">
                                    <div className="p-2 rounded-lg bg-red-500/20">
                                      <ItemIcon size={16} className="text-red-400" />
                                    </div>
                                    <span className="text-white font-medium">{item.label}</span>
                                  </div>
                                  <p className="text-gray-500 text-sm">{item.desc}</p>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        {/* Quick Actions */}
                        <div className="bg-black border border-gray-400 rounded-xl p-6">
                          <h4 className="text-white font-semibold mb-4">Quick Actions</h4>
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                            <button 
                              onClick={() => setActiveTab('posts')}
                              className="flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-red-600 to-red-700 rounded-lg text-white font-medium hover:opacity-90 transition-opacity"
                            >
                              <Plus size={18} />
                              Create Post
                            </button>
                            <button 
                              onClick={() => setActiveTab('accounts')}
                              className="flex items-center justify-center gap-2 px-4 py-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors"
                            >
                              <Settings size={18} />
                              Manage Account
                            </button>
                            <button 
                              onClick={fetchUploadPostStatus}
                              className="flex items-center justify-center gap-2 px-4 py-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors"
                            >
                              <RefreshCw size={18} />
                              Refresh Status
                            </button>
                          </div>
                        </div>
                      </>
                    );
                  }
                }
                
                // Other platforms (TikTok, LinkedIn, X) - still show "Coming Soon"
                const platformConfig = {
                  tiktok: { 
                    name: 'TikTok', 
                    icon: TikTokIcon, 
                    color: 'white',
                    gradient: 'from-gray-800 to-black',
                    stats: [
                      { label: 'Followers', value: 'Coming Soon', icon: Users },
                      { label: 'Total Likes', value: 'Coming Soon', icon: Heart },
                      { label: 'Total Videos', value: 'Coming Soon', icon: Video },
                      { label: 'Profile Views', value: 'Coming Soon', icon: Eye },
                    ]
                  },
                  linkedin: { 
                    name: 'LinkedIn', 
                    icon: LinkedInIcon, 
                    color: 'blue',
                    gradient: 'from-blue-600 to-blue-700',
                    stats: [
                      { label: 'Connections', value: 'Coming Soon', icon: Users },
                      { label: 'Post Views', value: 'Coming Soon', icon: Eye },
                      { label: 'Engagements', value: 'Coming Soon', icon: Heart },
                      { label: 'Followers', value: 'Coming Soon', icon: Users },
                    ]
                  },
                  x: { 
                    name: 'X (Twitter)', 
                    icon: XTwitterIcon, 
                    color: 'gray',
                    gradient: 'from-gray-700 to-gray-800',
                    stats: [
                      { label: 'Followers', value: 'Coming Soon', icon: Users },
                      { label: 'Total Tweets', value: 'Coming Soon', icon: MessageCircle },
                      { label: 'Impressions', value: 'Coming Soon', icon: Eye },
                      { label: 'Engagements', value: 'Coming Soon', icon: Heart },
                    ]
                  }
                };
                
                const config = platformConfig[analyticsSource] || {
                  name: analyticsSource.charAt(0).toUpperCase() + analyticsSource.slice(1),
                  icon: Users,
                  color: 'cyan',
                  gradient: 'from-cyan-600 to-cyan-700',
                  stats: []
                };
                
                const PlatformIcon = config.icon;
                
                return (
                  <>
                    {/* Connected Account Header */}
                    <div className={`bg-gradient-to-r ${config.gradient} rounded-xl p-6`}>
                      <div className="flex items-center gap-4">
                        {account.profile_picture ? (
                          <img 
                            src={account.profile_picture} 
                            alt={account.friendly_name}
                            className="w-16 h-16 rounded-full object-cover border-2 border-white/30"
                          />
                        ) : (
                          <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center">
                            <div className="w-8 h-8"><PlatformIcon /></div>
                          </div>
                        )}
                        <div className="flex-1">
                          <h3 className="text-2xl font-bold text-white">@{account.friendly_name || account.display_name}</h3>
                          <p className="text-white/70 text-sm">{config.name} • Connected via Upload-Post</p>
                        </div>
                        <CheckCircle className="w-8 h-8 text-green-400" />
                      </div>
                    </div>

                    {/* Stats Grid - Coming Soon */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                      {config.stats.map((stat, index) => {
                        const StatIcon = stat.icon;
                        return (
                          <div 
                            key={index}
                            className="bg-black border border-gray-400 rounded-xl p-5 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.2)] transition-all duration-300"
                          >
                            <div className="flex items-center justify-between mb-3">
                              <span className="text-gray-400 text-sm">{stat.label}</span>
                              <div className={`p-2 rounded-lg ${
                                config.color === 'red' ? 'bg-red-500/20' :
                                config.color === 'blue' ? 'bg-blue-500/20' :
                                'bg-gray-700'
                              }`}>
                                <StatIcon size={18} className={
                                  config.color === 'red' ? 'text-red-400' :
                                  config.color === 'blue' ? 'text-blue-400' :
                                  'text-gray-400'
                                } />
                              </div>
                            </div>
                            <p className="text-2xl font-bold text-gray-500">{stat.value}</p>
                            <p className="text-xs text-gray-600 mt-1">Analytics coming soon</p>
                          </div>
                        );
                      })}
                    </div>

                    {/* Coming Soon Notice */}
                    <div className="bg-cyan-500/10 border border-cyan-500/30 rounded-xl p-6">
                      <div className="flex items-start gap-4">
                        <div className="p-3 bg-cyan-500/20 rounded-lg">
                          <TrendingUp className="w-6 h-6 text-cyan-400" />
                        </div>
                        <div className="flex-1">
                          <h4 className="text-white font-semibold mb-2">{config.name} Analytics Coming Soon</h4>
                          <p className="text-gray-400 text-sm mb-4">
                            {config.name} analytics integration is in development. Soon you'll be able to see detailed metrics including 
                            {analyticsSource === 'tiktok' && ' followers, likes, video views, and engagement rates.'}
                            {analyticsSource === 'linkedin' && ' connections, post views, and professional engagement.'}
                            {analyticsSource === 'x' && ' followers, impressions, retweets, and tweet performance.'}
                            {!['tiktok', 'linkedin', 'x'].includes(analyticsSource) && ' platform-specific metrics and engagement data.'}
                          </p>
                          <div className="flex items-center gap-2 text-cyan-400 text-sm">
                            <CheckCircle size={16} />
                            <span>Account connected and ready for posting via Upload-Post</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Quick Actions */}
                    <div className="bg-black border border-gray-400 rounded-xl p-6 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.2)] transition-all duration-300">
                      <h4 className="text-white font-semibold mb-4">Quick Actions</h4>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <button 
                          onClick={() => setActiveTab('posts')}
                          className={`flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r ${config.gradient} rounded-lg text-white font-medium hover:opacity-90 transition-opacity`}
                        >
                          <Plus size={18} />
                          Create Post
                        </button>
                        <button 
                          onClick={() => setActiveTab('accounts')}
                          className="flex items-center justify-center gap-2 px-4 py-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors"
                        >
                          <Settings size={18} />
                          Manage Account
                        </button>
                        <button 
                          onClick={fetchUploadPostStatus}
                          className="flex items-center justify-center gap-2 px-4 py-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors"
                        >
                          <RefreshCw size={18} />
                          Refresh Status
                        </button>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>
          )}

          {/* Instagram Analytics Content */}
          {analyticsSource === 'instagram' && instagramStatus?.connected && instagramAnalytics && !analyticsLoading && (
            <>
              {/* No Data Alert */}
              {instagramAnalytics.totalPosts === 0 && (
                <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-4 mb-6 flex items-center gap-4">
                  <div className="p-2 bg-yellow-500/20 rounded-lg">
                    <AlertCircle className="w-6 h-6 text-yellow-500" />
                  </div>
                  <div className="flex-1">
                    <h4 className="text-white font-medium">No posts in this time period</h4>
                    <p className="text-gray-400 text-sm">
                      There are no Instagram posts in the last {analyticsDateRange === '7days' ? '7 days' : analyticsDateRange === '30days' ? '30 days' : '90 days'}. 
                      Try selecting a longer date range to see your analytics.
                    </p>
                  </div>
                  <button
                    onClick={() => setAnalyticsDateRange('year')}
                    className="px-4 py-2 bg-yellow-500/20 hover:bg-yellow-500/30 text-yellow-400 rounded-lg text-sm font-medium transition-colors"
                  >
                    View Year
                  </button>
                </div>
              )}

              {/* KPI Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                {[
                  { 
                    title: 'Total Posts', 
                    value: instagramAnalytics.totalPosts.toLocaleString(), 
                    subtitle: `in last ${analyticsDateRange === '7days' ? '7 days' : analyticsDateRange === '30days' ? '30 days' : analyticsDateRange === '90days' ? '90 days' : 'year'}`,
                    icon: Grid,
                    color: 'text-pink-400',
                    bgColor: 'bg-pink-500/20'
                  },
                  { 
                    title: 'Total Likes', 
                    value: instagramAnalytics.totalLikes.toLocaleString(), 
                    subtitle: `${instagramAnalytics.totalPosts > 0 ? Math.round(instagramAnalytics.totalLikes / instagramAnalytics.totalPosts) : 0} avg per post`,
                    icon: Heart,
                    color: 'text-red-400',
                    bgColor: 'bg-red-500/20'
                  },
                  { 
                    title: 'Total Comments', 
                    value: instagramAnalytics.totalComments.toLocaleString(), 
                    subtitle: `${instagramAnalytics.totalPosts > 0 ? Math.round(instagramAnalytics.totalComments / instagramAnalytics.totalPosts) : 0} avg per post`,
                    icon: MessageCircle,
                    color: 'text-blue-400',
                    bgColor: 'bg-blue-500/20'
                  },
                  { 
                    title: 'Engagement', 
                    value: instagramAnalytics.totalEngagement.toLocaleString(), 
                    subtitle: `${instagramAnalytics.avgEngagement} avg per post`,
                    icon: TrendingUp,
                    color: 'text-green-400',
                    bgColor: 'bg-green-500/20'
                  },
                ].map((kpi, idx) => {
                  const IconComponent = kpi.icon;
                  return (
                    <div 
                      key={idx}
                      className="bg-black border border-gray-400 rounded-xl p-5 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300"
                    >
                      <div className="flex items-center justify-between mb-4">
                        <span className="text-gray-400 text-sm font-medium">{kpi.title}</span>
                        <div className={`p-2 rounded-lg ${kpi.bgColor}`}>
                          <IconComponent size={18} className={kpi.color} />
                        </div>
                      </div>
                      <div className="text-3xl font-bold text-white mb-1">{kpi.value}</div>
                      <div className="text-xs text-gray-500">{kpi.subtitle}</div>
                    </div>
                  );
                })}
              </div>

              {/* Content Type Breakdown & Engagement Chart */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                {/* Content Type Breakdown */}
                <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
                  <h3 className="text-lg font-bold text-white mb-4">Content Breakdown</h3>
                  <div className="space-y-4">
                    {[
                      { type: 'Images', count: instagramAnalytics.imageCount, icon: ImageIcon, color: 'bg-pink-500' },
                      { type: 'Videos', count: instagramAnalytics.videoCount, icon: Video, color: 'bg-purple-500' },
                      { type: 'Carousels', count: instagramAnalytics.carouselCount, icon: Grid, color: 'bg-blue-500' },
                    ].map((item, idx) => {
                      const ItemIcon = item.icon;
                      const percentage = instagramAnalytics.totalPosts > 0 
                        ? Math.round((item.count / instagramAnalytics.totalPosts) * 100) 
                        : 0;
                      return (
                        <div key={idx} className="flex items-center gap-4">
                          <div className={`p-2 rounded-lg ${item.color}/20`}>
                            <ItemIcon size={18} className="text-white" />
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center justify-between mb-1">
                              <span className="text-white text-sm">{item.type}</span>
                              <span className="text-gray-400 text-sm">{item.count} ({percentage}%)</span>
                            </div>
                            <div className="h-2 bg-gray-800 rounded-full overflow-hidden">
                              <div 
                                className={`h-full ${item.color} rounded-full transition-all`}
                                style={{ width: `${percentage}%` }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Engagement Over Time */}
                <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
                  <h3 className="text-lg font-bold text-white mb-4">Engagement Over Time</h3>
                  <div className="h-48 flex items-end gap-1">
                    {instagramAnalytics.chartData.slice(-14).map((day, idx) => {
                      const maxEngagement = Math.max(...instagramAnalytics.chartData.map(d => d.engagement), 1);
                      const height = (day.engagement / maxEngagement) * 100;
                      return (
                        <div key={idx} className="flex-1 flex flex-col items-center group">
                          <div 
                            className="w-full bg-gradient-to-t from-pink-500 to-purple-500 rounded-t hover:from-pink-400 hover:to-purple-400 transition-all cursor-pointer relative"
                            style={{ height: `${Math.max(height, 2)}%` }}
                          >
                            <div className="absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 bg-black/90 rounded text-xs text-white whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                              {day.engagement} engagement
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="flex justify-between mt-2 text-xs text-gray-500">
                    <span>{instagramAnalytics.chartData.slice(-14)[0]?.shortDate}</span>
                    <span>{instagramAnalytics.chartData.slice(-1)[0]?.shortDate}</span>
                  </div>
                </div>
              </div>

              {/* Top Performing Posts */}
              <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
                <h3 className="text-lg font-bold text-white mb-4">Top Performing Posts</h3>
                {instagramAnalytics.topPosts.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                    {instagramAnalytics.topPosts.map((post, idx) => (
                      <div 
                        key={post.id}
                        className="relative group cursor-pointer"
                        onClick={() => setSelectedInstagramPost(post)}
                      >
                        <div className="aspect-square rounded-xl overflow-hidden border border-gray-700 hover:border-pink-500 transition-all">
                          {post.media_type === 'VIDEO' ? (
                            <img 
                              src={post.thumbnail_url || post.media_url} 
                              alt="Video"
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <img 
                              src={post.media_url} 
                              alt={`Top post ${idx + 1}`}
                              className="w-full h-full object-cover"
                            />
                          )}
                          <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center">
                            <div className="flex items-center gap-3 text-white">
                              <span className="flex items-center gap-1">
                                <Heart size={16} /> {post.like_count || 0}
                              </span>
                              <span className="flex items-center gap-1">
                                <MessageCircle size={16} /> {post.comments_count || 0}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="absolute top-2 left-2 bg-black/70 px-2 py-1 rounded text-xs text-white font-bold">
                          #{idx + 1}
                        </div>
                        {post.media_type === 'VIDEO' && (
                          <div className="absolute top-2 right-2">
                            <Video size={16} className="text-white drop-shadow-lg" />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-400 text-center py-8">No posts in selected date range</p>
                )}
              </div>
            </>
          )}

          {/* Personal Instagram Analytics Content (Upload-Post) */}
          {analyticsSource.startsWith('instagram-personal') && (
            (() => {
              const index = parseInt(analyticsSource.split('-')[2] || '0');
              const personalIgAccounts = uploadPostAccounts.filter(a => a.platform === 'instagram');
              const account = personalIgAccounts[index];
              
              // Use real analytics from API or show loading/empty state
              const analytics = personalIgAnalytics?.analytics;
              const recentPosts = personalIgAnalytics?.recent_posts || [];
              
              return account ? (
                <>
                  {/* Account Header */}
                  <div className="bg-black border border-gray-400 rounded-xl p-6 mb-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        {account.profile_picture ? (
                          <img 
                            src={account.profile_picture} 
                            alt={account.friendly_name}
                            className="w-16 h-16 rounded-full object-cover border-3 border-orange-500"
                          />
                        ) : (
                          <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-pink-500 rounded-full flex items-center justify-center">
                            <div className="w-8 h-8"><InstagramIcon /></div>
                          </div>
                        )}
                        <div>
                          <h2 className="text-2xl font-bold text-white">
                            @{account.friendly_name || account.display_name || account.username}
                          </h2>
                          <p className="text-gray-400">Personal Instagram • Connected via Upload-Post</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <button
                          onClick={fetchPersonalIgAnalytics}
                          disabled={personalIgAnalyticsLoading}
                          className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors flex items-center gap-2"
                        >
                          <RefreshCw size={16} className={personalIgAnalyticsLoading ? 'animate-spin' : ''} />
                          Refresh
                        </button>
                        <a
                          href={`https://instagram.com/${account.username || account.friendly_name}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="px-4 py-2 bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 rounded-lg text-white font-medium transition-colors flex items-center gap-2"
                        >
                          <ExternalLink size={16} />
                          View Profile
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Loading State */}
                  {personalIgAnalyticsLoading && (
                    <div className="flex items-center justify-center py-20">
                      <Loader2 className="w-8 h-8 animate-spin text-orange-500" />
                      <span className="ml-3 text-gray-400">Loading analytics...</span>
                    </div>
                  )}

                  {/* Analytics Content - Only show when there are actual posts */}
                  {!personalIgAnalyticsLoading && analytics && analytics.total_posts > 0 && (
                    <>
                      {/* KPI Cards */}
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                        {[
                          { 
                            title: 'Total Posts', 
                            value: (analytics.total_posts || 0).toLocaleString(), 
                            subtitle: 'uploaded via Upload-Post',
                            icon: Grid,
                            color: 'text-orange-400',
                            bgColor: 'bg-orange-500/20'
                          },
                          { 
                            title: 'Total Views', 
                            value: (analytics.total_views || 0).toLocaleString(), 
                            subtitle: 'content impressions',
                            icon: Eye,
                            color: 'text-pink-400',
                            bgColor: 'bg-pink-500/20'
                          },
                          { 
                            title: 'Total Likes', 
                            value: (analytics.total_likes || 0).toLocaleString(), 
                            subtitle: `${analytics.avg_likes || 0} avg per post`,
                            icon: Heart,
                            color: 'text-red-400',
                            bgColor: 'bg-red-500/20'
                          },
                          { 
                            title: 'Engagement Rate', 
                            value: `${analytics.engagement_rate || 0}%`, 
                            subtitle: `${(analytics.total_engagement || 0).toLocaleString()} total`,
                            icon: TrendingUp,
                            color: 'text-green-400',
                            bgColor: 'bg-green-500/20'
                          },
                        ].map((kpi, idx) => {
                          const IconComponent = kpi.icon;
                          return (
                            <div 
                              key={idx}
                              className="bg-black border border-gray-400 rounded-xl p-5 hover:border-orange-400 hover:shadow-[0_0_20px_rgba(249,115,22,0.2)] transition-all duration-300"
                            >
                              <div className="flex items-center justify-between mb-4">
                                <span className="text-gray-400 text-sm font-medium">{kpi.title}</span>
                                <div className={`p-2 rounded-lg ${kpi.bgColor}`}>
                                  <IconComponent size={18} className={kpi.color} />
                                </div>
                              </div>
                              <div className="text-3xl font-bold text-white mb-1">{kpi.value}</div>
                              <div className="text-xs text-gray-500">{kpi.subtitle}</div>
                            </div>
                          );
                        })}
                      </div>

                      {/* Comments & Shares */}
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                        <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-orange-400 hover:shadow-[0_0_20px_rgba(249,115,22,0.2)] transition-all duration-300">
                          <h3 className="text-lg font-bold text-white mb-4">Engagement Breakdown</h3>
                          <div className="space-y-4">
                            <div>
                              <div className="flex justify-between items-center mb-2">
                                <span className="text-gray-400 text-sm flex items-center gap-2">
                                  <Heart size={14} className="text-red-400" /> Likes
                                </span>
                                <span className="text-white font-medium">{(analytics.total_likes || 0).toLocaleString()}</span>
                              </div>
                              <div className="h-2 bg-gray-800 rounded-full overflow-hidden">
                                <div className="h-full bg-gradient-to-r from-red-500 to-pink-500 rounded-full" style={{width: `${Math.min(100, (analytics.total_likes / Math.max(analytics.total_engagement, 1)) * 100)}%`}}></div>
                              </div>
                            </div>
                            <div>
                              <div className="flex justify-between items-center mb-2">
                                <span className="text-gray-400 text-sm flex items-center gap-2">
                                  <MessageCircle size={14} className="text-blue-400" /> Comments
                                </span>
                                <span className="text-white font-medium">{(analytics.total_comments || 0).toLocaleString()}</span>
                              </div>
                              <div className="h-2 bg-gray-800 rounded-full overflow-hidden">
                                <div className="h-full bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full" style={{width: `${Math.min(100, (analytics.total_comments / Math.max(analytics.total_engagement, 1)) * 100)}%`}}></div>
                              </div>
                            </div>
                            <div>
                              <div className="flex justify-between items-center mb-2">
                                <span className="text-gray-400 text-sm flex items-center gap-2">
                                  <Share2 size={14} className="text-green-400" /> Shares
                                </span>
                                <span className="text-white font-medium">{(analytics.total_shares || 0).toLocaleString()}</span>
                              </div>
                              <div className="h-2 bg-gray-800 rounded-full overflow-hidden">
                                <div className="h-full bg-gradient-to-r from-green-500 to-emerald-500 rounded-full" style={{width: `${Math.min(100, (analytics.total_shares / Math.max(analytics.total_engagement, 1)) * 100)}%`}}></div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-orange-400 hover:shadow-[0_0_20px_rgba(249,115,22,0.2)] transition-all duration-300">
                          <h3 className="text-lg font-bold text-white mb-4">Performance Summary</h3>
                          <div className="space-y-3">
                            <div className="flex justify-between items-center p-3 bg-gray-900/50 rounded-lg">
                              <span className="text-gray-400 text-sm">Avg. Likes per Post</span>
                              <span className="text-white font-medium">{analytics.avg_likes || 0}</span>
                            </div>
                            <div className="flex justify-between items-center p-3 bg-gray-900/50 rounded-lg">
                              <span className="text-gray-400 text-sm">Avg. Comments per Post</span>
                              <span className="text-white font-medium">{analytics.avg_comments || 0}</span>
                            </div>
                            <div className="flex justify-between items-center p-3 bg-gray-900/50 rounded-lg">
                              <span className="text-gray-400 text-sm">Total Engagement</span>
                              <span className="text-white font-medium">{(analytics.total_engagement || 0).toLocaleString()}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* No Data State - Show when analytics show 0 posts or no analytics data */}
                  {!personalIgAnalyticsLoading && (!analytics || analytics.total_posts === 0) && (
                    <div className="bg-black border border-gray-400 rounded-xl p-8">
                      {/* Info Banner */}
                      <div className="bg-gradient-to-r from-orange-500/10 to-pink-500/10 border border-orange-500/30 rounded-xl p-6 mb-6">
                        <div className="flex items-start gap-4">
                          <div className="p-3 bg-orange-500/20 rounded-lg flex-shrink-0">
                            <Info size={24} className="text-orange-400" />
                          </div>
                          <div>
                            <h4 className="text-lg font-bold text-white mb-2">About Upload-Post Analytics</h4>
                            <p className="text-gray-300 text-sm leading-relaxed">
                              This section shows analytics for posts made <span className="text-orange-400 font-medium">through Upload-Post.com</span>. 
                              Currently, no Instagram posts have been uploaded via Upload-Post for this account.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Two Column Layout */}
                      <div className="grid md:grid-cols-2 gap-6">
                        {/* What's Available Here */}
                        <div className="bg-gray-900/50 rounded-xl p-5 border border-gray-700">
                          <h5 className="text-white font-semibold mb-3 flex items-center gap-2">
                            <CheckCircle size={18} className="text-green-400" />
                            What You Can Do Here
                          </h5>
                          <ul className="space-y-2 text-sm text-gray-400">
                            <li className="flex items-start gap-2">
                              <div className="w-1.5 h-1.5 rounded-full bg-orange-400 mt-2 flex-shrink-0"></div>
                              <span>Create & schedule Instagram posts via Upload-Post</span>
                            </li>
                            <li className="flex items-start gap-2">
                              <div className="w-1.5 h-1.5 rounded-full bg-orange-400 mt-2 flex-shrink-0"></div>
                              <span>Track engagement on posts uploaded through this app</span>
                            </li>
                            <li className="flex items-start gap-2">
                              <div className="w-1.5 h-1.5 rounded-full bg-orange-400 mt-2 flex-shrink-0"></div>
                              <span>View post history and performance metrics</span>
                            </li>
                          </ul>
                        </div>

                        {/* What's on Upload-Post Dashboard */}
                        <div className="bg-gray-900/50 rounded-xl p-5 border border-gray-700">
                          <h5 className="text-white font-semibold mb-3 flex items-center gap-2">
                            <ExternalLink size={18} className="text-blue-400" />
                            Full Account Insights
                          </h5>
                          <p className="text-sm text-gray-400 mb-3">
                            For detailed account-level analytics (followers, reach, impressions), visit:
                          </p>
                          <a
                            href="https://upload-post.com/dashboard"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 rounded-lg text-white text-sm font-medium transition-colors"
                          >
                            <ExternalLink size={14} />
                            Upload-Post Dashboard
                          </a>
                        </div>
                      </div>

                      {/* CTA Section */}
                      <div className="mt-6 pt-6 border-t border-gray-700 text-center">
                        <p className="text-gray-400 text-sm mb-4">
                          Start posting to Instagram through Upload-Post to see analytics here!
                        </p>
                        <div className="flex justify-center gap-4">
                          <button
                            onClick={() => setActiveTab('posts')}
                            className="px-6 py-3 bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 rounded-lg text-white font-medium transition-colors flex items-center gap-2"
                            data-testid="create-first-ig-post-btn"
                          >
                            <Plus size={18} />
                            Create Instagram Post
                          </button>
                          <button
                            onClick={fetchPersonalIgAnalytics}
                            className="px-6 py-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors flex items-center gap-2"
                            data-testid="refresh-ig-analytics-btn"
                          >
                            <RefreshCw size={18} />
                            Refresh
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Quick Actions */}
                  <div className="bg-black border border-gray-400 rounded-xl p-5 mt-6">
                    <h3 className="text-lg font-bold text-white mb-4">Quick Actions</h3>
                    <div className="flex flex-wrap gap-3">
                      <button
                        onClick={() => setActiveTab('posts')}
                        className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm font-medium transition-colors flex items-center gap-2"
                      >
                        <Plus size={16} />
                        Create New Post
                      </button>
                      <button
                        onClick={() => setActiveTab('layout')}
                        className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm font-medium transition-colors flex items-center gap-2"
                      >
                        <Grid size={16} />
                        View Content Grid
                      </button>
                      <a
                        href="https://www.instagram.com/accounts/professional_dashboard/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white text-sm font-medium transition-colors flex items-center gap-2"
                      >
                        <ExternalLink size={16} />
                        Instagram Insights
                      </a>
                    </div>
                  </div>
                </>
              ) : null;
            })()
          )}

          {/* Facebook Analytics Content */}
          {analyticsSource === 'facebook' && facebookStatus?.page?.connected && facebookAnalytics && !analyticsLoading && (
            <>
              {/* No Data Alert */}
              {facebookAnalytics.totalPosts === 0 && (
                <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-4 mb-6 flex items-center gap-4">
                  <div className="p-2 bg-yellow-500/20 rounded-lg">
                    <AlertCircle className="w-6 h-6 text-yellow-500" />
                  </div>
                  <div className="flex-1">
                    <h4 className="text-white font-medium">No posts in this time period</h4>
                    <p className="text-gray-400 text-sm">
                      There are no Facebook posts in the last {analyticsDateRange === '7days' ? '7 days' : analyticsDateRange === '30days' ? '30 days' : '90 days'}. 
                      Try selecting a longer date range to see your analytics.
                    </p>
                  </div>
                  <button
                    onClick={() => setAnalyticsDateRange('year')}
                    className="px-4 py-2 bg-yellow-500/20 hover:bg-yellow-500/30 text-yellow-400 rounded-lg text-sm font-medium transition-colors"
                  >
                    View Year
                  </button>
                </div>
              )}

              {/* Facebook KPI Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                {[
                  { 
                    title: 'Total Posts', 
                    value: facebookAnalytics.totalPosts.toLocaleString(), 
                    subtitle: `in last ${analyticsDateRange === '7days' ? '7 days' : analyticsDateRange === '30days' ? '30 days' : analyticsDateRange === '90days' ? '90 days' : 'year'}`,
                    icon: Grid,
                    color: 'text-blue-400',
                    bgColor: 'bg-blue-500/20'
                  },
                  { 
                    title: 'Total Likes', 
                    value: facebookAnalytics.totalLikes.toLocaleString(), 
                    subtitle: `${facebookAnalytics.totalPosts > 0 ? Math.round(facebookAnalytics.totalLikes / facebookAnalytics.totalPosts) : 0} avg per post`,
                    icon: Heart,
                    color: 'text-red-400',
                    bgColor: 'bg-red-500/20'
                  },
                  { 
                    title: 'Total Comments', 
                    value: facebookAnalytics.totalComments.toLocaleString(), 
                    subtitle: `${facebookAnalytics.totalPosts > 0 ? Math.round(facebookAnalytics.totalComments / facebookAnalytics.totalPosts) : 0} avg per post`,
                    icon: MessageCircle,
                    color: 'text-green-400',
                    bgColor: 'bg-green-500/20'
                  },
                  { 
                    title: 'Total Shares', 
                    value: facebookAnalytics.totalShares.toLocaleString(), 
                    subtitle: `${facebookAnalytics.avgEngagement} avg engagement`,
                    icon: Share2,
                    color: 'text-purple-400',
                    bgColor: 'bg-purple-500/20'
                  },
                ].map((kpi, idx) => {
                  const IconComponent = kpi.icon;
                  return (
                    <div 
                      key={idx}
                      className="bg-black border border-gray-400 rounded-xl p-5 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300"
                    >
                      <div className="flex items-center justify-between mb-4">
                        <span className="text-gray-400 text-sm font-medium">{kpi.title}</span>
                        <div className={`p-2 rounded-lg ${kpi.bgColor}`}>
                          <IconComponent size={18} className={kpi.color} />
                        </div>
                      </div>
                      <div className="text-3xl font-bold text-white mb-1">{kpi.value}</div>
                      <div className="text-xs text-gray-500">{kpi.subtitle}</div>
                    </div>
                  );
                })}
              </div>

              {/* Content Type Breakdown & Engagement Chart */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                {/* Content Type Breakdown */}
                <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
                  <h3 className="text-lg font-bold text-white mb-4">Content Breakdown</h3>
                  <div className="space-y-4">
                    {[
                      { type: 'Posts with Images', count: facebookAnalytics.postsWithImages, icon: ImageIcon, color: 'bg-blue-500' },
                      { type: 'Text Only Posts', count: facebookAnalytics.textOnlyPosts, icon: FileText, color: 'bg-gray-500' },
                    ].map((item, idx) => {
                      const ItemIcon = item.icon;
                      const percentage = facebookAnalytics.totalPosts > 0 
                        ? Math.round((item.count / facebookAnalytics.totalPosts) * 100) 
                        : 0;
                      return (
                        <div key={idx} className="flex items-center gap-4">
                          <div className={`p-2 rounded-lg ${item.color}/20`}>
                            <ItemIcon size={18} className="text-white" />
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center justify-between mb-1">
                              <span className="text-white text-sm">{item.type}</span>
                              <span className="text-gray-400 text-sm">{item.count} ({percentage}%)</span>
                            </div>
                            <div className="h-2 bg-gray-800 rounded-full overflow-hidden">
                              <div 
                                className={`h-full ${item.color} rounded-full transition-all`}
                                style={{ width: `${percentage}%` }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Engagement Over Time */}
                <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
                  <h3 className="text-lg font-bold text-white mb-4">Engagement Over Time</h3>
                  <div className="h-48 flex items-end gap-1">
                    {facebookAnalytics.chartData.slice(-14).map((day, idx) => {
                      const maxEngagement = Math.max(...facebookAnalytics.chartData.map(d => d.engagement), 1);
                      const height = (day.engagement / maxEngagement) * 100;
                      return (
                        <div key={idx} className="flex-1 flex flex-col items-center group">
                          <div 
                            className="w-full bg-gradient-to-t from-blue-500 to-blue-400 rounded-t hover:from-blue-400 hover:to-blue-300 transition-all cursor-pointer relative"
                            style={{ height: `${Math.max(height, 2)}%` }}
                          >
                            <div className="absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 bg-black/90 rounded text-xs text-white whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                              {day.engagement} engagement
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="flex justify-between mt-2 text-xs text-gray-500">
                    <span>{facebookAnalytics.chartData.slice(-14)[0]?.shortDate}</span>
                    <span>{facebookAnalytics.chartData.slice(-1)[0]?.shortDate}</span>
                  </div>
                </div>
              </div>

              {/* Top Performing Posts */}
              <div className="bg-black border border-gray-400 rounded-xl p-5 hover:border-gray-300 hover:shadow-[0_0_20px_rgba(156,163,175,0.3)] transition-all duration-300">
                <h3 className="text-lg font-bold text-white mb-4">Top Performing Posts</h3>
                {facebookAnalytics.topPosts.length > 0 ? (
                  <div className="space-y-4">
                    {facebookAnalytics.topPosts.map((post, idx) => (
                      <div 
                        key={post.id}
                        className="bg-gray-900 rounded-xl p-4 border border-gray-700 hover:border-blue-500 transition-all"
                      >
                        <div className="flex gap-4">
                          <div className="flex items-center justify-center w-8 h-8 bg-blue-500/20 rounded-lg text-blue-400 font-bold text-sm">
                            #{idx + 1}
                          </div>
                          {post.image_url && (
                            <img 
                              src={post.image_url} 
                              alt="Post"
                              className="w-20 h-20 rounded-lg object-cover flex-shrink-0"
                            />
                          )}
                          <div className="flex-1 min-w-0">
                            <p className="text-white text-sm line-clamp-2 mb-2">
                              {post.message || 'No caption'}
                            </p>
                            <div className="flex items-center gap-4 text-xs text-gray-400">
                              <span className="flex items-center gap-1">
                                <Heart size={12} /> {post.likes || 0}
                              </span>
                              <span className="flex items-center gap-1">
                                <MessageCircle size={12} /> {post.comments || 0}
                              </span>
                              <span className="flex items-center gap-1">
                                <Share2 size={12} /> {post.shares || 0}
                              </span>
                              <span>
                                {new Date(post.created_time).toLocaleDateString()}
                              </span>
                            </div>
                          </div>
                          <a 
                            href={post.permalink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-400 hover:text-blue-300 flex-shrink-0"
                          >
                            <ExternalLink size={18} />
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-400 text-center py-8">No posts in selected date range</p>
                )}
              </div>
            </>
          )}

          {/* Facebook Connected but No Analytics Data Yet */}
          {analyticsSource === 'facebook' && facebookStatus?.page?.connected && !facebookAnalytics && !facebookPostsLoading && !analyticsLoading && (
            <div className="bg-black border border-gray-400 rounded-xl p-12 text-center">
              <div className="w-20 h-20 rounded-full bg-blue-600/20 flex items-center justify-center mx-auto mb-4">
                <BarChart3 className="w-10 h-10 text-blue-400" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Loading Analytics...</h3>
              <p className="text-gray-400 mb-4">Fetching data from your Facebook Page</p>
              <button
                onClick={() => { fetchFacebookPosts(); }}
                className="px-6 py-2 bg-blue-500 hover:bg-blue-600 rounded-lg text-white font-medium"
              >
                Refresh Data
              </button>
            </div>
          )}
        </>
      )}

      {/* Media Picker Modal for Post Creation */}
      {showMediaPickerModal && (
        <div 
          className="fixed inset-0 bg-black/90 z-[60] flex items-center justify-center p-4"
          onClick={() => setShowMediaPickerModal(false)}
        >
          <div 
            className="bg-gray-900 rounded-xl max-w-4xl w-full max-h-[80vh] overflow-hidden flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-700">
              <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                <ImageIcon className="w-5 h-5" />
                Select Media
              </h3>
              <button 
                onClick={() => setShowMediaPickerModal(false)}
                className="p-2 hover:bg-gray-800 rounded-full transition-colors"
              >
                <X className="w-5 h-5 text-gray-400" />
              </button>
            </div>

            {/* Content - Media Grid */}
            <div className="flex-1 overflow-auto p-4">
              {mediaLoading ? (
                <div className="flex items-center justify-center py-20">
                  <Loader2 className="w-8 h-8 animate-spin text-cyan-500" />
                  <span className="ml-3 text-gray-400">Loading media...</span>
                </div>
              ) : mediaItems.length === 0 ? (
                <div className="text-center py-20">
                  <ImageIcon className="w-16 h-16 text-gray-600 mx-auto mb-4" />
                  <h3 className="text-xl font-semibold text-white mb-2">No Media Found</h3>
                  <p className="text-gray-400 mb-4">Upload some images or videos to your Media Library first.</p>
                  <button
                    onClick={() => {
                      setShowMediaPickerModal(false);
                      setActiveTab('media');
                    }}
                    className="px-4 py-2 bg-cyan-500 hover:bg-cyan-600 rounded-lg text-white font-medium transition-colors"
                  >
                    Go to Media Library
                  </button>
                </div>
              ) : (
                <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                  {mediaItems.map((item) => (
                    <button
                      key={item._id || item.id}
                      onClick={() => {
                        // Convert relative URL to absolute URL for external services
                        const absoluteUrl = item.url.startsWith('http') 
                          ? item.url 
                          : `${API_URL}${item.url}`;
                        setNewPost({...newPost, image: absoluteUrl, mediaType: item.type || 'image'});
                        setShowMediaPickerModal(false);
                        toast.success('Media added to post');
                      }}
                      className="aspect-square relative rounded-lg overflow-hidden border-2 border-transparent hover:border-cyan-500 transition-all group"
                      data-testid={`media-picker-item-${item._id || item.id}`}
                    >
                      {item.type === 'video' ? (
                        <div className="w-full h-full bg-gray-800 flex items-center justify-center relative">
                          <video 
                            src={item.url}
                            className="w-full h-full object-cover"
                            muted
                            playsInline
                            preload="metadata"
                            poster={item.thumbnail}
                            onLoadedData={(e) => {
                              // Seek to show first frame as thumbnail
                              e.target.currentTime = 0.1;
                            }}
                            onError={(e) => {
                              // Hide broken video, show placeholder
                              e.target.style.display = 'none';
                            }}
                          />
                          {/* Fallback video icon if video doesn't load */}
                          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                            <div className="bg-black/50 rounded-full p-3">
                              <Video size={24} className="text-white" />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <img 
                          src={item.thumbnail || item.url} 
                          alt={item.name || 'Media'}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23666"%3E%3Crect width="24" height="24" fill="%23333"/%3E%3Cpath d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/%3E%3C/svg%3E';
                          }}
                        />
                      )}
                      <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                        <div className="bg-cyan-500 rounded-full p-2">
                          <Plus size={20} className="text-white" />
                        </div>
                      </div>
                      {item.type === 'video' && (
                        <div className="absolute top-2 right-2 bg-black/70 rounded px-1.5 py-0.5 flex items-center gap-1">
                          <Video size={12} className="text-white" />
                          {item.duration && <span className="text-white text-[10px]">{item.duration}</span>}
                        </div>
                      )}
                      {/* Show name label at bottom */}
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-2">
                        <span className="text-white text-xs truncate block">{item.name}</span>
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-gray-700 flex items-center justify-between">
              <button
                onClick={() => {
                  setShowMediaPickerModal(false);
                  setShowMediaUploadModal(true);
                }}
                className="flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-white font-medium transition-colors"
              >
                <Upload size={16} />
                Upload New
              </button>
              <button
                onClick={() => setShowMediaPickerModal(false)}
                className="px-4 py-2 text-gray-400 hover:text-white transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Post Create/Edit Modal - Comprehensive Post Editor */}
      {showPostModal && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center p-4 z-50" onClick={() => setShowPostModal(false)}>
          <div 
            className={`bg-black border border-gray-500 rounded-xl relative transition-all duration-300 shadow-[0_0_20px_rgba(255,255,255,0.08)] hover:shadow-[0_0_40px_rgba(255,255,255,0.15)] hover:border-gray-400 ${
              postEditorExpanded ? 'w-full h-full max-w-none' : 'w-full max-w-6xl max-h-[90vh]'
            } overflow-hidden flex flex-col`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Main Content Area */}
            <div className="flex flex-1 overflow-hidden">
              
              {/* Left Sidebar - Platform Selection */}
              <div className="w-16 bg-black border-r border-gray-700 flex flex-col items-center py-4 gap-3 overflow-y-auto">
                {[
                  { id: 'instagram', icon: InstagramIcon, color: 'text-pink-500', bgActive: 'bg-pink-500/20' },
                  { id: 'youtube', icon: YouTubeIcon, color: 'text-red-500', bgActive: 'bg-red-500/20' },
                  { id: 'x', icon: XTwitterIcon, color: 'text-white', bgActive: 'bg-white/20' },
                  { id: 'facebook', icon: FacebookIcon, color: 'text-blue-500', bgActive: 'bg-blue-500/20' },
                  { id: 'linkedin', icon: LinkedInIcon, color: 'text-blue-600', bgActive: 'bg-blue-600/20' },
                  { id: 'tiktok', icon: TikTokIcon, color: 'text-white', bgActive: 'bg-white/20' },
                  { id: 'threads', icon: ThreadsIcon, color: 'text-white', bgActive: 'bg-white/20' },
                  { id: 'pinterest', icon: PinterestIcon, color: 'text-red-600', bgActive: 'bg-red-600/20' },
                  { id: 'bluesky', icon: BlueskyIcon, color: 'text-blue-400', bgActive: 'bg-blue-400/20' },
                ].map((platform) => {
                  const IconComponent = platform.icon;
                  const isSelected = (newPost.selectedPlatforms || []).includes(platform.id);
                  // Check if connected via Upload-Post
                  const isUploadPostConnected = uploadPostAccounts.some(acc => acc.platform === platform.id);
                  // Check direct connections
                  const isDirectConnected = (platform.id === 'instagram' && instagramStatus?.connected) ||
                                           (platform.id === 'facebook' && facebookStatus?.page?.connected);
                  const isConnected = isUploadPostConnected || isDirectConnected;
                  
                  return (
                    <div key={platform.id} className="relative">
                      <button
                        onClick={() => togglePostPlatform(platform.id)}
                        disabled={!isConnected}
                        className={`p-2 rounded-lg transition-all duration-200 ${
                          !isConnected
                            ? 'text-gray-700 cursor-not-allowed opacity-50'
                            : isSelected
                              ? `${platform.color} ${platform.bgActive} border border-gray-500 shadow-[0_0_10px_rgba(255,255,255,0.1)]`
                              : 'text-gray-600 hover:text-gray-400 hover:bg-gray-800'
                        }`}
                        title={`${platform.id}${isConnected ? ' (Connected)' : ' (Not Connected)'}`}
                      >
                        <IconComponent />
                      </button>
                      {/* Connected indicator */}
                      {isConnected && (
                        <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-black" />
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Main Editor Area */}
              <div className="flex-1 flex flex-col overflow-hidden">
                {/* Editor Header */}
                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-700">
                  <div className="flex items-center gap-3">
                    <button 
                      onClick={() => {
                        setNewPost({...newPost, title: '', description: '', hashtags: '', image: null, mediaType: null});
                      }}
                      className="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-400 hover:text-white bg-gray-800 hover:bg-gray-700 rounded-lg border border-gray-600 transition-all"
                    >
                      <X size={14} />
                      Clear
                    </button>
                    <button 
                      className="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-400 hover:text-white bg-gray-800 hover:bg-gray-700 rounded-lg border border-gray-600 transition-all"
                    >
                      <Hash size={14} />
                      Add labels
                    </button>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => setPostEditorExpanded(!postEditorExpanded)}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors"
                    >
                      {postEditorExpanded ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
                    </button>
                    <button 
                      onClick={() => setShowPostModal(false)}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors"
                    >
                      <X size={18} />
                    </button>
                  </div>
                </div>

                {/* Editor Content */}
                <div className="flex-1 overflow-y-auto p-4">
                  {/* Title Input */}
                  <input
                    type="text"
                    value={newPost.title}
                    onChange={(e) => setNewPost({...newPost, title: e.target.value})}
                    placeholder="Enter your headline..."
                    className="w-full text-xl font-semibold bg-transparent text-white placeholder-gray-500 focus:outline-none mb-4 border-b border-transparent hover:border-gray-700 focus:border-gray-500 pb-2 transition-colors"
                  />

                  {/* Description Textarea */}
                  <textarea
                    value={newPost.description}
                    onChange={(e) => setNewPost({...newPost, description: e.target.value})}
                    placeholder="Write your post content here. Share your story, insights, or message with your audience..."
                    rows={6}
                    className="w-full bg-transparent text-white placeholder-gray-500 focus:outline-none resize-none leading-relaxed"
                  />

                  {/* Hashtags Input */}
                  <div className="mt-4">
                    <input
                      type="text"
                      value={newPost.hashtags}
                      onChange={(e) => setNewPost({...newPost, hashtags: e.target.value})}
                      placeholder="#Hashtag1 #Hashtag2 #Hashtag3"
                      className="w-full bg-transparent text-cyan-400 placeholder-gray-600 focus:outline-none text-sm"
                    />
                  </div>

                  {/* Text Formatting Toolbar */}
                  <div className="flex items-center gap-2 mt-4 pb-4 border-b border-gray-700">
                    <button 
                      onClick={() => {
                        const hashtags = newPost.hashtags || '';
                        if (!hashtags.includes('#')) {
                          setNewPost({...newPost, hashtags: '# '});
                        }
                        // Focus would go to hashtag input - toast feedback instead
                        toast.info('Add hashtags in the field above');
                      }}
                      className="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-400 hover:text-white bg-gray-800 hover:bg-gray-700 rounded-lg border border-gray-600 transition-all"
                      data-testid="hashtag-toolbar-btn"
                    >
                      <Hash size={14} />
                      Hashtags
                    </button>
                    <div className="relative group">
                      <button 
                        onClick={() => {
                          if (newPost.description) {
                            improveAICaption();
                          } else {
                            generateAICaption();
                          }
                        }}
                        disabled={aiAssistLoading}
                        className={`flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg border transition-all ${
                          aiAssistLoading 
                            ? 'bg-purple-500/20 text-purple-300 border-purple-500/50 cursor-wait' 
                            : 'text-gray-400 hover:text-white bg-gray-800 hover:bg-purple-500/20 hover:border-purple-500/50 border-gray-600'
                        }`}
                        data-testid="ai-assist-toolbar-btn"
                      >
                        {aiAssistLoading ? (
                          <Loader2 size={14} className="animate-spin" />
                        ) : (
                          <Sparkles size={14} />
                        )}
                        {aiAssistLoading ? 'Generating...' : 'AI Assist'}
                      </button>
                      {/* Dropdown tooltip */}
                      <div className="absolute left-0 top-full mt-1 w-48 bg-gray-900 border border-gray-700 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                        <div className="p-2 space-y-1">
                          <button
                            onClick={(e) => { e.stopPropagation(); generateAICaption(); }}
                            disabled={aiAssistLoading}
                            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:bg-gray-800 rounded-lg transition-colors text-left"
                          >
                            <Sparkles size={14} className="text-purple-400" />
                            Generate Caption
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); improveAICaption(); }}
                            disabled={aiAssistLoading || !newPost.description}
                            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:bg-gray-800 rounded-lg transition-colors text-left disabled:opacity-50"
                          >
                            <Edit3 size={14} className="text-cyan-400" />
                            Improve Caption
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="flex-1" />
                    <span className="text-xs text-gray-500 mr-2">{newPost.description?.length || 0}</span>
                    <button 
                      onClick={() => {
                        const textarea = document.querySelector('textarea');
                        if (textarea) {
                          const start = textarea.selectionStart;
                          const end = textarea.selectionEnd;
                          const text = newPost.description || '';
                          const selectedText = text.substring(start, end);
                          if (selectedText) {
                            const newText = text.substring(0, start) + '**' + selectedText + '**' + text.substring(end);
                            setNewPost({...newPost, description: newText});
                          } else {
                            toast.info('Select text to make it bold');
                          }
                        }
                      }}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded transition-colors"
                      title="Bold (select text first)"
                      data-testid="bold-toolbar-btn"
                    >
                      <Bold size={16} />
                    </button>
                    <button 
                      onClick={() => {
                        const textarea = document.querySelector('textarea');
                        if (textarea) {
                          const start = textarea.selectionStart;
                          const end = textarea.selectionEnd;
                          const text = newPost.description || '';
                          const selectedText = text.substring(start, end);
                          if (selectedText) {
                            const newText = text.substring(0, start) + '_' + selectedText + '_' + text.substring(end);
                            setNewPost({...newPost, description: newText});
                          } else {
                            toast.info('Select text to make it italic');
                          }
                        }
                      }}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded transition-colors"
                      title="Italic (select text first)"
                      data-testid="italic-toolbar-btn"
                    >
                      <Italic size={16} />
                    </button>
                    <button 
                      onClick={() => {
                        // Common emojis for quick insert
                        const emojis = ['😀', '🎉', '🔥', '💯', '✨', '❤️', '👏', '🚀', '💪', '🙌'];
                        const randomEmoji = emojis[Math.floor(Math.random() * emojis.length)];
                        setNewPost({...newPost, description: (newPost.description || '') + ' ' + randomEmoji});
                        toast.success(`Added ${randomEmoji}`);
                      }}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded transition-colors"
                      title="Add emoji"
                      data-testid="emoji-toolbar-btn"
                    >
                      <Smile size={16} />
                    </button>
                  </div>

                  {/* Media Upload Area */}
                  <div className="mt-4">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-sm text-gray-400">Media</span>
                      {newPost.mediaType === 'video' && (
                        <span className="text-xs text-cyan-400 flex items-center gap-1"><Video size={12} /> Video Selected</span>
                      )}
                      {(newPost.selectedPlatforms || []).includes('youtube') && newPost.mediaType !== 'video' && (
                        <span className="text-xs text-red-400">(YouTube requires VIDEO)</span>
                      )}
                      {(newPost.selectedPlatforms || []).some(p => !['x', 'twitter', 'youtube'].includes(p)) && !newPost.image && (
                        <span className="text-xs text-orange-400">(Required for Instagram)</span>
                      )}
                      {(newPost.selectedPlatforms || []).every(p => ['x', 'twitter'].includes(p)) && (
                        <span className="text-xs text-gray-500">(Optional for Twitter/X)</span>
                      )}
                    </div>
                    <div className="flex gap-3">
                      {newPost.image ? (
                        <div className="relative w-32 h-32 rounded-lg overflow-hidden border border-gray-600 group">
                          {newPost.mediaType === 'video' ? (
                            <div className="w-full h-full bg-gray-800 flex items-center justify-center">
                              <video 
                                src={newPost.image} 
                                className="w-full h-full object-cover"
                                muted
                                playsInline
                              />
                              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                <div className="bg-black/60 rounded-full p-2">
                                  <Video size={20} className="text-white" />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <img 
                              src={newPost.image} 
                              alt="Post media"
                              className="w-full h-full object-cover"
                            />
                          )}
                          <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
                            <button 
                              onClick={() => setNewPost({...newPost, image: null, mediaType: null})}
                              className="p-2 bg-red-500/80 rounded-full text-white hover:bg-red-500 transition-colors"
                            >
                              <X size={16} />
                            </button>
                          </div>
                        </div>
                      ) : null}
                      <button 
                        onClick={() => setShowMediaPickerModal(true)}
                        className="w-32 h-32 border-2 border-dashed border-gray-600 rounded-lg flex flex-col items-center justify-center gap-2 text-gray-500 hover:text-gray-300 hover:border-gray-500 hover:bg-gray-800/30 transition-all"
                        data-testid="add-media-btn"
                      >
                        <Plus size={24} />
                        <span className="text-xs">Add Media</span>
                      </button>
                    </div>
                  </div>

                  {/* Schedule Date/Time */}
                  <div className="mt-6 p-4 bg-gray-800/50 rounded-xl border border-gray-700">
                    <label className="block text-sm font-medium text-white mb-3 flex items-center gap-2">
                      <Clock size={16} className="text-cyan-400" />
                      Schedule Post
                    </label>
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs text-gray-400 mb-1">Date</label>
                        <input
                          type="date"
                          value={newPost.date}
                          onChange={(e) => setNewPost({...newPost, date: e.target.value})}
                          className="w-full bg-black border border-gray-600 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-cyan-500"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-400 mb-1">Time</label>
                        <input
                          type="time"
                          value={newPost.time}
                          onChange={(e) => setNewPost({...newPost, time: e.target.value})}
                          className="w-full bg-black border border-gray-600 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-cyan-500"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Bottom Icon Toolbar */}
                  <div className="flex items-center gap-2 mt-4 py-4 border-t border-gray-700">
                    <button 
                      onClick={() => {
                        // Focus on the description textarea
                        const textarea = document.querySelector('textarea');
                        if (textarea) {
                          textarea.focus();
                          toast.info('Start typing your caption below');
                        }
                      }}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors" 
                      title="Add caption"
                      data-testid="caption-icon-btn"
                    >
                      <FileText size={18} />
                    </button>
                    <button 
                      onClick={() => {
                        const location = prompt('Enter location (e.g., "New York, NY")');
                        if (location) {
                          setNewPost({...newPost, location: location});
                          toast.success(`Location set: ${location}`);
                        }
                      }}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors" 
                      title="Add location"
                      data-testid="location-icon-btn"
                    >
                      <MapPin size={18} />
                    </button>
                    <div className="w-px h-6 bg-gray-700 mx-1" />
                    <button 
                      onClick={() => setShowMediaPickerModal(true)}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors" 
                      title="Add image"
                      data-testid="image-icon-btn"
                    >
                      <ImageIcon size={18} />
                    </button>
                    <button 
                      onClick={() => {
                        if (selectedPost) {
                          // Already editing a post
                          toast.info('You are already editing this post');
                        } else if (newPost.title || newPost.description) {
                          toast.info('Continue editing your post above');
                        } else {
                          // Focus on title input
                          const titleInput = document.querySelector('input[type="text"]');
                          if (titleInput) {
                            titleInput.focus();
                            toast.info('Start editing your post');
                          }
                        }
                      }}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors" 
                      title="Edit"
                      data-testid="edit-icon-btn"
                    >
                      <Pencil size={18} />
                    </button>
                    <div className="w-px h-6 bg-gray-700 mx-1" />
                    <button 
                      onClick={() => {
                        // Add first comment/note
                        const comment = prompt('Add a note or first comment for this post:');
                        if (comment) {
                          setNewPost({...newPost, firstComment: comment});
                          toast.success('First comment saved - will be posted after your content');
                        }
                      }}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors" 
                      title="Add first comment"
                      data-testid="comment-icon-btn"
                    >
                      <MessageCircle size={18} />
                    </button>
                    <button 
                      onClick={async () => {
                        // Copy post content to clipboard
                        const content = `${newPost.title || ''}\n\n${newPost.description || ''}\n\n${newPost.hashtags || ''}`.trim();
                        if (content) {
                          try {
                            await navigator.clipboard.writeText(content);
                            toast.success('Post content copied to clipboard!');
                          } catch (err) {
                            // Fallback for environments without clipboard access
                            toast.info('Content ready to copy - use Ctrl+C to copy');
                          }
                        } else {
                          toast.info('No content to copy yet');
                        }
                      }}
                      className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors" 
                      title="Copy to clipboard"
                      data-testid="share-icon-btn"
                    >
                      <Share2 size={18} />
                    </button>
                    <button 
                      onClick={() => {
                        if (newPost.title || newPost.description || newPost.image) {
                          if (confirm('Are you sure you want to clear all content?')) {
                            setNewPost({
                              title: '',
                              description: '',
                              hashtags: '',
                              image: null,
                              mediaType: null,
                              date: new Date().toISOString().split('T')[0],
                              time: '09:00',
                              status: 'draft',
                              category: categories[0]?.name || 'General',
                              selectedPlatforms: ['instagram'],
                              location: '',
                              firstComment: ''
                            });
                            toast.success('Content cleared');
                          }
                        } else {
                          toast.info('Nothing to clear');
                        }
                      }}
                      className="p-2 text-gray-400 hover:text-red-400 hover:bg-gray-700 rounded-lg transition-colors" 
                      title="Clear content"
                      data-testid="delete-icon-btn"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                </div>

                {/* Bottom Action Bar */}
                <div className="flex items-center justify-between px-4 py-3 border-t border-gray-700 bg-gray-900/50">
                  <button className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors">
                    <Users size={16} />
                    Bulk Options
                  </button>
                  <div className="flex items-center gap-3">
                    {postModalMode === 'edit' && (
                      <button
                        onClick={() => deletePost(selectedPost.id)}
                        className="px-4 py-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-lg border border-red-500/30 transition-colors flex items-center gap-2"
                        data-testid="delete-post-btn"
                      >
                        <Trash2 size={16} />
                        Delete
                      </button>
                    )}
                    <button
                      onClick={() => setShowPostModal(false)}
                      className="px-4 py-2 text-gray-300 bg-gray-800 hover:bg-gray-700 rounded-lg border border-gray-600 transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={async () => {
                        // Save as draft - persist to backend
                        const draftPost = { ...newPost, status: 'draft' };
                        try {
                          const postData = {
                            title: draftPost.title,
                            description: draftPost.description || '',
                            platform: draftPost.platform,
                            selectedPlatforms: draftPost.selectedPlatforms || [draftPost.platform],
                            date: draftPost.date || new Date().toISOString().split('T')[0],
                            time: draftPost.time || '09:00',
                            status: 'draft',
                            category: draftPost.category || 'uncategorized',
                            image: draftPost.image || null,
                            hashtags: draftPost.hashtags || '',
                          };

                          if (postModalMode === 'create') {
                            const response = await fetch(`${API_URL}/api/content-posts`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify(postData)
                            });
                            if (response.ok) {
                              const savedPost = await response.json();
                              setPosts([...posts, savedPost]);
                            }
                          } else {
                            const response = await fetch(`${API_URL}/api/content-posts/${selectedPost.id}`, {
                              method: 'PUT',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify(postData)
                            });
                            if (response.ok) {
                              const updatedPost = await response.json();
                              setPosts(posts.map(p => p.id === selectedPost.id ? updatedPost : p));
                            }
                          }
                          setShowPostModal(false);
                          toast.success('Post saved as draft');
                        } catch (error) {
                          console.error('Error saving draft:', error);
                          toast.error('Failed to save draft');
                        }
                      }}
                      disabled={!newPost.title.trim() && !newPost.description.trim()}
                      className="px-4 py-2 text-gray-300 bg-gray-800 hover:bg-gray-700 rounded-lg border border-gray-600 transition-colors disabled:opacity-50"
                    >
                      Save Draft
                    </button>
                    <button
                      onClick={() => {
                        if (!newPost.date) {
                          toast.error('Please select a date to schedule');
                          return;
                        }
                        savePost(false);
                      }}
                      disabled={(!newPost.title.trim() && !newPost.description.trim()) || !newPost.date}
                      className="flex items-center gap-2 px-5 py-2 text-black bg-gradient-to-r from-cyan-400 to-emerald-400 hover:from-cyan-300 hover:to-emerald-300 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <Calendar size={16} />
                      Schedule Post
                    </button>
                    {/* Publish Now button - shows when any connected platform is selected */}
                    {(newPost.selectedPlatforms || []).some(p => 
                      uploadPostAccounts.some(acc => acc.platform === p) ||
                      (p === 'instagram' && instagramStatus?.connected) ||
                      (p === 'facebook' && facebookStatus?.page?.connected)
                    ) && (
                      <button
                        data-testid="publish-now-btn"
                        onClick={async () => {
                          if (!newPost.title.trim() && !newPost.description.trim()) {
                            toast.error('Please add content to publish');
                            return;
                          }
                          await savePost(true);
                        }}
                        disabled={!newPost.title.trim() && !newPost.description.trim()}
                        className="flex items-center gap-2 px-5 py-2 text-white bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-400 hover:to-emerald-400 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <Send size={16} />
                        Publish Now
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Right Preview Panel */}
              <div className="w-80 bg-gray-900/50 border-l border-gray-700 flex flex-col overflow-hidden">
                {/* Preview Header */}
                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-700">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-300">Post Preview</span>
                    <Info size={14} className="text-gray-500" />
                  </div>
                  <div className="flex items-center gap-2">
                    <select className="bg-gray-800 border border-gray-600 rounded px-2 py-1 text-xs text-gray-300">
                      <option>All</option>
                      {platforms.map(p => (
                        <option key={p.id} value={p.id}>{p.name}</option>
                      ))}
                    </select>
                    <button className="p-1 text-gray-400 hover:text-white">
                      <Grid size={14} />
                    </button>
                    <button className="p-1 text-gray-400 hover:text-white">
                      <List size={14} />
                    </button>
                  </div>
                </div>

                {/* Preview Content */}
                <div className="flex-1 overflow-y-auto p-4">
                  {/* Preview Post */}
                  <div className="bg-black border border-gray-600 rounded-xl p-4 hover:border-gray-400 shadow-[0_0_10px_rgba(255,255,255,0.05)] hover:shadow-[0_0_25px_rgba(255,255,255,0.1)] transition-all duration-300">
                    <p className="text-white mb-2">
                      {newPost.title || 'Your headline will appear here'}
                    </p>
                    <p className="text-gray-400 text-sm mb-3 line-clamp-3">
                      {newPost.description || 'Your post content will be previewed here...'}
                    </p>
                    {newPost.hashtags && (
                      <p className="text-cyan-400 text-sm mb-3">
                        {newPost.hashtags}
                      </p>
                    )}
                    {newPost.image && (
                      <div className="rounded-lg overflow-hidden mb-3 relative">
                        {newPost.mediaType === 'video' ? (
                          <>
                            <video 
                              src={newPost.image} 
                              className="w-full h-40 object-cover"
                              muted
                              playsInline
                            />
                            <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                              <div className="bg-black/60 rounded-full p-3">
                                <Play size={24} className="text-white fill-white" />
                              </div>
                            </div>
                            <div className="absolute bottom-2 left-2 px-2 py-1 bg-black/70 rounded text-xs text-white flex items-center gap-1">
                              <Video size={12} />
                              Video
                            </div>
                          </>
                        ) : (
                          <img 
                            src={newPost.image} 
                            alt="Preview"
                            className="w-full h-40 object-cover"
                          />
                        )}
                      </div>
                    )}
                    
                    {/* Engagement Preview */}
                    <div className="flex items-center gap-4 pt-3 border-t border-gray-700 text-gray-500 text-xs">
                      <span className="flex items-center gap-1">
                        <Heart size={14} /> 0
                      </span>
                      <span className="flex items-center gap-1">
                        <MessageCircle size={14} /> 0
                      </span>
                      <span className="flex items-center gap-1">
                        <Share2 size={14} /> 0
                      </span>
                    </div>
                  </div>

                  {/* Schedule Info */}
                  <div className="mt-4 p-3 bg-gray-800/50 rounded-lg border border-gray-700">
                    <div className="flex items-center gap-2 text-sm text-gray-400 mb-2">
                      <Calendar size={14} />
                      <span>Scheduled for</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <input
                        type="date"
                        value={newPost.date}
                        onChange={(e) => setNewPost({...newPost, date: e.target.value})}
                        className="flex-1 bg-black border border-gray-600 rounded px-2 py-1.5 text-sm text-white focus:outline-none focus:border-gray-400"
                      />
                      <input
                        type="time"
                        value={newPost.time}
                        onChange={(e) => setNewPost({...newPost, time: e.target.value})}
                        className="w-24 bg-black border border-gray-600 rounded px-2 py-1.5 text-sm text-white focus:outline-none focus:border-gray-400"
                      />
                    </div>
                  </div>

                  {/* Category Selection */}
                  <div className="mt-4">
                    <label className="text-xs text-gray-500 mb-2 block">Category</label>
                    <div className="flex flex-wrap gap-2">
                      {categories.map((cat) => (
                        <button
                          key={cat.id}
                          onClick={() => setNewPost({...newPost, category: cat.id})}
                          className={`px-3 py-1 rounded-full text-xs transition-all ${
                            newPost.category === cat.id
                              ? `${cat.color} text-white`
                              : 'bg-gray-800 text-gray-400 hover:bg-gray-700 border border-gray-600'
                          }`}
                        >
                          {cat.name}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Selected Platforms */}
                  <div className="mt-4">
                    <label className="text-xs text-gray-500 mb-2 block">Posting to</label>
                    <div className="flex flex-wrap gap-2">
                      {(newPost.selectedPlatforms || []).map((platformId) => {
                        const platform = platforms.find(p => p.id === platformId) || 
                          [
                            { id: 'bluesky', name: 'Bluesky', color: 'text-blue-400' },
                            { id: 'medium', name: 'Medium', color: 'text-white' },
                            { id: 'telegram', name: 'Telegram', color: 'text-blue-400' },
                          ].find(p => p.id === platformId);
                        return platform ? (
                          <span key={platformId} className={`flex items-center gap-1 px-2 py-1 rounded bg-gray-800 text-xs ${platform.color}`}>
                            {platform.name}
                          </span>
                        ) : null;
                      })}
                      {(newPost.selectedPlatforms || []).length === 0 && (
                        <span className="text-xs text-gray-500">No platforms selected</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Disconnect Account Confirmation Modal */}
      {showDisconnectModal && accountToDisconnect && (
        <div 
          className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={() => setShowDisconnectModal(false)}
        >
          <div 
            className="bg-gray-900 border border-gray-700 rounded-xl w-full max-w-md p-6"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Warning Icon */}
            <div className="flex items-center justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center">
                <AlertCircle size={32} className="text-red-400" />
              </div>
            </div>

            {/* Title */}
            <h3 className="text-xl font-bold text-white text-center mb-2">
              Disconnect {accountToDisconnect.platform === 'x' ? 'X' : accountToDisconnect.platform.charAt(0).toUpperCase() + accountToDisconnect.platform.slice(1)}?
            </h3>

            {/* Account Info */}
            <div className="bg-gray-800 rounded-lg p-4 mb-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gray-700 flex items-center justify-center">
                  {accountToDisconnect.platform === 'instagram' && <div className="w-5 h-5 text-pink-500"><InstagramIcon /></div>}
                  {accountToDisconnect.platform === 'youtube' && <div className="w-5 h-5 text-red-500"><YouTubeIcon /></div>}
                  {accountToDisconnect.platform === 'x' && <div className="w-5 h-5"><XTwitterIcon /></div>}
                  {accountToDisconnect.platform === 'tiktok' && <div className="w-5 h-5"><TikTokIcon /></div>}
                  {accountToDisconnect.platform === 'linkedin' && <div className="w-5 h-5 text-blue-500"><LinkedInIcon /></div>}
                  {accountToDisconnect.platform === 'facebook' && <div className="w-5 h-5 text-blue-500"><FacebookIcon /></div>}
                  {!['instagram', 'youtube', 'x', 'tiktok', 'linkedin', 'facebook'].includes(accountToDisconnect.platform) && (
                    <User className="w-5 h-5 text-gray-400" />
                  )}
                </div>
                <div>
                  <p className="text-white font-medium">@{accountToDisconnect.name || accountToDisconnect.username}</p>
                  <p className="text-xs text-gray-400 capitalize">{accountToDisconnect.source === 'upload-post' ? 'via Upload-Post' : accountToDisconnect.source}</p>
                </div>
              </div>
            </div>

            {/* Warning Text */}
            <p className="text-gray-400 text-sm text-center mb-6">
              {accountToDisconnect.source === 'upload-post' ? (
                <>This will remove the account from your dashboard. To fully disconnect, you'll need to manage your accounts in the Upload-Post dashboard.</>
              ) : (
                <>This will disconnect your account. You can reconnect at any time.</>
              )}
            </p>

            {/* Action Buttons */}
            <div className="flex gap-3">
              <button
                onClick={() => {
                  setShowDisconnectModal(false);
                  setAccountToDisconnect(null);
                }}
                className="flex-1 px-4 py-3 bg-gray-800 hover:bg-gray-700 text-white rounded-lg font-medium transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleDisconnectAccount}
                disabled={!!disconnectingAccount}
                className="flex-1 px-4 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
                data-testid="confirm-disconnect-btn"
              >
                {disconnectingAccount ? (
                  <Loader2 size={18} className="animate-spin" />
                ) : (
                  <X size={18} />
                )}
                Disconnect
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialMedia;
